import { createBrowserHistory } from 'history'
import html2canvas from 'html2canvas'
import $ from 'jquery'
import React, { Component } from 'react'
import Sidebar from './sidebar'
import { withRouter } from 'react-router-dom'
import { HTML5Backend } from 'react-dnd-html5-backend-old'
import { TouchBackend } from 'react-dnd-touch-backend'
import Modal from 'react-modal'
import { DragDropContext } from 'react-dnd-old'
import WorkSpace from './workspace'
import { connect } from 'react-redux'
import '../../css/assembly.css'
import '../../css/pure-grids.min.css'
import Sizes from '../../helpers/Sizes'
import { webSerialConnect } from '../../redux/actions/index'
import renderPrgImage from '../../source/programImg'
import unicodeToChar from '../../utils/unicodeToChar'
import AssemblyPrgm from '../ReusableComponents/PrgmSlider/AssemblyPrgm/AssemblyPrgm'
import { activeCheckBox } from '../Assembly/CheckboxData'
import CustomDragLayer from './CustomDragLayer'
import * as atatus from 'atatus-spa'
import './index.css'
import {
    continousPABytesReadToggle_v1,
    sendBytes,
    readBytesPa,
    continousPABytesReadToggle,
    humanoidPABytesToSensorData,
    HUMANOID_PA_SEND_BYTES,
} from '../ReusableComponents/ByteTransfer'
import {
    playComputerPABytesToSensorData,
    robokiPABytesToSensorData,
    hexapodPABytesToSensorData,
    klawPABytesToSensorData,
    pokiPABytesToSensorData,
} from '../ReusableComponents/ByteTransfer/utils'

import renderImage from '../../source/importImg'
import removeSensorProgramData from '../../utils/removeSensorProgramData'
import removeHumanoidLocalProgramData from '../../utils/removeHumanoidLocalProgramData'
import {
    HEXAPOD_PA_SEND_BYTES,
    HUMANOID_V1_PA_SEND_BYTES,
    KLAW_PA_SEND_BYTES,
} from '../ReusableComponents/ByteTransfer/byteCodes'
import AiModeSelect from './AiModeSelect/AiModeSelect'
import { defaultAssemblyPageAi } from '../../source/assemblyPageAiData'
import { PORTDATA, generateDeviceDataKey } from '../Humanoid/defaultData'
import { getHederTextArr } from '../../utils/langaugeSupport'
import DialogModal from '../ReusableComponents/DialogModal/DialogModal'
import { isAi1NotPresent, isAi1ShowCondition } from '../../utils/utils'
import fetchAssemblyAccessories, {
    processAssemblyAccessoriesFromData,
} from './assemblyAccessoriesApi'
import Ports from './PortData'
import {
    HardwareWireConfigs,
    getHardwareWireConfig,
    computeAutoDropPinConnections,
    getWholeSocketParent,
} from '../Assembly/PinMaps'
import { getPortGroup } from './PortGroups'
import { fetchAssemblySteps, normalizeSteps } from './assemblyStepsApi'
import AssemblyStepsSlideshow from './AssemblyStepsSlideshow'
import ProgramHeaderTwo from '../ReusableComponents/Header/ProgramHeaderTwo'
import {
    MdOutlineArrowBack,
    MdOutlineViewInAr,
    MdFullscreen,
    MdClosedCaption,
    MdClose,
    MdLock,
    MdInfoOutline,
} from 'react-icons/md'
import { BsStars } from 'react-icons/bs'
import MakeHeader from '../ReusableComponents/Header/MakeHeader'
import MakeContext from '../Make/MakeContext'
import { GrPrevious, GrNext } from 'react-icons/gr'
import { RxReset } from 'react-icons/rx'
import ContentEngine from '../ContentEngine/ContentEngine'

var zooming
var oldDeltaX, oldDeltaY, panning
const history = createBrowserHistory()

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        height: ' 40%',
        width: ' 50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        zIndex: 1000000,
        transform: 'translate(-50%, -50%)',
    },
}
var nextVisbilityButton
var reader
let goBack = false
const connectedDevice = sessionStorage.getItem('connectedDevice')
class AssemblyTwo extends Component {
    static contextType = MakeContext
    constructor(props) {
        super(props)

        this.audioRef = React.createRef()
        this.appContainerRef = React.createRef()
        this.subtitleRef = React.createRef()
        this.typewriterInterval = null
        // Tracks IMU / Color sensor connection state so the Poki PA-bytes
        // receiver can decode the incoming stream correctly (mirrors Assembly).
        this.connectStatusRef = React.createRef()
        this.connectStatusRef.current = {
            isIMUConnect: false,
            isColor_sensorConnect: false,
        }
        // var props1 = props;
        var selectionType = localStorage.getItem('programMode')
        if (selectionType === 'learn') {
            nextVisbilityButton = 'hidden'
        } else {
            nextVisbilityButton = 'visible'
        }
        Modal.setAppElement('body')
        // this.continuesPAstop = this.continuesPAstop.bind(this)
        this.state = {
            // Gates the board render until the target step's workspace is built.
            // Prevents the previous-visit's assembly from flashing for ~1s when
            // navigating back into this screen (Redux still holds the old
            // workspace until the async step load rebuilds it). Make/tutorial
            // mode only; standalone use is unaffected (see render).
            stepsReady: false,
            activeRgbComponentType: null, // will be 'led', 'rgb_led', or 'servo_motor'
            rgbMagnifierOpen: false,
            activeRgbWire: null, // pin currently being routed: '+', '-', 'S1', ...
            activeRgbComponent: null, // { type, index } the active wire belongs to
            mouseX: 0,
            mouseY: 0,
            // Legacy single-component map (kept for backward-compat; the live source
            // of truth is now `pinConnections` stored on each component instance).
            rgbIndividualConnections: { '+': null, '-': null, S1: null },
            aiVoiceover: sessionStorage.getItem('aiVoiceToggle') !== 'false',
            currentStep: 1,
            assemblySteps: null,
            subtitleVisible: false,
            showSubtitleDisplay: false,
            // Inline tutorial notice shown near the footer ({ text, tone } or null).
            // tone: 'warning' (wrong sidebar component) | 'locked' (completed step).
            tutorialMessage: null,
            typewriterText: '',
            aiSpeaking: true,
            slideDirection: sessionStorage.getItem('slideDirection'),
            isReading: false,
            huBattery: 0,
            huUltrasonic: 0,
            huAccelerometerX: 0,
            huAccelerometerY: 0,
            huAccelerometerZ: 0,
            huGyroX: 0,
            huGyroY: 0,
            huGyroZ: 0,

            huSred1: 0,
            huSred2: 0,
            huSred3: 0,
            huSred4: 0,
            huSred5: 0,
            huSred6: 0,
            huSred7: 0,
            huSred8: 0,
            huSred9: 0,
            huSred10: 0,
            huSred11: 0,
            huSred12: 0,
            huSred13: 0,
            huSred14: 0,
            huSred15: 0,
            huSred16: 0,
            huSred17: 0,
            huSred18: 0,

            height: 0,
            width: 0,
            readbytes: false,
            modalIsOpen: false,
            props1: props,
            detected: false,
            usbOpen: false,
            isusb: false,
            isHelp: false,
            visible: nextVisbilityButton,
            isClickFourInOneSensor: false,
            isClickTempratureSensor: false,
            isPcActive: false,
            aiModelPopUpState: {
                message: '',
                showPopup: false,
            },
            p1: {
                selected: false,
                port: {},
            },
            refresh: false,
            reConnecting: false,
            flag: false,
            flagUpdated: false,
            k: false,
            keepReading: true,
            responceTp0: '',
            responceTp1: '',
            responceTp2: '',
            touch_pad: '',
            touch_pad2: '',
            rangeA1: '',
            rangeA2: '',
            rangeB1: '',
            rangeB2: '',
            rangeC1: '',
            rangeC2: '',
            rangeD1: '',
            rangeD2: '',
            rangeE1: '',
            rangeE2: '',
            rangeF1: '',
            rangeF2: '',
            rangeG1: '',
            rangeG2: '',
            rangeservo_motor1: '',
            rangeservo_motor2: '',
            tactswitch: '',
            mic: '',
            temprature: '',
            accelerometer_X: '',
            accelerometer_Y: '',
            accelerometer_Z: '',
            gyro_X: '',
            gyro_Y: '',
            gyro_Z: '',
            battery: '',
            temp: '',
            gas: '',
            zero: '',
            one: '',
            two: '',
            red: '',
            green: '',
            blue: '',
            light: '',
            gesture: '',
            distance: '',
            switch1: '',
            switch2: '',
            ir: '',
            shield: false,
            armShield: false,
            peeCeeATR: false,
            setIntervalId: '',
            humanoidPortData: JSON.parse(
                sessionStorage.getItem('humanoidPortData')
            ),

            //klaw datas
            // joystick1_X: '',
            // joystick1_Y: '',
            // joystick2_X: '',
            // joystick2_Y: '',
            // joystick3_X: '',
            // joystick3_Y: '',
            // switch1: '',
            // switch2: '',
            // switch3: '',
            pot1: '',
            pot2: '',
            pot3: '',
            pot4: '',
            pot5: '',
            pot6: '',
            pwm1: '',
            pwm2: '',
            pwm3: '',
            pwm4: '',
            pwm5: '',
            pwm6: '',
            isShowLowerVersionPopup: false,
            assemblySteps: null,
            stepsSlideIndex: 0,
            highlightComponentType: null,
            highlightPort: null,
            isForced: null,
            tutorialDeviation: false,
        }

        this.aiModelPopTimeOut = null
        this.messageHandler = this.messageHandler.bind(this)

        window.addEventListener('load', async (e) => {
            const height = document.body.clientHeight

            const width = document.body.clientWidth
            Sizes._update(width, height)
            this.setState({
                height: height,
                width: width,
            })
        })
        Sizes._update(document.body.clientWidth, document.body.clientHeight)
    }
    // componentDidCatch(error, info) {
    //     console.error(error, info)
    // }
    // async writePort(data) {
    //     sendBytes(data, this.props.webSerial.port)
    // }

    playAudioForStep = (slideIndex) => {
        // We calculate the actual 'step number' based on the slide index
        // Assuming 2 slides per step (Select -> Connect), step 1 is slide 0 & 1.
        // const stepNumber = Math.floor(slideIndex / 2) + 1;
        const stepNumber = slideIndex + 1 // If you want 1:1 mapping of slide to step

        const { assemblySteps } = this.state

        if (!assemblySteps?.meta?.audioBaseUrl) {
            console.warn('Audio Player: Missing audioBaseUrl in assemblySteps')
            return
        }

        // Construct URL (Matches the logic from your functional component)
        const audioUrl = `${assemblySteps.meta.audioBaseUrl}${stepNumber}.mp3`

        // In Make mode, play through the shell's persistent (pre-unlocked)
        // audio element so playback survives cross-screen navigation. Fall
        // back to the local element in standalone mode.
        if (this.context?.playAudio) {
            this.context.playAudio(audioUrl)
            return
        }

        if (!this.audioRef.current) {
            console.warn('Audio Player: Missing audio ref')
            return
        }
        this.audioRef.current.src = audioUrl
        this.audioRef.current
            .play()
            .catch((e) => console.log('Playback interrupted or failed:', e))
    }

    playAudioForStepWhenReady = (slideIndex) => {
        // With the shared shell element (Make mode) the element is already
        // unlocked, so a direct play is reliable — no canplaythrough dance.
        if (this.context?.playAudio) {
            this.playAudioForStep(slideIndex)
            return
        }

        const stepNumber = slideIndex + 1
        const { assemblySteps } = this.state

        if (!this.audioRef.current || !assemblySteps?.meta?.audioBaseUrl) {
            console.warn(
                'Audio Player: Missing ref or audioBaseUrl in assemblySteps'
            )
            return
        }

        const audio = this.audioRef.current
        const audioUrl = `${assemblySteps.meta.audioBaseUrl}${stepNumber}.mp3`

        const playWhenReady = () => {
            audio
                .play()
                .catch((e) => console.log('Playback interrupted or failed:', e))
        }

        audio.src = audioUrl
        audio.addEventListener('canplaythrough', playWhenReady, { once: true })

        // Fallback in case canplaythrough doesn't fire
        setTimeout(() => {
            if (audio.readyState >= 3) {
                playWhenReady()
            }
        }, 200)
    }

    //  TOGGLE BUTTONS

    // Toggle Voiceover
    handleAiVoiceoverToggle = () => {
        this.setState(
            (prevState) => ({
                aiVoiceover: !prevState.aiVoiceover,
            }),
            () => {
                // Callback runs AFTER state update
                sessionStorage.setItem(
                    'aiVoiceToggle',
                    String(this.state.aiVoiceover)
                )
                if (!this.state.aiVoiceover) {
                    // Turning OFF: Pause audio (shell element in Make mode,
                    // local element otherwise)
                    if (this.context?.stopAudio) {
                        this.context.stopAudio()
                    } else if (this.audioRef.current) {
                        this.audioRef.current.pause()
                        this.audioRef.current.currentTime = 0
                    }
                } else {
                    // Turning ON: Play current step
                    this.playAudioForStep(this.state.stepsSlideIndex)
                }
            }
        )
    }

    // Handle Fullscreen
    handleFullscreen = () => {
        // In Make mode, fullscreen the parent wrapper so it persists across screen transitions
        const el = this.context
            ? document.querySelector('.make-page')
            : this.appContainerRef.current

        const isFullscreen =
            document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.msFullscreenElement

        if (!isFullscreen) {
            if (el?.requestFullscreen) el.requestFullscreen()
            else if (el?.webkitRequestFullscreen) el.webkitRequestFullscreen()
            else if (el?.msRequestFullscreen) el.msRequestFullscreen()
        } else {
            if (document.exitFullscreen) document.exitFullscreen()
            else if (document.webkitExitFullscreen)
                document.webkitExitFullscreen()
            else if (document.msExitFullscreen) document.msExitFullscreen()
        }
    }

    //set PA bytes for Klaw
    setPABytes_Klaw() {
        let humanoidPortData = JSON.parse(
            sessionStorage.getItem('humanoidPortData')
        )
        let sendBytes = Array(17).fill('O')
        sendBytes[0] = 'P'
        sendBytes[1] = 'A'
        sendBytes[15] = 'E'
        sendBytes[16] = 'R'
        let internalAccessories = this.props.concept.internalaccessories
        let portConnections = this.props.assemblyTwo.PortConnections
        Object.keys(portConnections).map((port) => {
            if (
                port !== 'A' &&
                port !== 'B' &&
                port !== 'C' &&
                // port !== 'D' &&
                portConnections[port] !== null
            ) {
                const getIndex = (port) => {
                    switch (port) {
                        case 'A1':
                            return 2
                        case 'A2':
                            return 3
                        case 'B1':
                            return 4
                        case 'B2':
                            return 5
                        // case 'C1':
                        //     return 6
                        // case 'C2':
                        //     return 7
                        // case 'D1':
                        //     return 8
                        // case 'D2':
                        //     return 9
                        // case 'E1':
                        //     return 10
                        // case 'E2':
                        //     return 11
                        // case 'F1':
                        //     return 12
                        // case 'F2':
                        //     return 13
                    }
                }
                let arrIndex = getIndex(port)
                let Type = portConnections[port].type
                if (Type == 'ultrasonic_sensor') {
                    sendBytes[arrIndex] = 'U'
                } else if (Type == 'pcAiTool') {
                    sendBytes[arrIndex] = 'L'
                } else if (
                    Type == 'tact_switch' ||
                    Type == 'dual_switch' ||
                    Type == 'metal_detector' ||
                    Type == 'touch_sensor' ||
                    Type == 'dip_switch' ||
                    Type == 'tact_switch_2c'
                ) {
                    sendBytes[arrIndex] = 'I'
                    sendBytes[arrIndex] = 'I'
                } else if (
                    Type == 'distance_sensor' ||
                    Type == 'temperature_sensor' ||
                    Type == 'gas' ||
                    Type == 'light_sensor' ||
                    Type == 'linear_pot' ||
                    Type == 'pot' ||
                    Type == 'rain_sensor' ||
                    Type == 'humidity'
                ) {
                    sendBytes[arrIndex] = 'A'
                } else if (
                    Type == 'rotatory' ||
                    Type == 'joystick' ||
                    Type == 'extender'
                ) {
                    sendBytes[arrIndex] = 'A'
                    sendBytes[arrIndex] = 'A'
                }
            }
        })

        //joystick1
        sendBytes[6] = humanoidPortData['0'].isPortSelected ? 'A' : 'O'
        sendBytes[7] = humanoidPortData['1'].isPortSelected ? 'A' : 'O'
        //joystick1
        sendBytes[8] = humanoidPortData['2'].isPortSelected ? 'A' : 'O'
        sendBytes[9] = humanoidPortData['3'].isPortSelected ? 'A' : 'O'
        //joystick1
        sendBytes[10] = humanoidPortData['4'].isPortSelected ? 'A' : 'O'
        sendBytes[11] = humanoidPortData['5'].isPortSelected ? 'A' : 'O'
        sendBytes[12] = 'O'
        //switch
        sendBytes[13] = humanoidPortData['12'].isPortSelected ? 'I' : 'O'
        sendBytes[14] = humanoidPortData['13'].isPortSelected ? 'I' : 'O'
        // sendBytes[14] = humanoidPortData['5'].isPortSelected ? 'I' : 'O'

        sendBytes = sendBytes.toString().replaceAll(',', '')
        return sendBytes
    }

    //set PA bytes for roboki
    setPABytes_Roboki() {
        let sendBytes = Array(10).fill('O')

        sendBytes[0] = 'P'
        sendBytes[1] = 'A'
        sendBytes[8] = 'E'
        sendBytes[9] = 'R'
        let internalAccessories = this.props.concept.internalaccessories
        let portConnections = this.props.assemblyTwo.PortConnections
        Object.keys(portConnections).map((port) => {
            if (
                port !== 'A' &&
                port !== 'B' &&
                portConnections[port] !== null
            ) {
                const getIndex = (port) => {
                    switch (port) {
                        case 'A1':
                            return 2
                        case 'A2':
                            return 3
                        case 'B1':
                            return 4
                        case 'B2':
                            return 5
                        case 'C1':
                            return 6
                        case 'C2':
                            return 7
                    }
                }

                let arrIndex = getIndex(port)
                let Type = portConnections[port].type
                if (Type == 'ultrasonic_sensor') {
                    sendBytes[arrIndex] = 'U'
                } else if (Type == 'pcAiTool') {
                    sendBytes[arrIndex] = 'L'
                } else if (
                    [
                        'tact_switch',
                        'dual_switch',
                        'touch_sensor',
                        'dip_switch',
                        'tact_switch_2c',
                        'tern_tact_switch',
                        'tern_touch_sensor',
                    ].includes(Type)
                ) {
                    sendBytes[arrIndex] = 'I'
                    sendBytes[arrIndex] = 'I'
                } else if (
                    [
                        'distance_sensor',
                        'temperature_sensor',
                        'light_sensor',
                        'pot',
                        'rain_sensor',
                        'tern_humidity_sensor',
                        'tern_gas_sensor',
                        'tern_sound_sensor',
                    ].includes(Type)
                ) {
                    sendBytes[arrIndex] = 'A'
                } else if (
                    Type == 'rotatory' ||
                    Type == 'joystick' ||
                    Type == 'extender'
                ) {
                    sendBytes[arrIndex] = 'A'
                    sendBytes[arrIndex] = 'A'
                }
            }
        })
        if (internalAccessories.isSwitch1) {
            sendBytes[6] = 'I'
        }
        if (internalAccessories.isSwitch2) {
            sendBytes[7] = 'I'
        }
        sendBytes = sendBytes.toString().replaceAll(',', '')
        console.log('JJJJJJJJJJJ, sendBytes', sendBytes)
        return sendBytes
    }

    TokiPlusGetIndex = (port) => {
        switch (port) {
            case 'A1':
                return 2
            case 'A2':
                return 3
            case 'C1':
                return 4
            case 'C2':
                return 5
            case 'D1':
                return 6
            case 'D2':
                return 7
            case 'E1':
                return 8
            case 'E2':
                return 9
            case 'F1':
                return 10
            case 'F2':
                return 11
            case 'G1':
                return 12
            case 'G2':
                return 13
            case 'servo_motor1':
                return 14
            case 'servo_motor2':
                return 15
        }
    }

    //PA Bytes generat for PeeCee and Atr
    setPABytes_V1() {
        let sendBytes = []
        if (connectedDevice == 'Toki') {
            sendBytes = Array(9).fill('0')

            sendBytes[0] = 'P'
            sendBytes[1] = 'A'
            sendBytes[7] = 'E'
            sendBytes[8] = 'R'
        } else if (connectedDevice === 'Moki') {
            sendBytes = Array(21).fill('0')

            sendBytes[0] = 'P'
            sendBytes[1] = 'A'
            sendBytes[19] = 'E'
            sendBytes[20] = 'R'
        } else if (connectedDevice == 'Poki') {
            this.connectStatusRef.current = {
                isIMUConnect: false,
                isColor_sensorConnect: false,
            }

            sendBytes = Array(19).fill('0')

            sendBytes[0] = 'P'
            sendBytes[1] = 'A'
            sendBytes[17] = 'E'
            sendBytes[18] = 'R'
        } else {
            sendBytes = Array(25).fill('0')

            sendBytes[0] = 'P'
            sendBytes[1] = 'A'
            sendBytes[23] = 'E'
            sendBytes[24] = 'R'
        }
        let internalAccessories = this.props.concept.internalaccessories
        let portConnections = this.props.assemblyTwo.PortConnections
        Object.keys(portConnections).map((port) => {
            if (
                port !== 'A' &&
                port !== 'B' &&
                port !== 'C' &&
                port !== 'D' &&
                portConnections[port] !== null
            ) {
                const getIndex = (port) => {
                    switch (port) {
                        case 'A1':
                            return 2
                        case 'A2':
                            return 3
                        case 'B1':
                            return 4
                        case 'B2':
                            return 5
                        case 'C1':
                            return 6
                        case 'C2':
                            return 7
                        case 'D1':
                            return 8
                        case 'D2':
                            return 9
                        case 'E1':
                            return 10
                        case 'E2':
                            return 11
                        case 'F1':
                            return 12
                        case 'F2':
                            return 13
                        case 'G1':
                            return 14
                        case 'G2':
                            return 15
                    }
                }

                const tokiIndex = (port) => {
                    switch (port) {
                        case 'servo_motor1':
                            return 4
                        case 'servo_motor2':
                            return 5
                    }
                }

                let arrIndex
                if (connectedDevice == 'Poki') {
                    arrIndex = this.TokiPlusGetIndex(port)
                } else {
                    arrIndex = getIndex(port)
                }
                if (
                    connectedDevice == 'Toki' &&
                    ['servo_motor1', 'servo_motor2'].includes(port)
                ) {
                    arrIndex = tokiIndex(port)
                }

                let Type = portConnections[port].type
                if (Type == 'ultrasonic_sensor') {
                    sendBytes[arrIndex] = 'U'
                } else if (Type == 'pcAiTool') {
                    let isAi_lidarSelect =
                        this.props?.assemblyTwo?.assemblyPageAi?.aiItems
                            ?.ai_lidar
                    if (isAi_lidarSelect) sendBytes[arrIndex] = 'L'
                } else if (
                    [
                        'tact_switch',
                        'dual_switch',
                        'metal_detector',
                        'touch_sensor',
                        'dip_switch',
                        'tact_switch_2c',
                        'rain_sensor_module_digital',
                        'capacitative_touch_sensor',
                        'PIR_sensor',
                        'Digital_2_Pin_Input',
                        'Digital_3_Pin_Input',
                    ].includes(Type)
                ) {
                    sendBytes[arrIndex] = 'I'
                    sendBytes[arrIndex] = 'I'
                } else if (
                    [
                        'distance_sensor',
                        'temperature_sensor',
                        'gas',
                        'light_sensor',
                        'linear_pot',
                        'pot',
                        'rain_sensor',
                        'rain_sensor_module_analog',
                        'humidity',
                        'LDR_sensor',
                        'sound_sensor',
                        'DHT11',
                        'IR_proximity',
                        'Photo diode',
                        'Analog_3_Pin_Input',
                        'Analog_2_Pin_Input',
                    ].includes(Type)
                ) {
                    sendBytes[arrIndex] = 'A'
                } else if (
                    ['rotatory', 'joystick', 'extender'].includes(Type)
                ) {
                    sendBytes[arrIndex] = 'A'
                    sendBytes[arrIndex] = 'A'
                } else if (
                    Type === 'Magnetometer' &&
                    connectedDevice === 'Poki'
                ) {
                    sendBytes[arrIndex] = 'Q'
                } else if (
                    Type === 'Color_sensor' &&
                    connectedDevice === 'Poki'
                ) {
                    this.connectStatusRef.current = {
                        isIMUConnect: false,
                        isColor_sensorConnect: true,
                    }
                    sendBytes[arrIndex] = 'C'
                } else if (
                    Type === 'Magnetic_encoder' &&
                    connectedDevice === 'Poki'
                ) {
                    sendBytes[arrIndex] = 'E'
                } else if (Type === 'IMU' && connectedDevice === 'Poki') {
                    this.connectStatusRef.current = {
                        isIMUConnect: true,
                        isColor_sensorConnect: false,
                    }
                    sendBytes[arrIndex] = 'G'
                    sendBytes[arrIndex + 1] = 'G'
                }
            }
        })

        if (connectedDevice == 'Ace') {
            if (internalAccessories.isMic) {
                sendBytes[14] = 'M'
            }
            if (internalAccessories.isTemperature) {
                sendBytes[15] = 'T'
            }
            if (internalAccessories.isTouchZero) {
                sendBytes[16] = 'T'
            }
            if (internalAccessories.isTouchOne) {
                sendBytes[17] = 'T'
            }
            if (internalAccessories.isTouchTwo) {
                sendBytes[18] = 'T'
            }
            if (internalAccessories.isTouchThree) {
                sendBytes[19] = 'T'
            }
            if (internalAccessories.Four_in_one_sensor.isDistanceSensors) {
                sendBytes[20] = 'D'
            }
            if (internalAccessories.Four_in_one_sensor.isGestureSensor) {
                sendBytes[20] = 'G'
            }
            if (internalAccessories.Four_in_one_sensor.isColorSensor) {
                sendBytes[20] = 'C'
            }
            if (internalAccessories.Four_in_one_sensor.isLightSensor) {
                sendBytes[20] = 'L'
            }
            if (internalAccessories.isAccelerometer) {
                sendBytes[21] = 'A'
            }
            if (internalAccessories.isBattery) {
                sendBytes[22] = 'B'
            }
        } else if (connectedDevice === 'Moki') {
            if (internalAccessories.isIr) {
                sendBytes[16] = 'R'
            }
            if (internalAccessories.isSwitch1) {
                sendBytes[17] = 'I'
            }
            if (internalAccessories.isSwitch2) {
                sendBytes[18] = 'I'
            }
        } else if (connectedDevice === 'Poki') {
            if (internalAccessories.isIr) {
                sendBytes[16] = 'N'
            }
        } else if (connectedDevice === 'Toki') {
            if (internalAccessories.isIr) {
                sendBytes[6] = 'N'
            }
        }
        // }
        sendBytes = sendBytes.toString().replaceAll(',', '')
        return sendBytes
    }

    setPABytes_V2() {
        let humanoidPortData = JSON.parse(
            sessionStorage.getItem('humanoidPortData')
        )
        let sendBytes = Array(13).fill('O')

        sendBytes[0] = 'P'
        sendBytes[1] = 'A'
        sendBytes[11] = 'E'
        sendBytes[12] = 'R'
        let internalAccessories = this.props.concept.internalaccessories
        let portConnections = this.props.assemblyTwo.PortConnections
        Object.keys(portConnections).map((port) => {
            if (
                port !== 'A' &&
                port !== 'B' &&
                port !== 'C' &&
                // port !== 'D' &&
                portConnections[port] !== null
            ) {
                const getIndex = (port) => {
                    switch (port) {
                        case 'A1':
                            return 2
                        case 'A2':
                            return 3
                        case 'B1':
                            return 4
                        case 'B2':
                            return 5
                        case 'C1':
                            return 6
                        case 'C2':
                            return 7
                    }
                }

                let arrIndex = getIndex(port)
                let Type = portConnections[port].type
                if (Type == 'ultrasonic_sensor') {
                    sendBytes[arrIndex] = 'U'
                } else if (Type == 'pcAiTool') {
                    let isAi_lidarSelect =
                        this.props?.assemblyTwo?.assemblyPageAi?.aiItems
                            ?.ai_lidar
                    if (isAi_lidarSelect) sendBytes[arrIndex] = 'L'
                } else if (
                    Type == 'tact_switch' ||
                    Type == 'dual_switch' ||
                    Type == 'metal_detector' ||
                    Type == 'touch_sensor' ||
                    Type == 'dip_switch' ||
                    Type == 'tact_switch_2c'
                ) {
                    sendBytes[arrIndex] = 'I'
                    sendBytes[arrIndex] = 'I'
                } else if (
                    Type == 'distance_sensor' ||
                    Type == 'temperature_sensor' ||
                    Type == 'gas' ||
                    Type == 'light_sensor' ||
                    Type == 'linear_pot' ||
                    Type == 'pot' ||
                    Type == 'rain_sensor' ||
                    Type == 'humidity'
                ) {
                    sendBytes[arrIndex] = 'A'
                } else if (
                    Type == 'rotatory' ||
                    Type == 'joystick' ||
                    Type == 'extender'
                ) {
                    sendBytes[arrIndex] = 'A'
                    sendBytes[arrIndex] = 'A'
                }
            }
        })
        if (connectedDevice == 'Hexapod') {
            sendBytes[8] = humanoidPortData['24'].isPortSelected ? 'U' : 'O'
            let isAMPUEnable = false
            for (let i = 0; i < 6; i++) {
                if (humanoidPortData[25 + i].isPortSelected) {
                    isAMPUEnable = true
                    break
                }
            }
            sendBytes[9] = isAMPUEnable ? 'A' : 'O'
            sendBytes[10] = humanoidPortData['23'].isPortSelected ? 'B' : 'O'
        } else {
            sendBytes[8] = humanoidPortData['22'].isPortSelected ? 'U' : 'O'
            // sendBytes[9] = humanoidPortData['4b'].isPortSelected
            //     ? 'S'.charCodeAt(0)
            //     : 'O'.charCodeAt(0)
            let isAMPUEnable = false
            for (let i = 0; i < 6; i++) {
                if (humanoidPortData[23 + i].isPortSelected) {
                    isAMPUEnable = true
                    break
                }
            }
            sendBytes[9] = isAMPUEnable ? 'A' : 'O'
            // sendBytes[9] = 'O'.charCodeAt(0)
            sendBytes[10] = humanoidPortData['21'].isPortSelected ? 'B' : 'O'
        }

        sendBytes = sendBytes.toString().replaceAll(',', '')

        return sendBytes
    }

    setPABytes_PCv0() {
        let bytesData = Array(11).fill('O'.charCodeAt())

        bytesData.unshift('A'.charCodeAt())
        bytesData.unshift('P'.charCodeAt())

        let sessionData = JSON.parse(sessionStorage.getItem('concept'))

        let Tp0 = sessionData.internalaccessories.isTouchOne

        let portdata = JSON.parse(sessionStorage.getItem('assemblyTwo'))

        Object.keys(portdata.PortConnections).map((port) => {
            if (portdata.PortConnections[port] != null) {
                if (port === 'A' || port === 'A1' || port === 'A2') {
                    let Type = portdata.PortConnections[port].type

                    if (Type == 'ultrasonic_sensor') {
                        bytesData[2] = 'U'.charCodeAt()
                        // bytesData[3] = "I".charCodeAt();
                    } else if (
                        Type == 'tact_switch' ||
                        Type == 'touch_sensor' ||
                        Type == 'dual_switch' ||
                        Type == 'dip_switch' ||
                        Type == 'metal_detector'
                    ) {
                        if (port == 'A') {
                            bytesData[2] = 'I'.charCodeAt()
                            bytesData[3] = 'I'.charCodeAt()
                        }
                        if (port == 'A1') bytesData[2] = 'I'.charCodeAt()
                        if (port == 'A2') bytesData[3] = 'I'.charCodeAt()
                    } else if (
                        Type == 'distance_sensor' ||
                        Type == 'temperature_sensor' ||
                        Type == 'gas' ||
                        Type == 'light_sensor' ||
                        Type == 'linear_pot' ||
                        Type == 'pot' ||
                        Type == 'rain_sensor' ||
                        Type == 'humidity'
                    ) {
                        if (port == 'A') {
                            bytesData[2] = 'A'.charCodeAt()
                            bytesData[3] = 'A'.charCodeAt()
                        }
                        if (port == 'A1') bytesData[2] = 'A'.charCodeAt()
                        if (port == 'A2') bytesData[3] = 'A'.charCodeAt()
                    } else if (
                        Type == 'rotatory' ||
                        Type == 'joystick' ||
                        Type == 'extender'
                    ) {
                        bytesData[2] = 'A'.charCodeAt()
                        bytesData[3] = 'A'.charCodeAt()
                    }
                } else if (port === 'B' || port === 'B1' || port === 'B2') {
                    let Type = portdata.PortConnections[port].type

                    if (
                        Type == 'rotatory' ||
                        Type == 'joystick' ||
                        Type == 'extender'
                    ) {
                        bytesData[4] = 'A'.charCodeAt()
                        bytesData[5] = 'A'.charCodeAt()
                    } else if (
                        Type == 'distance_sensor' ||
                        Type == 'temperature_sensor' ||
                        Type == 'gas' ||
                        Type == 'light_sensor' ||
                        Type == 'linear_pot' ||
                        Type == 'pot' ||
                        Type == 'rain_sensor' ||
                        Type == 'humidity'
                    ) {
                        if (port == 'B') {
                            bytesData[4] = 'A'.charCodeAt()
                            bytesData[5] = 'A'.charCodeAt()
                        }
                        if (port == 'B1') bytesData[4] = 'A'.charCodeAt()
                        if (port == 'B2') bytesData[5] = 'A'.charCodeAt()
                    } else if (
                        Type == 'tact_switch' ||
                        Type == 'touch_sensor' ||
                        Type == 'dual_switch' ||
                        Type == 'dip_switch' ||
                        Type == 'metal_detector'
                    ) {
                        if (port == 'B') {
                            bytesData[4] = 'I'.charCodeAt()
                            bytesData[5] = 'I'.charCodeAt()
                        }
                        if (port == 'B1') bytesData[4] = 'I'.charCodeAt()
                        if (port == 'B2') bytesData[5] = 'I'.charCodeAt()
                    }
                } else if (port === 'C' || port === 'C1' || port === 'C2') {
                    let Type = portdata.PortConnections[port].type

                    if (Type == 'ultrasonic_sensor') {
                        bytesData[6] = 'U'.charCodeAt()
                        // bytesData[7] = "A".charCodeAt();
                    } else if (
                        Type == 'tact_switch' ||
                        Type == 'touch_sensor' ||
                        Type == 'metal_detector' ||
                        Type == 'dual_switch' ||
                        Type == 'dip_switch'
                    ) {
                        if (port == 'C') {
                            bytesData[6] = 'I'.charCodeAt()
                            bytesData[7] = 'I'.charCodeAt()
                        }
                        if (port == 'C1') bytesData[6] = 'I'.charCodeAt()
                        if (port == 'C2') bytesData[7] = 'I'.charCodeAt()
                    } else if (
                        Type == 'distance_sensor' ||
                        Type == 'temperature_sensor' ||
                        Type == 'gas' ||
                        Type == 'light_sensor' ||
                        Type == 'linear_pot' ||
                        Type == 'pot' ||
                        Type == 'rain_sensor' ||
                        Type == 'humidity'
                    ) {
                        if (port == 'C') {
                            bytesData[6] = 'A'.charCodeAt()
                            bytesData[7] = 'A'.charCodeAt()
                        }
                        if (port == 'C1') bytesData[6] = 'A'.charCodeAt()
                        if (port == 'C2') bytesData[7] = 'A'.charCodeAt()
                    } else if (
                        Type == 'rotatory' ||
                        Type == 'joystick' ||
                        Type == 'metal_detector' ||
                        Type == 'extender'
                    ) {
                        bytesData[6] = 'A'.charCodeAt()
                        bytesData[7] = 'A'.charCodeAt()
                    }
                } else if (port === 'F' || port === 'F1' || port === 'F2') {
                    let Type = portdata.PortConnections[port].type

                    if (
                        Type == 'tact_switch' ||
                        Type == 'touch_sensor' ||
                        Type == 'dual_switch' ||
                        Type == 'dip_switch' ||
                        Type == 'metal_detector'
                    ) {
                        if (port == 'F1') bytesData[8] = 'I'.charCodeAt()
                        if (port == 'F2') bytesData[9] = 'I'.charCodeAt()
                    }
                }
            }
        })

        if (sessionData.internalaccessories.isMic) {
            bytesData[11] = 'M'.charCodeAt()
        }
        if (sessionData.internalaccessories.isTemperature) {
            bytesData[12] = 'T'.charCodeAt()
        }
        if (sessionData.internalaccessories.isTouchZero) {
            bytesData[2] = 'T'.charCodeAt()
        }
        if (sessionData.internalaccessories.isTouchOne) {
            bytesData[4] = 'T'.charCodeAt()
        }
        if (sessionData.internalaccessories.isTouchTwo) {
            bytesData[6] = 'T'.charCodeAt()
        }

        if (
            sessionData.internalaccessories.Four_in_one_sensor.isDistanceSensors
        ) {
            bytesData[10] = 'D'.charCodeAt()
        }
        if (
            sessionData.internalaccessories.Four_in_one_sensor.isGestureSensor
        ) {
            bytesData[10] = 'G'.charCodeAt()
        }
        if (sessionData.internalaccessories.Four_in_one_sensor.isColorSensor) {
            bytesData[10] = 'C'.charCodeAt()
        }
        if (sessionData.internalaccessories.Four_in_one_sensor.isLightSensor) {
            bytesData[10] = 'L'.charCodeAt()
        }
        return bytesData
    }

    setPaBytes_ZingV1V2 = () => {
        // let humanoidPortData = JSON.parse(
        //     sessionStorage.getItem('humanoidPortData')
        // )

        let sendBytes = [...HUMANOID_V1_PA_SEND_BYTES]
        console.log(this.state.humanoidPortData)
        if (!this.props.webSerial.isConnected) {
            window.location.reload()
            return
        }

        sessionStorage.setItem('isReadingZingPA', this.state.isReading)
        // this.setState({
        //     isReading: !this.state.isReading,
        // })
        let portdata = JSON.parse(sessionStorage.getItem('assemblyTwo'))

        Object.keys(portdata.PortConnections).map((port) => {
            if (portdata.PortConnections[port] != null) {
                if (port === 'A' || port === 'A1' || port === 'A2') {
                    let Type = portdata.PortConnections[port].type

                    if (Type == 'ultrasonic_sensor') {
                        HUMANOID_PA_SEND_BYTES[2] = 'U'.charCodeAt()
                        HUMANOID_PA_SEND_BYTES[3] = 'U'.charCodeAt()

                        sendBytes[2] = 'U'.charCodeAt()
                        sendBytes[3] = 'U'.charCodeAt()
                        // bytesData[3] = "I".charCodeAt();
                    } else if (Type == 'pcAiTool') {
                        sendBytes[2] = 'L'
                    } else if (
                        Type == 'tact_switch' ||
                        Type == 'touch_sensor' ||
                        Type == 'dual_switch' ||
                        Type == 'metal_detector' ||
                        Type == 'dip_switch'
                    ) {
                        if (port == 'A') {
                            HUMANOID_PA_SEND_BYTES[2] = 'I'.charCodeAt()
                            HUMANOID_PA_SEND_BYTES[3] = 'I'.charCodeAt()

                            sendBytes[2] = 'I'.charCodeAt()
                            sendBytes[3] = 'I'.charCodeAt()
                        }
                        if (port == 'A1') {
                            HUMANOID_PA_SEND_BYTES[2] = 'I'.charCodeAt()
                            sendBytes[2] = 'I'.charCodeAt()
                        }
                        if (port == 'A2') {
                            HUMANOID_PA_SEND_BYTES[3] = 'I'.charCodeAt()
                            sendBytes[3] = 'I'.charCodeAt()
                        }
                    } else if (
                        Type == 'distance_sensor' ||
                        Type == 'temperature_sensor' ||
                        Type == 'gas' ||
                        Type == 'light_sensor' ||
                        Type == 'linear_pot' ||
                        Type == 'pot' ||
                        Type == 'rain_sensor' ||
                        Type == 'metal_detector' ||
                        Type == 'humidity'
                    ) {
                        if (port == 'A') {
                            HUMANOID_PA_SEND_BYTES[2] = 'A'.charCodeAt()
                            HUMANOID_PA_SEND_BYTES[3] = 'A'.charCodeAt()

                            sendBytes[2] = 'A'.charCodeAt()
                            sendBytes[3] = 'A'.charCodeAt()
                        }
                        if (port == 'A1') {
                            HUMANOID_PA_SEND_BYTES[2] = 'A'.charCodeAt()
                            sendBytes[2] = 'A'.charCodeAt()
                        }
                        if (port == 'A2') {
                            HUMANOID_PA_SEND_BYTES[3] = 'A'.charCodeAt()
                            sendBytes[3] = 'A'.charCodeAt()
                        }
                    } else if (
                        Type == 'rotatory' ||
                        Type == 'joystick' ||
                        Type == 'extender'
                    ) {
                        HUMANOID_PA_SEND_BYTES[2] = 'A'.charCodeAt()
                        HUMANOID_PA_SEND_BYTES[3] = 'A'.charCodeAt()

                        sendBytes[2] = 'A'.charCodeAt()
                        sendBytes[3] = 'A'.charCodeAt()
                    }
                } else if (port === 'B' || port === 'B1' || port === 'B2') {
                    let Type = portdata.PortConnections[port].type

                    if (
                        Type == 'rotatory' ||
                        Type == 'joystick' ||
                        Type == 'extender'
                    ) {
                        HUMANOID_PA_SEND_BYTES[4] = 'A'.charCodeAt()
                        HUMANOID_PA_SEND_BYTES[5] = 'A'.charCodeAt()

                        sendBytes[4] = 'A'.charCodeAt()
                        sendBytes[5] = 'A'.charCodeAt()
                    } else if (
                        Type == 'distance_sensor' ||
                        Type == 'temperature_sensor' ||
                        Type == 'gas' ||
                        Type == 'light_sensor' ||
                        Type == 'linear_pot' ||
                        Type == 'pot' ||
                        Type == 'rain_sensor' ||
                        Type == 'humidity'
                    ) {
                        if (port == 'B') {
                            HUMANOID_PA_SEND_BYTES[4] = 'A'.charCodeAt()
                            HUMANOID_PA_SEND_BYTES[5] = 'A'.charCodeAt()

                            sendBytes[4] = 'A'.charCodeAt()
                            sendBytes[5] = 'A'.charCodeAt()
                        }
                        if (port == 'B1') {
                            HUMANOID_PA_SEND_BYTES[4] = 'A'.charCodeAt()
                            sendBytes[4] = 'A'.charCodeAt()
                        }
                        if (port == 'B2') {
                            HUMANOID_PA_SEND_BYTES[5] = 'A'.charCodeAt()
                            sendBytes[5] = 'A'.charCodeAt()
                        }
                    } else if (
                        Type == 'tact_switch' ||
                        Type == 'touch_sensor' ||
                        Type == 'dual_switch' ||
                        Type == 'dip_switch' ||
                        Type == 'metal_detector'
                    ) {
                        if (port == 'B') {
                            HUMANOID_PA_SEND_BYTES[4] = 'I'.charCodeAt()
                            HUMANOID_PA_SEND_BYTES[5] = 'I'.charCodeAt()

                            sendBytes[4] = 'I'.charCodeAt()
                            sendBytes[5] = 'I'.charCodeAt()
                        }
                        if (port == 'B1') {
                            HUMANOID_PA_SEND_BYTES[4] = 'I'.charCodeAt()
                            sendBytes[4] = 'I'.charCodeAt()
                        }
                        if (port == 'B2') {
                            HUMANOID_PA_SEND_BYTES[5] = 'I'.charCodeAt()
                            sendBytes[5] = 'I'.charCodeAt()
                        }
                    }
                } else if (port === 'C' || port === 'C1' || port === 'C2') {
                    let Type = portdata.PortConnections[port].type
                    let connectedDevice =
                        sessionStorage.getItem('deviceConnected')
                    if (Type == 'ultrasonic_sensor') {
                        if (
                            connectedDevice == 'Humanoid' &&
                            (sessionStorage.getItem('zincVersion') || '')[0] ==
                                '0'
                        )
                            return
                        sendBytes[6] = 'U'.charCodeAt()
                        sendBytes[7] = 'U'.charCodeAt()
                    } else if (
                        Type == 'tact_switch' ||
                        Type == 'touch_sensor' ||
                        Type == 'metal_detector' ||
                        Type == 'dual_switch' ||
                        Type == 'dip_switch'
                    ) {
                        if (port == 'C') {
                            HUMANOID_PA_SEND_BYTES[6] = 'I'.charCodeAt()
                            HUMANOID_PA_SEND_BYTES[7] = 'I'.charCodeAt()

                            sendBytes[6] = 'I'.charCodeAt()
                            sendBytes[7] = 'I'.charCodeAt()
                        }
                        if (port == 'C1') {
                            HUMANOID_PA_SEND_BYTES[6] = 'I'.charCodeAt()
                            sendBytes[6] = 'I'.charCodeAt()
                        }
                        if (port == 'C2') {
                            HUMANOID_PA_SEND_BYTES[7] = 'I'.charCodeAt()
                            sendBytes[7] = 'I'.charCodeAt()
                        }
                    } else if (
                        Type == 'distance_sensor' ||
                        Type == 'temperature_sensor' ||
                        Type == 'gas' ||
                        Type == 'light_sensor' ||
                        Type == 'linear_pot' ||
                        Type == 'pot' ||
                        Type == 'rain_sensor' ||
                        Type == 'humidity'
                    ) {
                        if (port == 'C') {
                            HUMANOID_PA_SEND_BYTES[6] = 'A'.charCodeAt()
                            HUMANOID_PA_SEND_BYTES[7] = 'A'.charCodeAt()

                            sendBytes[6] = 'A'.charCodeAt()
                            sendBytes[7] = 'A'.charCodeAt()
                        }
                        if (port == 'C1') {
                            sendBytes[6] = 'A'.charCodeAt()
                            HUMANOID_PA_SEND_BYTES[6] = 'A'.charCodeAt()
                        }
                        if (port == 'C2') {
                            HUMANOID_PA_SEND_BYTES[7] = 'A'.charCodeAt()
                            sendBytes[7] = 'A'.charCodeAt()
                        }
                    } else if (
                        Type == 'rotatory' ||
                        Type == 'joystick' ||
                        Type == 'extender'
                    ) {
                        HUMANOID_PA_SEND_BYTES[6] = 'A'.charCodeAt()
                        HUMANOID_PA_SEND_BYTES[7] = 'A'.charCodeAt()

                        sendBytes[6] = 'A'.charCodeAt()
                        sendBytes[7] = 'A'.charCodeAt()
                    }
                } else if (port === 'D' || port === 'D1' || port === 'D2') {
                    let Type = portdata.PortConnections[port].type

                    if (Type == 'ultrasonic_sensor') {
                        HUMANOID_PA_SEND_BYTES[8] = 'U'.charCodeAt()
                        HUMANOID_PA_SEND_BYTES[9] = 'U'.charCodeAt()
                        // bytesData[7] = "A".charCodeAt();
                    } else if (
                        Type == 'tact_switch' ||
                        Type == 'touch_sensor' ||
                        Type == 'metal_detector' ||
                        Type == 'dual_switch' ||
                        Type == 'dip_switch'
                    ) {
                        if (port == 'D') {
                            HUMANOID_PA_SEND_BYTES[8] = 'I'.charCodeAt()
                            HUMANOID_PA_SEND_BYTES[9] = 'I'.charCodeAt()
                        }
                        if (port == 'D1')
                            HUMANOID_PA_SEND_BYTES[8] = 'I'.charCodeAt()
                        if (port == 'C2')
                            HUMANOID_PA_SEND_BYTES[9] = 'I'.charCodeAt()
                    } else if (
                        Type == 'distance_sensor' ||
                        Type == 'temperature_sensor' ||
                        Type == 'gas' ||
                        Type == 'light_sensor' ||
                        Type == 'linear_pot' ||
                        Type == 'pot' ||
                        Type == 'rain_sensor' ||
                        Type == 'humidity'
                    ) {
                        if (port == 'D') {
                            HUMANOID_PA_SEND_BYTES[8] = 'A'.charCodeAt()
                            HUMANOID_PA_SEND_BYTES[9] = 'A'.charCodeAt()
                        }
                        if (port == 'D1')
                            HUMANOID_PA_SEND_BYTES[8] = 'A'.charCodeAt()
                        if (port == 'D2')
                            HUMANOID_PA_SEND_BYTES[9] = 'A'.charCodeAt()
                    } else if (
                        Type == 'rotatory' ||
                        Type == 'joystick' ||
                        Type == 'extender'
                    ) {
                        HUMANOID_PA_SEND_BYTES[8] = 'A'.charCodeAt()
                        HUMANOID_PA_SEND_BYTES[9] = 'A'.charCodeAt()
                    }
                }
            }
        })

        HUMANOID_PA_SEND_BYTES[10] = 'B'.charCodeAt(0)
        HUMANOID_PA_SEND_BYTES[11] = 'A'.charCodeAt(0)
        HUMANOID_PA_SEND_BYTES[12] = 'G'.charCodeAt(0)

        sendBytes[8] = this.state.humanoidPortData['22'].isPortSelected
            ? 'U'.charCodeAt(0)
            : 'O'.charCodeAt(0)
        // sendBytes[9] = humanoidPortData['4b'].isPortSelected
        //     ? 'S'.charCodeAt(0)
        //     : 'O'.charCodeAt(0)

        //boards without acc and gyro
        let isAMPUEnable = false
        for (let i = 0; i < 6; i++) {
            if (this.state.humanoidPortData[23 + i].isPortSelected) {
                isAMPUEnable = true
                break
            }
        }
        sendBytes[9] = isAMPUEnable ? 'A'.charCodeAt(0) : 'O'.charCodeAt(0)

        // sendBytes[9] = 'O'.charCodeAt(0)
        sendBytes[10] = this.state.humanoidPortData['21'].isPortSelected
            ? 'B'.charCodeAt(0)
            : 'O'.charCodeAt(0)
        console.log('IIIIIIIIIIIIIIIII', HUMANOID_PA_SEND_BYTES)
        // let zingVersion = sessionStorage.getItem('zingVersion') || '0.0.0'
        let deviceVersion = sessionStorage.getItem('deviceVersion') || '0.0.0'
        let connectedDevice = sessionStorage.getItem('connectedDevice') || ''
        console.log('OOOOOOOOOOOOO', sendBytes.join(' '))

        return ['1', '2', '3'].includes(deviceVersion?.[0])
            ? sendBytes
            : HUMANOID_PA_SEND_BYTES
        // if (connectedDevice == 'Hexapod' && deviceVersion.includes('2.0')) {
        //     this.handleReadBytes_Hexapod(sendBytes)

        // continousPABytesReadToggle(
        //     // zingVersion[0] === '1' ||
        //     ['Hexapod', 'Humanoid'].includes(connectedDevice) &&
        //         deviceVersion[0] === '1'
        //         ? sendBytes
        //         : HUMANOID_PA_SEND_BYTES,
        //     54,
        //     this.props.webSerial.port,
        //     (response) => {
        //         if (!this.state.isReading) {
        //             this.setState({
        //                 huBattery: '',

        //                 huUltrasonic: '',
        //                 huSred1: '',
        //                 huSred2: '',
        //                 huSred3: '',
        //                 huSred4: '',
        //                 huSred5: '',
        //                 huSred6: '',
        //                 huSred7: '',
        //                 huSred8: '',
        //                 huSred9: '',
        //                 huSred10: '',
        //                 huSred11: '',
        //                 huSred12: '',
        //                 huSred13: '',
        //                 huSred14: '',
        //                 huSred15: '',
        //                 huSred16: '',

        //                 huAccelerometerX: '',
        //                 huAccelerometerY: '',
        //                 huAccelerometerZ: '',
        //                 huGyroX: '',
        //                 huGyroY: '',
        //                 huGyroZ: '',
        //                 rangeA1: '',
        //                 rangeA2: '',
        //                 rangeB1: '',
        //                 rangeB2: '',
        //                 rangeC1: '',
        //                 rangeC2: '',
        //                 rangeD1: '',
        //                 rangeD2: '',
        //             })
        //             return
        //         }
        //         if (connectedDevice == 'Humanoid') {
        //             this.setState({
        // huBattery: humanoidPABytesToSensorData(response, 21),
        // huAccelerometerX: humanoidPABytesToSensorData(
        //     response,
        //     23
        // ),
        // huAccelerometerY: humanoidPABytesToSensorData(
        //     response,
        //     24
        // ),
        // huAccelerometerZ: humanoidPABytesToSensorData(
        //     response,
        //     25
        // ),
        // huGyroX: humanoidPABytesToSensorData(response, 26),
        // huGyroY: humanoidPABytesToSensorData(response, 27),
        // huGyroZ: humanoidPABytesToSensorData(response, 28),
        // rangeA1: humanoidPABytesToSensorData(response, 31),
        // rangeA2: humanoidPABytesToSensorData(response, 32),
        // rangeB1: humanoidPABytesToSensorData(response, 33),
        // rangeB2: humanoidPABytesToSensorData(response, 34),
        // rangeC1: humanoidPABytesToSensorData(response, 35),
        // rangeC2: humanoidPABytesToSensorData(response, 36),
        // rangeD1: humanoidPABytesToSensorData(response, 37),
        // rangeD2: humanoidPABytesToSensorData(response, 38),

        // huUltrasonic: humanoidPABytesToSensorData(response, 22),
        //                 huSred1: humanoidPABytesToSensorData(response, 5),
        //                 huSred2: humanoidPABytesToSensorData(response, 6),
        //                 huSred3: humanoidPABytesToSensorData(response, 7),
        //                 huSred4: humanoidPABytesToSensorData(response, 8),
        //                 huSred5: humanoidPABytesToSensorData(response, 9),
        //                 huSred6: humanoidPABytesToSensorData(response, 10),
        //                 huSred7: humanoidPABytesToSensorData(response, 11),
        //                 huSred8: humanoidPABytesToSensorData(response, 12),
        //                 huSred9: humanoidPABytesToSensorData(response, 13),
        //                 huSred10: humanoidPABytesToSensorData(response, 14),
        //                 huSred11: humanoidPABytesToSensorData(response, 15),
        //                 huSred12: humanoidPABytesToSensorData(response, 16),
        //                 huSred13: humanoidPABytesToSensorData(response, 17),
        //                 huSred14: humanoidPABytesToSensorData(response, 18),
        //                 huSred15: humanoidPABytesToSensorData(response, 19),
        //                 huSred16: humanoidPABytesToSensorData(response, 20),
        //             })
        //         } else if (connectedDevice == 'Hexapod') {
        //             this.setState({
        //                 huBattery: hexapodPABytesToSensorData(response, 23),
        //                 huAccelerometerX: hexapodPABytesToSensorData(
        //                     response,
        //                     25
        //                 ),
        //                 huAccelerometerY: hexapodPABytesToSensorData(
        //                     response,
        //                     26
        //                 ),
        //                 huAccelerometerZ: hexapodPABytesToSensorData(
        //                     response,
        //                     27
        //                 ),
        //                 huGyroX: hexapodPABytesToSensorData(response, 28),
        //                 huGyroY: hexapodPABytesToSensorData(response, 29),
        //                 huGyroZ: hexapodPABytesToSensorData(response, 30),
        //                 rangeA1: hexapodPABytesToSensorData(response, 31),
        //                 rangeA2: hexapodPABytesToSensorData(response, 32),
        //                 rangeB1: hexapodPABytesToSensorData(response, 33),
        //                 rangeB2: hexapodPABytesToSensorData(response, 34),
        //                 rangeC1: hexapodPABytesToSensorData(response, 35),
        //                 rangeC2: hexapodPABytesToSensorData(response, 36),
        //                 rangeD1: hexapodPABytesToSensorData(response, 37),
        //                 rangeD2: hexapodPABytesToSensorData(response, 38),

        //                 huUltrasonic: hexapodPABytesToSensorData(response, 24),
        //                 huSred1: hexapodPABytesToSensorData(response, 5),
        //                 huSred2: hexapodPABytesToSensorData(response, 6),
        //                 huSred3: hexapodPABytesToSensorData(response, 7),
        //                 huSred4: hexapodPABytesToSensorData(response, 8),
        //                 huSred5: hexapodPABytesToSensorData(response, 9),
        //                 huSred6: hexapodPABytesToSensorData(response, 10),
        //                 huSred7: hexapodPABytesToSensorData(response, 11),
        //                 huSred8: hexapodPABytesToSensorData(response, 12),
        //                 huSred9: hexapodPABytesToSensorData(response, 13),
        //                 huSred10: hexapodPABytesToSensorData(response, 14),
        //                 huSred11: hexapodPABytesToSensorData(response, 15),
        //                 huSred12: hexapodPABytesToSensorData(response, 16),
        //                 huSred13: hexapodPABytesToSensorData(response, 17),
        //                 huSred14: hexapodPABytesToSensorData(response, 18),
        //                 huSred15: hexapodPABytesToSensorData(response, 19),
        //                 huSred16: hexapodPABytesToSensorData(response, 20),
        //                 huSred17: hexapodPABytesToSensorData(response, 21),
        //                 huSred18: hexapodPABytesToSensorData(response, 22),
        //             })
        //         }
        //     }
        // )
    }

    setPaBytes_Hexapod = () => {
        // let humanoidPortData = JSON.parse(
        //     sessionStorage.getItem('humanoidPortData')
        // )
        let sendBytes = [...HEXAPOD_PA_SEND_BYTES]

        if (!this.props.webSerial.isConnected) {
            window.location.reload()
            return
        }

        sessionStorage.setItem('isReadingZingPA', this.state.isReading)
        // this.setState({
        //     isReading: !this.state.isReading,
        // })
        let portdata = JSON.parse(sessionStorage.getItem('assemblyTwo'))

        Object.keys(portdata.PortConnections).map((port) => {
            if (portdata.PortConnections[port] != null) {
                if (port === 'A' || port === 'A1' || port === 'A2') {
                    let Type = portdata.PortConnections[port].type

                    if (Type == 'ultrasonic_sensor') {
                        sendBytes[2] = 'U'.charCodeAt()
                        sendBytes[3] = 'U'.charCodeAt()
                        // bytesData[3] = "I".charCodeAt();
                    } else if (Type == 'pcAiTool') {
                        sendBytes[2] = 'L'
                    } else if (
                        Type == 'tact_switch' ||
                        Type == 'touch_sensor' ||
                        Type == 'dual_switch' ||
                        Type == 'metal_detector' ||
                        Type == 'dip_switch'
                    ) {
                        if (port == 'A') {
                            sendBytes[2] = 'I'.charCodeAt()
                            sendBytes[3] = 'I'.charCodeAt()
                        }
                        if (port == 'A1') {
                            sendBytes[2] = 'I'.charCodeAt()
                        }
                        if (port == 'A2') {
                            sendBytes[3] = 'I'.charCodeAt()
                        }
                    } else if (
                        Type == 'distance_sensor' ||
                        Type == 'temperature_sensor' ||
                        Type == 'gas' ||
                        Type == 'light_sensor' ||
                        Type == 'linear_pot' ||
                        Type == 'pot' ||
                        Type == 'rain_sensor' ||
                        Type == 'metal_detector' ||
                        Type == 'humidity'
                    ) {
                        if (port == 'A') {
                            sendBytes[2] = 'A'.charCodeAt()
                            sendBytes[3] = 'A'.charCodeAt()
                        }
                        if (port == 'A1') {
                            sendBytes[2] = 'A'.charCodeAt()
                        }
                        if (port == 'A2') {
                            sendBytes[3] = 'A'.charCodeAt()
                        }
                    } else if (
                        Type == 'rotatory' ||
                        Type == 'joystick' ||
                        Type == 'extender'
                    ) {
                        sendBytes[2] = 'A'.charCodeAt()
                        sendBytes[3] = 'A'.charCodeAt()
                    }
                } else if (port === 'B' || port === 'B1' || port === 'B2') {
                    let Type = portdata.PortConnections[port].type

                    if (
                        Type == 'rotatory' ||
                        Type == 'joystick' ||
                        Type == 'extender'
                    ) {
                        sendBytes[4] = 'A'.charCodeAt()
                        sendBytes[5] = 'A'.charCodeAt()
                    } else if (
                        Type == 'distance_sensor' ||
                        Type == 'temperature_sensor' ||
                        Type == 'gas' ||
                        Type == 'light_sensor' ||
                        Type == 'linear_pot' ||
                        Type == 'pot' ||
                        Type == 'rain_sensor' ||
                        Type == 'humidity'
                    ) {
                        if (port == 'B') {
                            sendBytes[4] = 'A'.charCodeAt()
                            sendBytes[5] = 'A'.charCodeAt()
                        }
                        if (port == 'B1') {
                            sendBytes[4] = 'A'.charCodeAt()
                        }
                        if (port == 'B2') {
                            sendBytes[5] = 'A'.charCodeAt()
                        }
                    } else if (
                        Type == 'tact_switch' ||
                        Type == 'touch_sensor' ||
                        Type == 'dual_switch' ||
                        Type == 'dip_switch' ||
                        Type == 'metal_detector'
                    ) {
                        if (port == 'B') {
                            sendBytes[4] = 'I'.charCodeAt()
                            sendBytes[5] = 'I'.charCodeAt()
                        }
                        if (port == 'B1') {
                            sendBytes[4] = 'I'.charCodeAt()
                        }
                        if (port == 'B2') {
                            sendBytes[5] = 'I'.charCodeAt()
                        }
                    }
                } else if (port === 'C' || port === 'C1' || port === 'C2') {
                    let Type = portdata.PortConnections[port].type
                    let connectedDevice =
                        sessionStorage.getItem('deviceConnected')
                    if (Type == 'ultrasonic_sensor') {
                        sendBytes[6] = 'U'.charCodeAt()
                        sendBytes[7] = 'U'.charCodeAt()
                    } else if (
                        Type == 'tact_switch' ||
                        Type == 'touch_sensor' ||
                        Type == 'metal_detector' ||
                        Type == 'dual_switch' ||
                        Type == 'dip_switch'
                    ) {
                        if (port == 'C') {
                            sendBytes[6] = 'I'.charCodeAt()
                            sendBytes[7] = 'I'.charCodeAt()
                        }
                        if (port == 'C1') {
                            sendBytes[6] = 'I'.charCodeAt()
                        }
                        if (port == 'C2') {
                            sendBytes[7] = 'I'.charCodeAt()
                        }
                    } else if (
                        Type == 'distance_sensor' ||
                        Type == 'temperature_sensor' ||
                        Type == 'gas' ||
                        Type == 'light_sensor' ||
                        Type == 'linear_pot' ||
                        Type == 'pot' ||
                        Type == 'rain_sensor' ||
                        Type == 'humidity'
                    ) {
                        if (port == 'C') {
                            sendBytes[6] = 'A'.charCodeAt()
                            sendBytes[7] = 'A'.charCodeAt()
                        }
                        if (port == 'C1') {
                            sendBytes[6] = 'A'.charCodeAt()
                        }
                        if (port == 'C2') {
                            sendBytes[7] = 'A'.charCodeAt()
                        }
                    } else if (
                        Type == 'rotatory' ||
                        Type == 'joystick' ||
                        Type == 'extender'
                    ) {
                        sendBytes[6] = 'A'.charCodeAt()
                        sendBytes[7] = 'A'.charCodeAt()
                    }
                } else if (port === 'D' || port === 'D1' || port === 'D2') {
                    let Type = portdata.PortConnections[port].type

                    if (Type == 'ultrasonic_sensor') return
                    // bytesData[7] = "A".charCodeAt();
                    // } else if (
                    //     Type == 'tact_switch' ||
                    //     Type == 'touch_sensor' ||
                    //     Type == 'metal_detector' ||
                    //     Type == 'dual_switch' ||
                    //     Type == 'dip_switch'
                    // ) {
                    //     if (port == 'D') {
                    //         HUMANOID_PA_SEND_BYTES[8] = 'I'.charCodeAt()
                    //         HUMANOID_PA_SEND_BYTES[9] = 'I'.charCodeAt()
                    //     }
                    //     if (port == 'D1')
                    //         HUMANOID_PA_SEND_BYTES[8] = 'I'.charCodeAt()
                    //     if (port == 'C2')
                    //         HUMANOID_PA_SEND_BYTES[9] = 'I'.charCodeAt()
                    // } else if (
                    //     Type == 'distance_sensor' ||
                    //     Type == 'temperature_sensor' ||
                    //     Type == 'gas' ||
                    //     Type == 'light_sensor' ||
                    //     Type == 'linear_pot' ||
                    //     Type == 'pot' ||
                    //     Type == 'rain_sensor' ||
                    //     Type == 'humidity'
                    // ) {
                    //     if (port == 'D') {

                    //     }
                    //     if (port == 'D1')

                    //     if (port == 'D2')

                    // } else if (
                    //     Type == 'rotatory' ||
                    //     Type == 'joystick' ||
                    //     Type == 'extender'
                    // ) {

                    // }
                }
            }
        })

        sendBytes[8] = this.state.humanoidPortData['24'].isPortSelected
            ? 'U'.charCodeAt(0)
            : 'O'.charCodeAt(0)
        // sendBytes[9] = humanoidPortData['4b'].isPortSelected
        //     ? 'S'.charCodeAt(0)
        //     : 'O'.charCodeAt(0)
        let isAMPUEnable = false
        for (let i = 0; i < 6; i++) {
            if (this.state.humanoidPortData[25 + i].isPortSelected) {
                isAMPUEnable = true
                break
            }
        }
        sendBytes[9] = isAMPUEnable ? 'A'.charCodeAt(0) : 'O'.charCodeAt(0)
        // sendBytes[9] = 'O'.charCodeAt(0)
        sendBytes[10] = this.state.humanoidPortData['23'].isPortSelected
            ? 'B'.charCodeAt(0)
            : 'O'.charCodeAt(0)

        let deviceVersion = sessionStorage.getItem('deviceVersion')
        let connectedDevice = sessionStorage.getItem('connectedDevice')
        console.log('OOOOOOOOOOOOO', sendBytes)

        // if (connectedDevice == 'Hexapod' && deviceVersion.includes('2.0')) {
        //     this.handleReadBytes_Hexapod(sendBytes)

        return sendBytes
        // continousPABytesReadToggle(
        //     sendBytes,
        //     54,
        //     this.props.webSerial.port,
        //     (response) => {
        //         console.log('assembly screen', response)
        //         if (!this.state.isReading) {
        //             this.setState({
        //                 huBattery: '',

        //                 huUltrasonic: '',
        //                 huSred1: '',
        //                 huSred2: '',
        //                 huSred3: '',
        //                 huSred4: '',
        //                 huSred5: '',
        //                 huSred6: '',
        //                 huSred7: '',
        //                 huSred8: '',
        //                 huSred9: '',
        //                 huSred10: '',
        //                 huSred11: '',
        //                 huSred12: '',
        //                 huSred13: '',
        //                 huSred14: '',
        //                 huSred15: '',
        //                 huSred16: '',
        //                 huSred17: '',
        //                 huSred18: '',

        //                 huAccelerometerX: '',
        //                 huAccelerometerY: '',
        //                 huAccelerometerZ: '',
        //                 huGyroX: '',
        //                 huGyroY: '',
        //                 huGyroZ: '',
        //                 rangeA1: '',
        //                 rangeA2: '',
        //                 rangeB1: '',
        //                 rangeB2: '',
        //                 rangeC1: '',
        //                 rangeC2: '',
        //                 rangeD1: '',
        //                 rangeD2: '',
        //             })
        //             return
        //         }

        //         this.setState({
        //             huBattery: hexapodPABytesToSensorData(response, 23),
        //             huAccelerometerX: hexapodPABytesToSensorData(response, 25),
        //             huAccelerometerY: hexapodPABytesToSensorData(response, 26),
        //             huAccelerometerZ: hexapodPABytesToSensorData(response, 27),
        //             huGyroX: hexapodPABytesToSensorData(response, 28),
        //             huGyroY: hexapodPABytesToSensorData(response, 29),
        //             huGyroZ: hexapodPABytesToSensorData(response, 30),
        //             rangeA1: hexapodPABytesToSensorData(response, 31),
        //             rangeA2: hexapodPABytesToSensorData(response, 32),
        //             rangeB1: hexapodPABytesToSensorData(response, 33),
        //             rangeB2: hexapodPABytesToSensorData(response, 34),
        //             rangeC1: hexapodPABytesToSensorData(response, 35),
        //             rangeC2: hexapodPABytesToSensorData(response, 36),
        //             rangeD1: hexapodPABytesToSensorData(response, 37),
        //             rangeD2: hexapodPABytesToSensorData(response, 38),

        //             huUltrasonic: hexapodPABytesToSensorData(response, 24),
        //             huSred1: hexapodPABytesToSensorData(response, 5),
        //             huSred2: hexapodPABytesToSensorData(response, 6),
        //             huSred3: hexapodPABytesToSensorData(response, 7),
        //             huSred4: hexapodPABytesToSensorData(response, 8),
        //             huSred5: hexapodPABytesToSensorData(response, 9),
        //             huSred6: hexapodPABytesToSensorData(response, 10),
        //             huSred7: hexapodPABytesToSensorData(response, 11),
        //             huSred8: hexapodPABytesToSensorData(response, 12),
        //             huSred9: hexapodPABytesToSensorData(response, 13),
        //             huSred10: hexapodPABytesToSensorData(response, 14),
        //             huSred11: hexapodPABytesToSensorData(response, 15),
        //             huSred12: hexapodPABytesToSensorData(response, 16),
        //             huSred13: hexapodPABytesToSensorData(response, 17),
        //             huSred14: hexapodPABytesToSensorData(response, 18),
        //             huSred15: hexapodPABytesToSensorData(response, 19),
        //             huSred16: hexapodPABytesToSensorData(response, 20),
        //             huSred17: hexapodPABytesToSensorData(response, 21),
        //             huSred18: hexapodPABytesToSensorData(response, 22),
        //         })
        //     }
        // )
    }
    handleUsb = (e) => {
        if (this.state.isusb) {
            this.setState({
                isusb: false,
            })
        } else {
            this.setState({
                isusb: true,
            })
        }
    }
    helpBtn = (e) => {
        this.setState({ isHelp: !this.state.isHelp })
    }

    goBack = () => {
        // history.push('/playdynamexNew')
        // window.location.reload()
        history.back()
    }

    handleHeaderTabClick = (index) => {
        if (index > 3) {
            return
        }

        this.stopPaOnBack()

        if (index === 0) {
            this.props.history.push('/playdynamexNew')
        }
        if (index === 1) {
            if (!sessionStorage.getItem('connectedDevice')) {
                sessionStorage.setItem(
                    'connectedDevice',
                    sessionStorage.getItem('allowedDevice') || 'Toki'
                )
                sessionStorage.setItem('deviceVersion', '1')
            }
            this.props.history.push('/assemblyTwo')
        }
        if (index === 2) {
            this.props.history.push('/logicTwo')
        }
        if (index === 3) {
            this.props.history.push('/SimulateNew')
        }
    }

    refreshAssemblyAccessories = async () => {
        try {
            if (this.props.data) {
                processAssemblyAccessoriesFromData(this.props.data)
            } else {
                // Extract safely and pass explicitly
                const apiProjectId = this.getCurrentProjectId()
                const apiScreenId = this.getCurrentScreenId()
                const urlParams = new URLSearchParams(
                    this.props.location?.search || window.location.search
                )
                const isPreview = urlParams.get('preview') === 'true'

                // Pass apiScreenId down to your API function
                await fetchAssemblyAccessories(
                    apiProjectId,
                    isPreview,
                    apiScreenId
                )
            }
            if (!this.isComponentMounted) return

            // Sync redux with updated sessionStorage data.
            // IMPORTANT: Dispatch concept-related actions FIRST because the
            // componentSelection reducer's default case writes its current
            // state to sessionStorage('concept') on every unhandled action.
            // If we dispatch assemblyTwo actions first, the default case
            // overwrites sessionStorage with stale Redux state.
            try {
                const updatedConcept = JSON.parse(
                    sessionStorage.getItem('concept')
                )
                if (updatedConcept?.internalaccessories) {
                    this.props.updateInternalAccessories(
                        updatedConcept.internalaccessories
                    )
                }
                if (updatedConcept?.componentProps) {
                    this.props.updateComponentProps(
                        updatedConcept.componentProps
                    )
                }
                if (updatedConcept?.counter) {
                    this.props.updateComponentSelection(updatedConcept.counter)
                }

                const updatedAssemblyTwo = JSON.parse(
                    sessionStorage.getItem('assemblyTwo')
                )
                if (updatedAssemblyTwo?.PortConnections) {
                    this.props.PortConnections(
                        updatedAssemblyTwo.PortConnections
                    )
                }
                // --- NEW HEALING LOGIC HERE ---
                if (updatedAssemblyTwo?.workspace) {
                    const { newWorkspace, needsUpdate } =
                        this.healWorkspaceCoordinates(
                            updatedAssemblyTwo.workspace
                        )
                    this.props.assemblyComponent(newWorkspace) // If we fixed broken coordinates, save them back to memory immediately

                    if (needsUpdate) {
                        updatedAssemblyTwo.workspace = newWorkspace
                        sessionStorage.setItem(
                            'assemblyTwo',
                            JSON.stringify(updatedAssemblyTwo)
                        )
                    }
                }

                if (updatedAssemblyTwo?.workspace) {
                    this.props.assemblyComponent(updatedAssemblyTwo.workspace)
                }

                // Re-write sessionStorage('concept') as a safeguard.
                // The componentSelection reducer's default case can overwrite
                // it with stale data when unrelated actions are dispatched.
                sessionStorage.setItem(
                    'concept',
                    JSON.stringify(updatedConcept)
                )
            } catch (syncErr) {
                console.error('Failed to sync redux after API fetch', syncErr)
            }

            this.setState((prevState) => ({ refresh: !prevState.refresh }))
        } catch (error) {
            console.error('Failed to refresh assembly accessories', error)
        }
    }

    loadAssemblySteps = async () => {
        try {
            let stepsData
            if (this.props.data) {
                stepsData = normalizeSteps(this.props.data)
                console.log('stepsData', stepsData)
            } else {
                // Fix: Get project ID from our single source of truth function
                const apiProjectId = this.getCurrentProjectId()
                const apiScreenId = this.getCurrentScreenId()
                const urlParams = new URLSearchParams(
                    this.props.location?.search || window.location.search
                )
                const isPreview = urlParams.get('preview') === 'true'

                // Pass apiScreenId down to your API function
                stepsData = await fetchAssemblySteps(
                    apiProjectId,
                    isPreview,
                    apiScreenId
                )
            }

            if (!this.isComponentMounted) return

            const urlParams = new URLSearchParams(window.location.search)
            const isPreviewMode = urlParams.get('preview') === 'true'

            const storageKey = `assembly_step_${this.getCurrentProjectId()}_${this.getCurrentScreenId() || 'default'}`

            // 1. Retrieve the saved step or incoming initial step
            let savedStep = 0
            const shouldResetConnections =
                this._isProjectChanged || isPreviewMode

            // FIXED: Prioritize initialStep from ContentEngine when jumping from another screen
            if (
                this.props.initialStep !== undefined &&
                this.props.initialStep !== null
            ) {
                savedStep = this.props.initialStep - 1 // Convert 1-based to 0-based
                sessionStorage.setItem(storageKey, savedStep.toString())
            } else if (!shouldResetConnections) {
                const savedStepStr = sessionStorage.getItem(storageKey)
                savedStep =
                    savedStepStr && !isNaN(savedStepStr)
                        ? parseInt(savedStepStr, 10)
                        : 0
            } else {
                // Clear all visual connections and port connections
                const workspace = { ...this.props.assemblyTwo.workspace }
                workspace.components = {}
                this.props.assemblyComponent(workspace)

                const clearedPorts = {}
                Object.keys(this.props.assemblyTwo.PortConnections).forEach(
                    (key) => {
                        clearedPorts[key] = null
                    }
                )
                this.props.PortConnections(clearedPorts)
            }

            // 2. Ensure the saved step doesn't exceed the available steps
            const totalSlides = this.getStepsSlideCount(stepsData)
            if (savedStep >= totalSlides && totalSlides > 0) {
                savedStep = totalSlides - 1
            }

            this.setState(
                {
                    assemblySteps: stepsData,
                    stepsSlideIndex: savedStep,
                    aiVoiceover:
                        sessionStorage.getItem('aiVoiceToggle') !== 'false',
                    subtitleVisible: false,
                    showSubtitleDisplay: false,
                    aiSpeaking: true,
                },
                () => {
                    // 3. FIXED: Rebuild the actual logic AND apply visuals
                    // (This handles cross-screen jumps)
                    this.buildWorkspaceForStep(savedStep, { updateUI: true })
                    // Correct step is built — safe to reveal the board now.
                    this.setState({ stepsReady: true })
                    this._syncShellProps()

                    // 4. Ensure the correct subtitle appears for the saved step
                    const isFinalSlide = savedStep === stepsData?.steps?.length
                    const instruction = isFinalSlide
                        ? stepsData?.finalStepInstruction ||
                          'Congratulations on completing your electronic connections! Click Continue to proceed.'
                        : stepsData?.steps?.[savedStep]?.instruction || ''

                    this.runTypewriterEffect(instruction)

                    if (this.state.aiVoiceover) {
                        this.playAudioForStepWhenReady(savedStep)
                    }

                    // Slide in the subtitle box after a short delay
                    setTimeout(
                        () =>
                            this.setState({
                                subtitleVisible: true,
                                showSubtitleDisplay: true,
                            }),
                        50
                    )
                }
            )
        } catch (error) {
            console.error('Failed to load assembly steps', error)
            // Never leave the board gated on error — reveal whatever we have.
            if (this.isComponentMounted) this.setState({ stepsReady: true })
        }
    }

    getStepsSlideCount = (stepsData) => {
        if (!stepsData) return 0
        const stepCount = Array.isArray(stepsData.steps)
            ? stepsData.steps.length
            : 0
        // Each step is now 1 slide, (plus 1 if you wanna count the final "Continue" screen)
        return stepCount + 1
    }

    getStepComponentPosition = (port, workspace, componentType) => {
        const fallback = {
            left: workspace?.bibox?.left || 100,
            top: workspace?.bibox?.top || 100,
        }

        // Define Hardcoded Offsets for Toki Board (Relative to board's top-left corner)
        // You may need to tweak these numbers slightly based on your exact image size
        const tokiPortOffsets = {
            A1: [20, 120],
            A2: [197, 120],
            servo_motor1: [68, 12],
            servo_motor2: [147, 12],
            M1: [20, 300],
            M3: [205, 300],
        }

        const pokiPortOffsets = {
            A1: [-80, 0],
            A2: [300, 0],
            servo_motor1: [20, -100],
            servo_motor2: [200, -100],
            A1: [-80, 0],
            A2: [300, 0],
            E: [-120, 100],
            E1: [-120, 100],
            E2: [-120, 100],
            B2: [600, 80],
            C1: [-90, 240],
            D2: [570, 220],
            C2: [-40, 380],
            D1: [520, 340],
            B1: [40, 450],
            F: [460, 440],
            F1: [460, 440],
            F2: [460, 440],
            M1: [90, 380],
            M3: [160, 380],
        }

        // 3. Determine the Port Offset
        let portOffset = null
        const connectedDevice = sessionStorage.getItem('connectedDevice')

        if (connectedDevice === 'Toki' && tokiPortOffsets[port]) {
            // Use our hardcoded Toki values
            portOffset = tokiPortOffsets[port]
        } else if (connectedDevice === 'Poki' && pokiPortOffsets[port]) {
            // Use the existing Ports file logic for other devices
            portOffset = pokiPortOffsets[port]
        } else {
            // Use the existing Ports file logic for other devices
            portOffset = Ports(port)
        }

        if (!Array.isArray(portOffset)) {
            return fallback
        }

        // 4. Calculate Component Adjustments (Centering)
        // This removes the generic "-80/-60" and calculates specific offsets
        // so the component's wire hits the port exactly.
        let componentAdjustX = 0
        let componentAdjustY = 0

        if (
            [
                'dc_motor',
                'mini_geared_motor',
                'geared_motor',
                'dynamex_motor',
                'servo_motor',
                'servo_motor_270',
                'servo_motor_360',
            ].includes(componentType)
        ) {
            // Motors/servos are usually drawn with the wire at the top-left or center
            // Adjust these to shift the motor image relative to the port point
            componentAdjustX = 100
            componentAdjustY = 50
        } else {
            // Default adjustment for other sensors to center them
            componentAdjustX = 120
            componentAdjustY = 60
        }

        // Ports which are on the right side of the board
        if (port === 'M3' || port === 'servo_motor2' || port === 'A2') {
            componentAdjustX *= -1
        }

        // 5. Return Final Position
        // Device Position + Port Offset - Component Adjustment
        return {
            left:
                (workspace?.bibox?.left || 0) +
                portOffset[0] -
                componentAdjustX,
            top:
                (workspace?.bibox?.top || 0) + portOffset[1] - componentAdjustY,
        }
    }

    applyPortConnection = (portConnections, componentType, index, port) => {
        const nextConnections = { ...portConnections }
        const connectedDevice = sessionStorage.getItem('connectedDevice')
        const isTokiFamily = ['Toki', 'Poki'].includes(connectedDevice)

        const connectPort = (portName) => {
            nextConnections[portName] = { type: componentType, index }
        }

        connectPort(port)
        if (!isTokiFamily && port === 'M1') {
            connectPort('M2')
        }
        if (!isTokiFamily && port === 'M3') {
            connectPort('M4')
        }

        // console.log('Next Port Connections:', nextConnections)

        return nextConnections
    }

    // === MAGNIFIER MULTI-PIN WIRE HELPERS ===
    // Per-pin connections live on each component instance as `pinConnections`
    // ({ '+': port|null, '-': port|null, S1: port|null }). `connectedTo` is derived:
    // it is set only when EVERY pin is wired, which is what populates redux
    // PortConnections and lets the tutorial step advance — making a fully manual
    // connection behave exactly like dropping the component on its port.
    getPinConnections = (type, index) => {
        const comp =
            this.props.assemblyTwo?.workspace?.components?.[type]?.[index]
        return comp && comp.pinConnections ? comp.pinConnections : {}
    }

    // Called at drag-start: if a Poki component needs + / - but no free power
    // pin exists anywhere on the board, it can't connect — warn immediately
    // (the drop will be rejected and no port is highlighted for it). `skip`
    // excludes the dragged instance so it can reclaim its own freed slots.
    // Returns true if blocked.
    warnIfPowerBlocked = (type, skip) => {
        const device = sessionStorage.getItem('connectedDevice')
        if (device !== 'Poki') return false
        const cfg = getHardwareWireConfig(type, device)
        if (!cfg) return false
        const components =
            this.props.assemblyTwo?.workspace?.components || {}
        const result = computeAutoDropPinConnections(
            Ports,
            type,
            null,
            device,
            components,
            skip || null
        )
        if (!result || result.allConnected) return false
        const missing = ['+', '-'].filter(
            (pk) => cfg.pins[pk] && !result.pinConnections[pk]
        )
        const label = missing.join(' / ')
        this.showTutorialMessage?.(
            `All ${label} power pins are occupied. Disconnect one to wire this component's ${label}.`,
            'warning'
        )
        return true
    }

    setPinConnections = (type, index, pinConnections) => {
        const workspace = { ...this.props.assemblyTwo.workspace }
        const components = { ...workspace.components }
        const list = [...(components[type] || [])]
        if (!list[index]) return

        const config = HardwareWireConfigs[type]
        const pinKeys = config ? Object.keys(config.pins) : []
        const allConnected =
            pinKeys.length > 0 && pinKeys.every((k) => pinConnections[k])
        // The signal pin decides which port the component is logically connected to.
        // Prefer the explicit isSignal flag; fall back to the first non-power pin.
        const signalPin =
            pinKeys.find((k) => config.pins[k].isSignal) ||
            pinKeys.find((k) => k !== '+' && k !== '-')

        const prevConnectedTo = list[index].connectedTo
        const updated = { ...list[index], pinConnections }
        if (allConnected) {
            let resolved = signalPin
                ? pinConnections[signalPin]
                : pinConnections[pinKeys[0]]
            // Whole-socket component (2+ signal wires into aliases of ONE grouped
            // socket, e.g. OLED's E1 + E2 → the E socket): it connects logically to
            // the group PARENT (E), matching an auto-drop onto E. Single-signal
            // components keep their specific alias (e.g. Digital → F1).
            const device = sessionStorage.getItem('connectedDevice')
            const wholeSocketParent = getWholeSocketParent(
                type,
                device,
                getPortGroup
            )
            if (wholeSocketParent) resolved = wholeSocketParent
            updated.connectedTo = resolved
        } else {
            delete updated.connectedTo
        }
        list[index] = updated
        components[type] = list
        workspace.components = components
        this.props.assemblyComponent(workspace)

        // Mirror connected/disconnected state into redux PortConnections so the
        // tutorial step logic sees it exactly like a drop-on-port connection.
        const nextPC = { ...this.props.assemblyTwo.PortConnections }
        if (prevConnectedTo) nextPC[prevConnectedTo] = null
        if (allConnected) nextPC[updated.connectedTo] = { type, index }
        this.props.PortConnections(nextPC)
    }

    // A component is LOCKED once the tutorial has advanced past the step that
    // placed it. Locked components belong to steps strictly before the current
    // slide index, so they can no longer be removed or re-wired — this prevents
    // users from breaking an already-completed step. The active step's component
    // is wired to steps[stepsSlideIndex].port, which is never in the completed
    // slice, so it stays fully editable.
    isComponentLocked = (type, index) => {
        const { assemblySteps, stepsSlideIndex } = this.state
        if (!assemblySteps || !Array.isArray(assemblySteps.steps)) return false

        const completedSteps = assemblySteps.steps.slice(0, stepsSlideIndex)
        if (completedSteps.length === 0) return false

        const comp =
            this.props.assemblyTwo?.workspace?.components?.[type]?.[index]
        if (!comp) return false

        const device = sessionStorage.getItem('connectedDevice')

        // The instance belongs to a completed step when its type matches the
        // step's component and it is wired to that step's port — checked against
        // the whole port group and the per-pin map so multi-wire components count.
        return completedSteps.some((step) => {
            if (step.component !== type) return false
            const group = getPortGroup(device, step.port)
            if (comp.connectedTo && group.includes(comp.connectedTo)) return true
            if (comp.pinConnections) {
                return Object.values(comp.pinConnections).some(
                    (p) => p && group.includes(p)
                )
            }
            return false
        })
    }

    // --- Inline tutorial notice (near the footer) ---------------------------
    // Turn a component type id into a readable label for messages.
    prettyComponentName = (type) =>
        type ? String(type).replace(/_/g, ' ') : 'component'

    // Show a dismissible notice that auto-hides. Re-showing the same text just
    // restarts the timer so rapid repeated clicks don't flicker the box.
    showTutorialMessage = (text, tone = 'warning') => {
        if (this.tutorialMessageTimer) clearTimeout(this.tutorialMessageTimer)
        this.setState({ tutorialMessage: { text, tone } })
        this.tutorialMessageTimer = setTimeout(() => {
            this.tutorialMessageTimer = null
            if (this.isComponentMounted)
                this.setState({ tutorialMessage: null })
        }, 4500)
    }

    dismissTutorialMessage = () => {
        if (this.tutorialMessageTimer) clearTimeout(this.tutorialMessageTimer)
        this.tutorialMessageTimer = null
        this.setState({ tutorialMessage: null })
    }

    // A locked component (belonging to a completed step) was interacted with.
    notifyLockedComponent = () => {
        this.showTutorialMessage(
            'This component is part of a completed step and is locked. Finish or revisit that step to change it.',
            'locked'
        )
    }

    // A sidebar component that isn't required for the current step was clicked.
    notifyBlockedSidebarComponent = () => {
        const expected = this.prettyComponentName(
            this.state.highlightComponentType
        )
        this.showTutorialMessage(
            this.state.highlightComponentType
                ? `That component isn't needed for this step. Add the highlighted ${expected} to continue.`
                : "That component isn't needed for this step.",
            'warning'
        )
    }

    // Start dragging a pin's wire from the cursor. If the pin is already wired,
    // disconnect it first so the user can re-route it.
    startPinWire = (type, index, pinKey) => {
        // Locked components (from completed steps) can't be re-wired.
        if (this.isComponentLocked(type, index)) {
            this.notifyLockedComponent()
            return
        }
        let current = this.getPinConnections(type, index)
        const comp =
            this.props.assemblyTwo?.workspace?.components?.[type]?.[index]
        // Legacy/restored components only have `connectedTo` (no per-pin map). Treat
        // those as every pin wired to that port so an individual pin can be re-routed.
        if (
            (!current || Object.keys(current).length === 0) &&
            comp &&
            comp.connectedTo
        ) {
            const config = HardwareWireConfigs[type]
            current = {}
            if (config) {
                Object.keys(config.pins).forEach((pk) => {
                    current[pk] = comp.connectedTo
                })
            }
        }
        if (current[pinKey]) {
            this.setPinConnections(type, index, {
                ...current,
                [pinKey]: null,
            })
        }
        this.setState({
            activeRgbWire: pinKey,
            activeRgbComponent: { type, index },
        })
    }

    // Drop the currently-routing pin onto a target port.
    connectActivePinToPort = (portName) => {
        const { activeRgbWire, activeRgbComponent } = this.state
        if (!activeRgbWire || !activeRgbComponent) return
        const { type, index } = activeRgbComponent

        // Grouped sockets (e.g. Poki E/E1/E2, F/F1/F2 are each one physical socket):
        // refuse to wire this pin to `portName` if any alias in its group is already
        // held by a DIFFERENT component. Re-routing this component's own pin within
        // the group is still allowed. Mirrors the drop guard in IsOverPort so the
        // magnifier hint-click path can't sneak a second component into the socket.
        const device = sessionStorage.getItem('connectedDevice')
        const PC = this.props.assemblyTwo.PortConnections || {}
        const blocked = getPortGroup(device, portName).some((alias) => {
            const c = PC[alias]
            return c && !(c.type === type && c.index === index)
        })
        if (blocked) return

        const current = this.getPinConnections(type, index)
        this.setPinConnections(type, index, {
            ...current,
            [activeRgbWire]: portName,
        })
        if (sessionStorage.getItem('connectedDevice') !== 'Poki') {
            this.setState({ activeRgbWire: null, activeRgbComponent: null })
        }
    }

    applyConnectionStep = (step) => {
        if (!step) return

        const workspace = { ...this.props.assemblyTwo.workspace }
        const components = { ...workspace.components }
        const componentType = step.component
        const port = step.port

        const list = Array.isArray(components[componentType])
            ? [...components[componentType]]
            : [] // 1. Check if there is ALREADY a component of this type connected to THIS port

        let componentIndex = list.findIndex((item) => item.connectedTo === port) // 2. If not found, check if there is an unconnected component of this type lying around

        if (componentIndex === -1) {
            componentIndex = list.findIndex((item) => !item.connectedTo)
        } // 3. If STILL not found (-1), create a brand new one

        if (componentIndex === -1) {
            const position = this.getStepComponentPosition(
                port,
                workspace,
                componentType
            )
            componentIndex = list.length
            list.push({
                left: position.left,
                top: position.top,
                connectedTo: port,
            })
        } else {
            // 4. Otherwise, update the existing one (unconnected or already on this port)
            list[componentIndex] = {
                ...list[componentIndex],
                connectedTo: port,
            }
        }

        // Poki: seed the per-pin map so + / - distribute across free pins instead
        // of every step's component piling its power wires onto the shared
        // fallbackPins rail. Uses the same routing as auto-drop/drag so footer
        // "next" placement looks identical to dragging the component in.
        const device = sessionStorage.getItem('connectedDevice')
        if (device === 'Poki' && getHardwareWireConfig(componentType, device)) {
            const result = computeAutoDropPinConnections(
                Ports,
                componentType,
                port,
                device,
                components,
                { type: componentType, index: componentIndex }
            )
            if (result) {
                list[componentIndex] = {
                    ...list[componentIndex],
                    pinConnections: result.pinConnections,
                }
            }
        }

        components[componentType] = list
        console.log('components are', components)
        workspace.components = components

        this.props.assemblyComponent(workspace)

        const nextPortConnections = this.applyPortConnection(
            this.props.assemblyTwo.PortConnections,
            componentType,
            componentIndex,
            port
        )
        console.log('nextPortConnections', nextPortConnections)

        this.props.PortConnections(nextPortConnections)
    }

    healWorkspaceCoordinates = (workspace) => {
        if (!workspace || !workspace.components)
            return { newWorkspace: workspace, needsUpdate: false }

        let needsUpdate = false
        const newWorkspace = JSON.parse(JSON.stringify(workspace))

        Object.keys(newWorkspace.components).forEach((compType) => {
            newWorkspace.components[compType].forEach((item) => {
                // If item is stuck at top-left (0,0), it's corrupted and needs healing
                if (
                    (item.left === 0 || item.left < 20) &&
                    (item.top === 0 || item.top < 20) &&
                    item.connectedTo
                ) {
                    console.log(
                        `Healing coordinates for ${compType} on port ${item.connectedTo}`
                    )
                    const fixedPos = this.getStepComponentPosition(
                        item.connectedTo,
                        newWorkspace,
                        compType
                    )
                    item.left = fixedPos.left
                    item.top = fixedPos.top
                    needsUpdate = true
                }
            })
        })

        return { newWorkspace, needsUpdate }
    }

    applyAssemblyVisualForSlide = (slideIndex, stepsDataParam) => {
        const stepsData = stepsDataParam || this.state.assemblySteps
        if (!stepsData || !Array.isArray(stepsData.steps)) return

        const totalSlides = this.getStepsSlideCount(stepsData)
        const boundedIndex = Math.max(0, Math.min(slideIndex, totalSlides - 1))

        // Determine if we are on the final "Success" slide
        const isFinalSlide = boundedIndex === stepsData.steps.length

        if (isFinalSlide) {
            this.setState({
                stepsSlideIndex: boundedIndex,
                highlightComponentType: null,
                highlightPort: null,
                isForced: false,
            })
        } else {
            const step = stepsData.steps[boundedIndex]
            this.setState(
                {
                    stepsSlideIndex: boundedIndex,
                    highlightComponentType: step.component, // Always highlight the current step's component
                    highlightPort: step.port, // Highlight the port as well
                },
                () => {
                    this.checkTutorialDeviation()
                }
            )
        }
    }

    removeConnectionStep = (step) => {
        if (!step) return

        // --- 1. Remove from Visual Workspace ---
        const workspace = { ...this.props.assemblyTwo.workspace }
        const componentType = step.component
        const port = step.port

        // Check if this component type exists in the workspace
        if (workspace.components[componentType]) {
            // Filter out the specific component instance connected to this port
            workspace.components[componentType] = workspace.components[
                componentType
            ].filter((item) => item.connectedTo !== port)

            // Save visual state
            this.props.assemblyComponent(workspace)
        }

        // --- 2. Remove from Logical Port Connections ---
        const currentConnections = { ...this.props.assemblyTwo.PortConnections }
        const connectedDevice = sessionStorage.getItem('connectedDevice')
        const isTokiFamily = ['Toki', 'Poki'].includes(connectedDevice)

        // Helper to set port to null
        const disconnect = (p) => {
            currentConnections[p] = null
        }

        // Disconnect the main port (e.g., "M1" or "A")
        disconnect(port)

        // Handle special multi-port logic (Mirrors your applyPortConnection logic)
        if (componentType === 'pcAiTool') {
            disconnect('A')
            disconnect('A1')
            disconnect('ai_LEDA1')
            disconnect('ai_audioA1')
        } else if (componentType === 'OLED') {
            disconnect('D')
            disconnect('OLEDOne')
            disconnect('OLEDTwo')
            disconnect('OLEDThree')
        } else if (
            [
                'dc_motor',
                'mini_geared_motor',
                'geared_motor',
                'dynamex_motor',
            ].includes(componentType)
        ) {
            // Undo motor logic
            if (!isTokiFamily) {
                if (port === 'M1') disconnect('M2')
                if (port === 'M3') disconnect('M4')
            }
        } else {
            // Undo standard sensor logic (sub-ports)
            if (['A', 'B', 'C', 'D', 'E', 'F'].includes(port)) {
                disconnect(`${port}1`)
                disconnect(`${port}2`)
            }
        }

        // Save logical state
        this.props.PortConnections(currentConnections)
    }

    handleStepsPrev = () => {
        const { data } = this.props
        const { assemblySteps, stepsSlideIndex } = this.state

        if (stepsSlideIndex !== 0) {
            const stepsData = assemblySteps
            if (!stepsData || stepsSlideIndex === 0) return

            const prevStepIndex = stepsSlideIndex - 1

            if (prevStepIndex < stepsData.steps.length) {
                const stepToDisconnect = stepsData.steps[prevStepIndex]
                this.removeConnectionStep(stepToDisconnect)
            }

            const nextIndex = stepsSlideIndex - 1
            this.applyAssemblyVisualForSlide(nextIndex, stepsData)

            if (this.state.aiVoiceover) {
                this.playAudioForStep(nextIndex)
            }

            this.setState({
                stepsSlideIndex: nextIndex,
                aiSpeaking: false,
                showSubtitleDisplay: true,
            })

            return
        }

        const urlParams = new URLSearchParams(window.location.search)
        const isPreviewMode = urlParams.get('preview') === 'true'
        if (isPreviewMode) return

        if (data) {
            ContentEngine.prev()
        } else {
            this.goBack()
        }
    }

    handleStepsNext = () => {
        const stepsData = this.state.assemblySteps
        if (!stepsData) return

        const totalSlides = this.getStepsSlideCount(stepsData)

        // If not on the final slide, ensure the current step is connected before moving on
        if (this.state.stepsSlideIndex < stepsData.steps.length) {
            const currentStep = stepsData.steps[this.state.stepsSlideIndex]
            this.applyConnectionStep(currentStep)
            sessionStorage.setItem('dragingItem', currentStep.component)
        }

        const nextIndex = this.state.stepsSlideIndex + 1

        // If on the final "Done" slide and clicking continue
        if (nextIndex >= totalSlides) {
            // Detect mode from URL
            const urlParams = new URLSearchParams(window.location.search)
            const isPreviewMode = urlParams.get('preview') === 'true'
            if (isPreviewMode) return

            if (this.props.data) {
                ContentEngine.next()
            } else {
                window.location.replace('/deviceSelectionTwo')
                return
            }
        }

        this.applyAssemblyVisualForSlide(nextIndex, stepsData)

        if (this.state.aiVoiceover) {
            this.playAudioForStep(nextIndex)
        }

        this.setState({ aiSpeaking: false, showSubtitleDisplay: true })
    }

    checkTutorialDeviation = () => {
        const stepsData = this.state.assemblySteps
        if (!stepsData || !Array.isArray(stepsData.steps)) {
            this.setState({ tutorialDeviation: false })
            return
        }

        const slideIndex = this.state.stepsSlideIndex
        // We expect connections for all steps BEFORE the current slide index
        const expectedSteps = stepsData.steps.slice(0, slideIndex)

        const expectedConnections = {}
        expectedSteps.forEach((step) => {
            expectedConnections[step.port] = { type: step.component }
        })

        const currentPortConnections =
            this.props.assemblyTwo.PortConnections || {}
        let hasDeviation = false

        // Logic:
        // 1. Are there extra connections?
        Object.keys(currentPortConnections).forEach((port) => {
            if (currentPortConnections[port] !== null) {
                if (!expectedConnections[port]) {
                    // Allow the connection if it matches the CURRENT step (user just dragged it but animation hasn't fired yet)
                    const currentStep = stepsData.steps[slideIndex]
                    if (
                        currentStep &&
                        port === currentStep.port &&
                        currentPortConnections[port].type ===
                            currentStep.component
                    ) {
                        return // This is fine, auto-advance will catch it
                    }
                    hasDeviation = true
                }
            }
        })

        // 2. Are missing expected connections?
        Object.keys(expectedConnections).forEach((port) => {
            if (
                !currentPortConnections[port] ||
                currentPortConnections[port].type !==
                    expectedConnections[port].type
            ) {
                hasDeviation = true
            }
        })

        this.setState({ tutorialDeviation: hasDeviation })
    }

    //  **** THIS IS FOR RESETTING TO THE CURRENT STEP IF THE USER DEVIATES. ****
    buildWorkspaceForStep = (targetSlideIndex, { updateUI = false } = {}) => {
        const stepsData = this.state.assemblySteps
        if (!stepsData || !Array.isArray(stepsData.steps)) return

        // 1. Clear everything locally in memory
        const workspace = { ...this.props.assemblyTwo.workspace }
        workspace.components = {} // This is an object

        const PortConnections = {}
        Object.keys(this.props.assemblyTwo.PortConnections).forEach((key) => {
            PortConnections[key] = null
        })

        // 2. Re-apply steps sequentially strictly BEFORE the target slide index
        for (let i = 0; i < targetSlideIndex; i++) {
            if (i < stepsData.steps.length) {
                const step = stepsData.steps[i]

                // Visual Component
                const componentType = step.component
                const port = step.port
                const position = this.getStepComponentPosition(
                    port,
                    workspace,
                    componentType
                )

                if (!workspace.components[componentType]) {
                    workspace.components[componentType] = []
                }

                const componentIndex =
                    workspace.components[componentType].length
                const placed = {
                    left: position.left,
                    top: position.top,
                    connectedTo: port,
                }
                // Poki: seed the per-pin map so + / - distribute across free pins
                // (occupancy is read from the in-memory workspace built so far)
                // instead of every component piling onto the shared fallbackPins
                // rail. Mirrors auto-drop/drag routing.
                const device = sessionStorage.getItem('connectedDevice')
                if (
                    device === 'Poki' &&
                    getHardwareWireConfig(componentType, device)
                ) {
                    const result = computeAutoDropPinConnections(
                        Ports,
                        componentType,
                        port,
                        device,
                        workspace.components,
                        { type: componentType, index: componentIndex }
                    )
                    if (result) placed.pinConnections = result.pinConnections
                }
                workspace.components[componentType].push(placed)

                // Logical Connection
                const nextPortConnections = this.applyPortConnection(
                    PortConnections,
                    componentType,
                    componentIndex,
                    port
                )
                Object.assign(PortConnections, nextPortConnections)
            }
        }

        // 3. Dispatch to Redux once — workspace first, then PortConnections
        this.props.assemblyComponent(workspace)
        this.props.PortConnections(PortConnections)

        // 4. Optionally synchronize UI highlights and step index after board state
        if (updateUI) {
            const totalSlides = this.getStepsSlideCount(stepsData)
            const boundedIndex = Math.max(
                0,
                Math.min(targetSlideIndex, totalSlides - 1)
            )
            const isFinalSlide = boundedIndex === stepsData.steps.length

            const uiState = {
                stepsSlideIndex: boundedIndex,
                tutorialDeviation: false,
                showSubtitleDisplay: true,
            }

            if (isFinalSlide) {
                uiState.highlightComponentType = null
                uiState.highlightPort = null
                uiState.isForced = false
            } else {
                const step = stepsData.steps[boundedIndex]
                uiState.highlightComponentType = step.component
                uiState.highlightPort = step.port
            }

            this.setState(uiState, () => {
                if (!isFinalSlide) this.checkTutorialDeviation()
            })
        } else {
            this.setState({ tutorialDeviation: false })
        }
    }

    resetTutorial = () => {
        const stepsData = this.state.assemblySteps
        if (!stepsData || !Array.isArray(stepsData.steps)) return

        // Reset to step 0 (before any connections)
        const slideIndex = 0

        // 1. Clear everything locally
        const workspace = { ...this.props.assemblyTwo.workspace }
        workspace.components = {}

        const PortConnections = {}
        Object.keys(this.props.assemblyTwo.PortConnections).forEach((key) => {
            PortConnections[key] = null
        })

        // 2. Update UI state
        this.setState({
            stepsSlideIndex: slideIndex,
            showSubtitleDisplay: true,
            aiSpeaking: false,
            tutorialDeviation: false,
        })

        // 3. Update Redux state
        this.props.assemblyComponent(workspace)
        this.props.PortConnections(PortConnections)

        // 4. Play audio if voiceover is enabled
        if (this.state.aiVoiceover) {
            this.playAudioForStep(0)
        }

        // 5. Save to sessionStorage
        const storageKey = `assembly_step_${this.getCurrentProjectId()}_${this.getCurrentScreenId() || 'default'}`
        sessionStorage.setItem(storageKey, '0')

        const step = stepsData.steps[0]

        this.setState(
            {
                highlightComponentType: step.component, // Always highlight the current step's component
                highlightPort: step.port, // Highlight the port as well
            },
            () => {
                this.checkTutorialDeviation()
            }
        )
    }

    getCurrentProjectId = () => {
        // Use this.props.location.search (safer in React Router) as fallback to window
        const urlParams = new URLSearchParams(
            this.props.location?.search || window.location.search
        )
        const queryProjectId = urlParams.get('projectId')

        if (queryProjectId) return queryProjectId
        if (this.props.projectId) return this.props.projectId

        return sessionStorage.getItem('apiProjectId') || 'talking-dragon'
    }

    getCurrentScreenId = () => {
        const urlParams = new URLSearchParams(
            this.props.location?.search || window.location.search
        )
        const queryScreenId = urlParams.get('screenId')
        if (queryScreenId) return queryScreenId
        if (this.props.screenId) return this.props.screenId
        return sessionStorage.getItem('apiScreenId') || null
    }

    componentDidMount() {
        window.appState = this
        this.isComponentMounted = true

        // Ensure the board identity is set for the admin / preview flow (which may
        // arrive without a hardware connection). Derive it from the admin-selected
        // board (allowedDevice) so the board render and the sidebar components agree
        // for Toki, Poki, etc. Only set when missing — never override a live device.
        if (!sessionStorage.getItem('connectedDevice')) {
            sessionStorage.setItem(
                'connectedDevice',
                sessionStorage.getItem('allowedDevice') || 'Toki'
            )
            sessionStorage.setItem('deviceVersion', '1')
        }

        // --- Project change detection ---
        const currentProjectId = this.getCurrentProjectId()
        const previousProjectId = sessionStorage.getItem('assemblyTwoProjectId')
        this._isProjectChanged =
            previousProjectId != null && previousProjectId !== currentProjectId

        // --- Screen change detection ---
        const currentScreenId = this.getCurrentScreenId()
        const previousScreenId = sessionStorage.getItem('assemblyTwoScreenId')
        this._isScreenChanged =
            previousScreenId != null && previousScreenId !== currentScreenId

        if (this._isProjectChanged || this._isScreenChanged) {
            console.log(
                `Assembly ${this._isProjectChanged ? 'project' : 'screen'} changed: "${previousProjectId || previousScreenId}" → "${currentProjectId}/${currentScreenId}". Resetting.`
            )
            // Clear saved tutorial step so we start from step 0
            const storageKey = `assembly_step_${this.getCurrentProjectId()}_${this.getCurrentScreenId() || 'default'}`
            sessionStorage.removeItem(storageKey)
            // Remove stale assemblyTwo sessionStorage so refreshAssemblyAccessories rebuilds fresh
            sessionStorage.removeItem('assemblyTwo')

            // Immediately clear Redux connections & workspace
            const emptyWorkspace = {
                ...this.props.assemblyTwo.workspace,
                components: {},
            }
            const emptyPortConnections = {}
            Object.keys(this.props.assemblyTwo.PortConnections).forEach(
                (key) => {
                    emptyPortConnections[key] = null
                }
            )
            this.props.assemblyComponent(emptyWorkspace)
            this.props.PortConnections(emptyPortConnections)
        }

        // Store current project ID for future comparisons
        sessionStorage.setItem('assemblyTwoProjectId', currentProjectId)
        sessionStorage.setItem('assemblyTwoScreenId', currentScreenId || '')
        // --- End project/screen change detection ---

        this.lastPortConnections = JSON.parse(
            JSON.stringify(this.props.assemblyTwo.PortConnections || {})
        )

        // Create a deep copy of the initial connections to track changes manually
        this.lastPortConnections = JSON.parse(
            JSON.stringify(this.props.assemblyTwo.PortConnections || {})
        )

        document.addEventListener('mousedown', this.handleClickOutside)
        document.addEventListener('click', this.handleActiveWireCancel)
        sessionStorage.setItem('isReadingZingPA', false)
        sessionStorage.removeItem('readSetIntervalId')
        this.refreshAssemblyAccessories()
        this.loadAssemblySteps()

        // Restore tutorial step from sessionStorage if available (skip if project/screen just changed)
        if (this.props.initialStep) {
            this.setState({ stepsSlideIndex: this.props.initialStep - 1 })
        } else if (!this._isProjectChanged && !this._isScreenChanged) {
            const storageKey = `assembly_step_${this.getCurrentProjectId()}_${this.getCurrentScreenId() || 'default'}`
            const savedStep = sessionStorage.getItem(storageKey)
            if (savedStep && !isNaN(savedStep)) {
                this.setState({ stepsSlideIndex: parseInt(savedStep, 10) })
            }
        }

        this.checkTutorialDeviation()
        if (sessionStorage.getItem('shield') === 'true') {
            this.props.updateInternalAccessories({
                isTouchZero: false,
                isTouchOne: false,
                isTouchTwo: false,
                isTouchThree: false,
                isTouchZeroOutput: false,
                isTouchOneOutput: false,
                isTouchTwoOutput: false,
                isTouchThreeOutput: false,
            })
        }
        if (
            sessionStorage.getItem('peeCeeATR') === 'true' &&
            sessionStorage.getItem('deviceVersion')?.startsWith('1')
        ) {
            this.props.updateInternalAccessories({
                isTouchZero: false,
                isTouchOne: false,
                isTouchTwo: false,
                isTouchThree: false,
                isTouchZeroOutput: false,
                isTouchOneOutput: false,
                isTouchTwoOutput: false,
                isTouchThreeOutput: false,
            })
        }
        if (sessionStorage.getItem('armShield') === 'true') {
            this.props.updateInternalAccessories({
                isSmileOne: false,
                isSmileTwo: false,
                isSmileThree: false,
                isSmileFour: false,
            })
        }

        atatus.beginTransaction('Assembly Screen')
        let sessionDataCheckbox = JSON.parse(
            sessionStorage.getItem('assemblyCheckbox')
        )

        if (sessionStorage.getItem('Ace')) {
            Object.keys(sessionDataCheckbox).map((val, indx) => {
                document.getElementById(`${val}`).checked =
                    sessionDataCheckbox[val]
            })
        }
        // sessionStorage.setItem("shield", "false");

        let data = JSON.parse(sessionStorage.getItem('user'))

        if (data === 1) {
            this.setState({
                isusb: true,
            })
        }
        if (data === 0) {
            this.setState({
                isusb: false,
            })
        }
        Sizes._update(document.body.clientWidth, document.body.clientHeight)
        window.addEventListener('resize', (e) => {
            const height = document.body.clientHeight
            const width = document.body.clientWidth
            Sizes._update(width, height)
            this.setState({
                height: height,
                width: width,
            })
        })

        Sizes._update(document.body.clientWidth, document.body.clientHeight)
        // Reset panning and pinching variables
        this.panEnd()
        this.pinchEnd()
        let hhh = JSON.parse(sessionStorage.getItem('SavedGDriveData'))
        let name = sessionStorage.getItem('name')
        console.log(name, 'kkklmo')
        if (name != 'null' && name != undefined && name != null) {
            for (let i = 0; i < hhh.length; i++) {
                if (name == hhh[i].name) {
                    const savedAssembly = hhh[i].assemblyTwo || hhh[i].assembly
                    if (savedAssembly) {
                        // --- NEW HEALING LOGIC HERE ---
                        const { newWorkspace } = this.healWorkspaceCoordinates(
                            savedAssembly.workspace
                        )
                        this.props.assemblyComponent(newWorkspace)
                        // ------------------------------
                        this.props.assemblyComponent(savedAssembly.workspace)
                        this.props.PortConnections(
                            savedAssembly.PortConnections
                        )
                    }
                }
            }
        }

        /////////////////// bugFix/PLAYC-2 ////////////////////////////////
        try {
            var { workspace, PortConnections } = this.props.assemblyTwo

            const isArmShield =
                sessionStorage.getItem('armShield') == 'true' || false

            Object.entries(workspace.components).map((device) => {
                device[1].map((instance, index) => {
                    if (
                        [
                            'dc_motor',
                            'mini_geared_motor',
                            'geared_motor',
                            'dynamex_motor',
                        ].includes(device[0])
                    ) {
                        if (isArmShield) {
                            if (instance.connectedTo == 'M1') {
                                PortConnections[`M1`] = null
                            }
                        }
                    }
                })
            })

            this.props.PortConnections(PortConnections)
        } catch (e) {
            console.log('error', e)
        }
        ///////////////////////////////////////////////////////////////////

        //add the  worker onMessage event
        this.props.worker.addEventListener('message', this.messageHandler)

        window.addEventListener('mousemove', (e) => {
            if (this.state.activeRgbWire) {
                this.setState({ mouseX: e.clientX, mouseY: e.clientY })
            }
        })
    }

    //read data from serial worker
    messageHandler = (e) => {
        if (
            ['RobokiPAread', 'PAreadZH', 'PAread', 'PAreadKlaw'].includes(
                e.data.type
            )
        ) {
            this.recievedBytes(e.data.value)
        } else if (e.data.type == 'PAreadPCv0') {
            this.recievedBytes_Pcv01(e.data.value, false)
        } else if (e.data.type === 'read' && e.data.value === '\r\nEåR\r\n') {
            console.log('ZZZZZZZZZZZZZZZ', e.data)
            this.stopPaOnBack()
        }
    }

    /**
     * Remove a component from workspace
     * @param  {WorkspaceComponent} item
     */
    ParseNodeList = (node, port, type) => {
        for (var nodeKey in node) {
            var obj = node[nodeKey].state
            if (obj['source'] == port) {
                delete node[nodeKey].state['source']
                delete node[nodeKey].state['value']
                delete node[nodeKey].state['value2']
                delete node[nodeKey].state['condition']
                delete node[nodeKey].state['hour']
                delete node[nodeKey].state['hour2']
                delete node[nodeKey].state['minute']
                delete node[nodeKey].state['minute2']
            }
            if (
                node[nodeKey].type == 'variable_output' ||
                node[nodeKey].type == 'hardware'
            ) {
                //  for tern+
                try {
                    var l = port.length
                } catch (e) {}
                if (l == 1) {
                    if (obj['assign' + port + '1']) {
                        delete node[nodeKey].state['assign' + port + '1']
                        delete node[nodeKey].state['assign' + port + '2']
                    }
                    if (obj['value' + port + '1']) {
                        delete node[nodeKey].state['value' + port + '1']
                        delete node[nodeKey].state['value' + port + '2']
                    }
                    if (type == 'dot_matrix') {
                        for (var key in obj) {
                            if (key.startsWith('dot_matrix')) {
                                delete node[nodeKey].state[key]
                            }
                        }
                    }
                    if (type == '7segment_display') {
                        for (var key in obj) {
                            if (
                                key.includes('valueB') ||
                                key.includes('valueC')
                            ) {
                                delete node[nodeKey].state[key]
                            }
                        }
                    }
                    if (type == 'OLED') {
                        for (var key in obj) {
                            if (key.includes('OLED')) {
                                delete node[nodeKey].state[key]
                            }
                        }
                    }
                    if (type == 'RGB') {
                        for (var key in obj) {
                            if (key.includes('RGBComp')) {
                                delete node[nodeKey].state[key]
                            }
                        }
                    }
                } else {
                    if (obj['assign' + port]) {
                        delete node[nodeKey].state['assign' + port]
                    }
                    if (obj['value' + port]) {
                        delete node[nodeKey].state['value' + port]
                    }
                    if (type == 'dot_matrix') {
                        for (var key in obj) {
                            if (key.startsWith('dot_matrix')) {
                                delete node[nodeKey].state[key]
                            }
                        }
                    }
                    if (type == '7segment_display') {
                        for (var key in obj) {
                            if (
                                key.includes('valueB') ||
                                key.includes('valueC')
                            ) {
                                delete node[nodeKey].state[key]
                            }
                        }
                    }
                    if (
                        [
                            'dc_motor',
                            'mini_geared_motor',
                            'geared_motor',
                            'dynamex_motor',
                        ].includes(type)
                    ) {
                        try {
                            delete node[nodeKey].state['assign' + port + '1']
                            delete node[nodeKey].state['assign' + port + '2']
                            delete node[nodeKey].state['value' + port + '1']
                            delete node[nodeKey].state['value' + port + '2']
                        } catch (e) {}
                    }
                }
            }
            if (node[nodeKey].subprogram) {
                this.ParseNodeList(node[nodeKey].subprogram, port, type)
            }
        }
        return node
    }

    setShield = (e) => {
        this.setState({ shield: e })
        if (e === false) {
            window.location.reload()
        }
    }
    setArmShield = (e) => {
        this.setState({ armShield: e })
        if (e === false) {
            window.location.reload()
        }
    }
    setPeeCeeATR = (e) => {
        this.setState({ peeCeeATR: e })
        if (e === false) {
            window.location.reload()
        }
    }

    removePlayShieldChildren = (item, { workspace, PortConnections }) => {
        // console.log('Edwin', item)
        // console.log('Edwin', workspace)
        // console.log('Edwin', PortConnections)

        if (item.type !== 'play_shield' && item.type !== 'play_shield_v1')
            return

        Object.entries(workspace.components).map((sensor) => {
            workspace.components[sensor[0]] = sensor[1].filter((child) => {
                if (!(child && child.connectedTo)) return true

                if (
                    PortConnections['A'] === null &&
                    (child.connectedTo === 'A1' || child.connectedTo === 'A2')
                ) {
                    PortConnections['A1'] = null
                    PortConnections['A2'] = null
                    return false
                } else if (
                    PortConnections['B'] === null &&
                    (child.connectedTo === 'B1' || child.connectedTo === 'B2')
                ) {
                    PortConnections['B1'] = null
                    PortConnections['B2'] = null
                    return false
                } else if (
                    PortConnections['C'] === null &&
                    (child.connectedTo === 'C1' || child.connectedTo === 'C2')
                ) {
                    PortConnections['C1'] = null
                    PortConnections['C2'] = null
                    return false
                } else if (
                    PortConnections['D'] === null &&
                    (child.connectedTo === 'D1' || child.connectedTo === 'D2')
                ) {
                    PortConnections['D1'] = null
                    PortConnections['D2'] = null
                    return false
                } else if (PortConnections['E'] && child.connectedTo === 'E') {
                    PortConnections['E'] = null
                    PortConnections['E1'] = null
                    return false
                } else if (PortConnections['F'] && child.connectedTo === 'F') {
                    PortConnections['F'] = null
                    PortConnections['F1'] = null
                    return false
                } else if (
                    child.connectedTo === 'M1' ||
                    child.connectedTo === 'M3'
                ) {
                    PortConnections['M1'] = null
                    PortConnections['M2'] = null

                    PortConnections['M3'] = null
                    PortConnections['M4'] = null
                    return false
                }
                return true
            })
        })

        // return { workspace, PortConnections }
    }

    // removeFromWorkspace11 = (item) => {
    //     this.setState({ readbytes: false })
    //     if (
    //         sessionStorage.getItem('deviceVersion')?.startsWith('1') ||
    //         ['Roboki'].includes(sessionStorage.getItem('connectedDevice'))
    //     ) {
    //         this.setState({ readbytes: false })
    //         this.setState({ isPcActive: false })
    //     }
    //     this.removePlayShieldChildren(item, this.props.assemblyTwo)

    //     var prev_data = this.props
    //     var port = item.port
    //     var updated_prog
    //     if (item.port !== undefined || item.connectedTo !== undefined) {
    //         updated_prog = removeSensorProgramData(
    //             prev_data.logic.program,
    //             item.port || item.connectedTo,
    //             item.type
    //         )
    //     }
    //     var { components } = this.props.assemblyTwo.workspace
    //     // var updated_flow_prog1 = this.ParseNodeList(prev_data.logicNew.cardConnections, port, item.type);
    //     // var updated_flow_prog2 = this.ParseNodeList(prev_data.logicNew.cards, port, item.type);
    //     if (item.port !== undefined || item.connectedTo !== undefined)
    //         prev_data.logic.program = updated_prog
    //     // prev_data.logicNew.cardConnections = updated_flow_prog1;
    //     // prev_data.logicNew.cards = updated_flow_prog2;
    //     //////////////fix-PLAYC-685/////////////////////////////

    //     if (this.state.isReading) {
    //         this.setState({ isReading: false })
    //         this.continuesPAstop()
    //     }
    //     // sessionStorage.setItem('isReadingZingPA', false)
    //     // if (
    //     //     ['Humanoid', 'Hexapod', 'Klaw'].includes(
    //     //         sessionStorage.getItem('connectedDevice')
    //     //     ) &&
    //     //     !sessionStorage.getItem('deviceVersion')?.startsWith('2')
    //     // )
    //     //     if (this.props.webSerial.isConnected) {
    //     //         this.setState({ isReading: false })
    //     //         this.setState({
    //     //             isReading: false,
    //     //             huBattery: '',
    //     //             huAccelerometerX: '',
    //     //             huAccelerometerY: '',
    //     //             huAccelerometerZ: '',
    //     //             huGyroX: '',
    //     //             huGyroY: '',
    //     //             huGyroZ: '',
    //     //             rangeA1: '',
    //     //             rangeA2: '',
    //     //             rangeB1: '',
    //     //             rangeB2: '',
    //     //             rangeC1: '',
    //     //             rangeC2: '',
    //     //             rangeD1: '',
    //     //             rangeD2: '',
    //     //         })
    //     //         continousPABytesReadToggle(
    //     //             null,
    //     //             null,
    //     //             this.props.webSerial.port,
    //     //             null,
    //     //             true
    //     //         )
    //     //     }
    // }

    removeFromWorkspace = (item) => {
        console.log('fsdfdsfdfdfdf', item)
        // this.setState({ readbytes: false })
        // if (
        //     sessionStorage.getItem('deviceVersion')?.startsWith('1') ||
        //     ['Roboki', 'Atr].includes(sessionStorage.getItem('connectedDevice'))
        // ) {
        //     this.setState({ readbytes: false })
        //     this.setState({ isPcActive: false })
        // }

        this.removePlayShieldChildren(item, this.props.assemblyTwo)

        var prev_data = this.props
        var port = item.port
        var updated_prog
        if (item.port !== undefined || item.connectedTo !== undefined) {
            updated_prog = removeSensorProgramData(
                prev_data.logic.program,
                item.port || item.connectedTo,
                item.type
            )
        }
        var { components } = this.props.assemblyTwo.workspace
        // var updated_flow_prog1 = this.ParseNodeList(prev_data.logicNew.cardConnections, port, item.type);
        // var updated_flow_prog2 = this.ParseNodeList(prev_data.logicNew.cards, port, item.type);
        if (item.port !== undefined || item.connectedTo !== undefined)
            prev_data.logic.program = updated_prog
        // prev_data.logicNew.cardConnections = updated_flow_prog1;
        // prev_data.logicNew.cards = updated_flow_prog2;

        // if (this.state.isReading) {
        //     this.setState({ isReading: false })
        //     // this.continuesPAstop()
        // }

        if (
            [
                'Humanoid',
                'Ace',
                'Roboki',
                'Hexapod',
                'Klaw',
                'Atr',
                'Toki',
                'Poki',
                'Moki',
            ].includes(sessionStorage.getItem('connectedDevice'))
        ) {
            // when we connect driver motor components, then add led to any ports when we remove the led from workspace
            // then driver motor show only one connected port(B) not both(BD) prots so add this checking

            let sdad = JSON.parse(sessionStorage.getItem('assemblyTwo'))
                .workspace.components

            if (item.type == 'pc_motor_driver') {
                if (item.connectedTo == 'A' || item.connectedTo == 'C') {
                    prev_data.assemblyTwo.PortConnections['C'] = null
                    prev_data.assemblyTwo.PortConnections['A'] = null
                }

                if (item.connectedTo == 'B' || item.connectedTo == 'D') {
                    prev_data.assemblyTwo.PortConnections['B'] = null
                    prev_data.assemblyTwo.PortConnections['D'] = null
                }
            } else if (item.type == 'stepper_motor') {
                if (
                    JSON.parse(sessionStorage.getItem('assemblyTwo'))
                        .PortConnections.B !== null
                ) {
                    if (
                        JSON.parse(sessionStorage.getItem('assemblyTwo'))
                            .PortConnections.B.type == 'pc_motor_driver'
                    ) {
                        if (item.connectedTo == 'STPM') {
                            prev_data.assemblyTwo.PortConnections['B1'] = null
                            prev_data.assemblyTwo.PortConnections['B2'] = null

                            prev_data.assemblyTwo.PortConnections['D1'] = null
                            prev_data.assemblyTwo.PortConnections['D2'] = null
                        }
                    }
                } else if (
                    JSON.parse(sessionStorage.getItem('assemblyTwo'))
                        .PortConnections.A !== null
                ) {
                    if (
                        JSON.parse(sessionStorage.getItem('assemblyTwo'))
                            .PortConnections.A.type == 'pc_motor_driver'
                    ) {
                        if (item.connectedTo == 'STPM') {
                            prev_data.assemblyTwo.PortConnections['A1'] = null
                            prev_data.assemblyTwo.PortConnections['A2'] = null

                            prev_data.assemblyTwo.PortConnections['C1'] = null
                            prev_data.assemblyTwo.PortConnections['C2'] = null
                        }
                    }
                }
            } else if (item.type == 'arm_shield') {
                prev_data.assemblyTwo.PortConnections['SS'] = null
                prev_data.assemblyTwo.PortConnections['MOTOR1'] = null
                prev_data.assemblyTwo.PortConnections['P0'] = null
                prev_data.assemblyTwo.PortConnections['P1'] = null
                prev_data.assemblyTwo.PortConnections['P2'] = null
                prev_data.assemblyTwo.PortConnections['SPK'] = null
            } else if (item.type == 'play_shield') {
                for (const [key, value] of Object.entries(
                    prev_data.assemblyTwo.PortConnections
                ))
                    prev_data.assemblyTwo.PortConnections[`${key}`] = null
                for (const [key, value] of Object.entries(components)) {
                    for (const [innerKey, innerValue] of Object.entries(
                        value
                    )) {
                        if (key != 'play_shield') {
                            let itemrecurse = {
                                type: key,
                                port: innerKey.connectedTo,
                            }
                            this.removeFromWorkspace(itemrecurse)
                        }
                    }
                }
            } else if (item.type == 'peeCee_ATR') {
                prev_data.assemblyTwo.PortConnections['S1'] = null
                prev_data.assemblyTwo.PortConnections['S2'] = null

                for (const [key, value] of Object.entries(components)) {
                    for (const [innerKey, innerValue] of Object.entries(
                        value
                    )) {
                        if (
                            innerValue.connectedTo == 'S1' ||
                            innerValue.connectedTo == 'S2'
                        ) {
                            let itemrecurse = {
                                type: key,
                                port: innerKey.connectedTo,
                            }
                            this.removeFromWorkspace(itemrecurse)
                        }
                    }
                }

                if (prev_data.assemblyTwo.PortConnections['M'] == null) {
                    prev_data.assemblyTwo.PortConnections['M1'] = null
                    prev_data.assemblyTwo.PortConnections['M2'] = null
                    prev_data.assemblyTwo.PortConnections['M3'] = null
                    prev_data.assemblyTwo.PortConnections['M4'] = null
                    for (const [key, value] of Object.entries(components)) {
                        for (const [innerKey, innerValue] of Object.entries(
                            value
                        )) {
                            if (
                                innerValue.connectedTo == 'M1' ||
                                innerValue.connectedTo == 'M2' ||
                                innerValue.connectedTo == 'M4' ||
                                innerValue.connectedTo == 'M3'
                            ) {
                                let itemrecurse = {
                                    type: key,
                                    port: innerKey.connectedTo,
                                }
                                this.removeFromWorkspace(itemrecurse)
                            }
                        }
                    }
                }
            } else if (
                [
                    'dc_motor',
                    'mini_geared_motor',
                    'geared_motor',
                    'dynamex_motor',
                ].includes(item.type)
            ) {
                try {
                    if (
                        sessionStorage.getItem('peeCeeATR') ||
                        ['Roboki', 'Moki'].includes(
                            sessionStorage.getItem('connectedDevice')
                        )
                    ) {
                        if (item.port == 'M1') {
                            prev_data.assemblyTwo.PortConnections['M1'] = null
                            prev_data.assemblyTwo.PortConnections['M2'] = null
                        } else if (item.port == 'M3') {
                            prev_data.assemblyTwo.PortConnections['M3'] = null
                            prev_data.assemblyTwo.PortConnections['M4'] = null
                        } else {
                            prev_data.assemblyTwo.PortConnections[
                                item.port[0] + '1'
                            ] = null
                            prev_data.assemblyTwo.PortConnections[
                                item.port[0] + '2'
                            ] = null
                        }
                    } else if (
                        (sessionStorage.getItem('connectedDevice') === 'Klaw' &&
                            ['F1', 'F2'].includes(item.port)) ||
                        (sessionStorage.getItem('connectedDevice') === 'Atr' &&
                            ['D1'].includes(item.port)) ||
                        (['Toki'].includes(
                            sessionStorage.getItem('connectedDevice')
                        ) &&
                            ['C1', 'C2', 'D1'].includes(item.port))
                    ) {
                        prev_data.assemblyTwo.PortConnections[item.port] = null
                    } else {
                        let portNum = 1
                        try {
                            portNum = parseInt(item.port[1])
                        } catch (e) {
                            portNum = 1
                            console.log('ERROR', e)
                        }
                        prev_data.assemblyTwo.PortConnections[
                            item.port[0] + portNum
                        ] = null
                        prev_data.assemblyTwo.PortConnections[
                            item.port[0] + (portNum + 1)
                        ] = null
                        // }
                    }
                } catch (e) {}
            } else {
                if (port == 'A') {
                    prev_data.assemblyTwo.PortConnections['A1'] = null
                    prev_data.assemblyTwo.PortConnections['A2'] = null
                } else if (port == 'B') {
                    prev_data.assemblyTwo.PortConnections['B1'] = null
                    prev_data.assemblyTwo.PortConnections['B2'] = null
                } else if (port == 'C') {
                    prev_data.assemblyTwo.PortConnections['C1'] = null
                    prev_data.assemblyTwo.PortConnections['C2'] = null
                } else if (port == 'D') {
                    prev_data.assemblyTwo.PortConnections['D1'] = null
                    prev_data.assemblyTwo.PortConnections['D2'] = null
                } else if (port == 'E') {
                    prev_data.assemblyTwo.PortConnections['E1'] = null
                    prev_data.assemblyTwo.PortConnections['E2'] = null
                } else if (port == 'F') {
                    prev_data.assemblyTwo.PortConnections['F'] = null
                    prev_data.assemblyTwo.PortConnections['F1'] = null
                    prev_data.assemblyTwo.PortConnections['F2'] = null
                } else {
                    prev_data.assemblyTwo.PortConnections[port] = null
                }
            }
            if (item.type == 'pcAiTool') {
                this.props.setAssemblyPageAi(defaultAssemblyPageAi)
            }
        } else {
            prev_data.assemblyTwo.PortConnections[item.port] = null
        }
        // sessionStorage.setItem("AppDetails-new", JSON.stringify(prev_data));
        // AppState.PortConnections = prev_data.assemblyTwo.PortConnections;
        // AppState.logic = prev_data.logic;
        // AppState.logicNew = prev_data.logicNew;
        var { logic } = prev_data
        this.props.logicComponent(logic)
        var { workspace, PortConnections } = this.props.assemblyTwo
        workspace.components[item.type].splice(item.index, 1)
        this.props.assemblyComponent(workspace)

        console.log(item)

        ////////// HOTFIX: workspace data not updated while removing dual_splitter  //////////////////
        if (item.type == 'dual_splitter') {
            const newWorkspace = JSON.parse(JSON.stringify(workspace))
            const oldDualSplitter = JSON.parse(
                sessionStorage.getItem('dualsplitter')
            ).dual_splitter.map((x) => x.connectedTo)
            const updateDualSplitter = JSON.parse(
                JSON.stringify(workspace)
            ).components.dual_splitter.map((x) => x.connectedTo)
            let removedDualSplitter = oldDualSplitter.filter(
                (x) => !updateDualSplitter.includes(x)
            )
            sessionStorage.setItem(
                'dualsplitter',
                JSON.stringify(workspace.components)
            )

            Object.entries(newWorkspace.components).map((parent) => {
                const component = parent[0]

                const children = parent[1].map((child) => {
                    if (
                        child.connectedTo &&
                        (child.connectedTo == `${removedDualSplitter + '1'}` ||
                            child.connectedTo ==
                                `${removedDualSplitter + '2'}`) &&
                        PortConnections[removedDualSplitter] == null
                    ) {
                        prev_data.assemblyTwo.PortConnections[
                            child.connectedTo
                        ] = null
                        delete child.connectedTo
                    }

                    return child
                })
                newWorkspace.components[component] = children
            })
            this.props.assemblyComponent(newWorkspace)
        }

        /////////////////////////////////////////////////////////////////////////////////////////////
    }
    /**
     * Pan event handler with throttling
     */
    pan = (e) => {
        if (panning) return
        panning = true
        var { workspace } = this.props.assemblyTwo
        workspace.offset.left += (e.deltaX - oldDeltaX) / workspace.scale
        workspace.offset.top += (e.deltaY - oldDeltaY) / workspace.scale
        oldDeltaX = e.deltaX
        oldDeltaY = e.deltaY
        this.props.assemblyComponent(workspace, () => {
            panning = false
        })
    }
    /**
     * Reset pan variables
     */
    panEnd = () => {
        panning = false
        oldDeltaX = 0
        oldDeltaY = 0
    }
    /**
     * Zoom function with throttling
     * @param  {number} scale   The new scale
     * @param  {number} clientX The clientX (center of pinch or cursor position on wheel)
     * @param  {number} clientY The clientY (center of pinch or cursor position on wheel)
     */
    zoom = (scale, clientX, clientY) => {
        if (zooming) return
        var { workspace, height, width } = this.props.assemblyTwo
        if (
            (workspace.scale < 0.25 && scale < 1) ||
            (workspace.scale > 2 && scale > 1)
        )
            return
        zooming = true
        clientX -= width * 0.2
        clientY -= document.body.clientHeight - height
        // client = (offset + x/y) * scale
        // client of oldx/y = client of newx/y (current mouse position)
        // oldx/y = client / scale - offset
        // (newoffset + oldx/y) * newscale = (oldOffset + oldx/y) * oldscale
        const oldX = clientX / workspace.scale - workspace.offset.left
        const oldY = clientY / workspace.scale - workspace.offset.top
        workspace.offset.left = (workspace.offset.left + oldX) / scale - oldX
        workspace.offset.top = (workspace.offset.top + oldY) / scale - oldY
        workspace.scale *= scale
        this.props.assemblyComponent(workspace, () => {
            zooming = false
        })
    }
    /**
     * Pinch Out event handler
     */
    pinchOut = (e) => {
        this.zoom(12 / 11, e.center.x, e.center.y)
        e.preventDefault()
        return false
    }
    /**
     * Pinch In event handler
     */
    pinchIn = (e) => {
        this.zoom(11 / 12, e.center.x, e.center.y)
        e.preventDefault()
        return false
    }
    /**
     * Reset pinch variables
     */
    pinchEnd = () => {
        zooming = false
    }
    /**
     * Wheel event handler
     */
    wheel = (e) => {
        const { clientX, clientY, deltaY } = e
        // if (deltaY > 0) this.zoom(5 / 6, clientX, clientY);
        // else this.zoom(6 / 5, clientX, clientY);
        //e.preventDefault();
        return false
    }
    close = () => {
        var c = document.getElementById('assemblyConnections')
        var d = document.getElementById('biboxClass')
        var e = document.getElementById('connectPort')

        c.style.zIndex = 2
        d.style.zIndex = 2
        e.style.zIndex = 2
        this.setState({ modalIsOpen: false })
    }
    saveToLocalStorage = () => {
        let programMode = sessionStorage.programMode
        let connectedDevice = sessionStorage.connectedDevice
        let version = sessionStorage.deviceVersion

        let updatelocalStorage = JSON.parse(
            localStorage.getItem('recoveryData')
        ) || {
            [programMode]: {
                [connectedDevice]: {
                    [version]: sessionStorage,
                },
            },
        }

        if (programMode in updatelocalStorage) {
            if (connectedDevice in updatelocalStorage[programMode]) {
                updatelocalStorage[programMode][connectedDevice][version] =
                    sessionStorage
                localStorage.setItem(
                    'recoveryData',
                    JSON.stringify(updatelocalStorage)
                )
            } else {
                updatelocalStorage[programMode][connectedDevice] = {
                    [version]: sessionStorage,
                }
                localStorage.setItem(
                    'recoveryData',
                    JSON.stringify(updatelocalStorage)
                )
            }
        } else {
            updatelocalStorage[programMode] = {
                [connectedDevice]: {
                    [version]: sessionStorage,
                },
            }
            localStorage.setItem(
                'recoveryData',
                JSON.stringify(updatelocalStorage)
            )
        }
    }
    check = async () => {
        let programMode = sessionStorage.programMode
        let connectedDevice = sessionStorage.connectedDevice
        let version = sessionStorage.deviceVersion
        if (
            programMode in JSON.parse(localStorage.getItem('recoveryData')) &&
            connectedDevice in
                JSON.parse(localStorage.getItem('recoveryData'))[programMode]
        ) {
            let updatelocalStorage = JSON.parse(
                localStorage.getItem('recoveryData')
            )
            updatelocalStorage[programMode][connectedDevice][version] =
                sessionStorage
            localStorage.setItem(
                'recoveryData',
                JSON.stringify(updatelocalStorage)
            )
        }

        if (this.state.isReading && this.props.webSerial.isConnected) {
            connectedDevice == 'Hexapod'
                ? this.setPaBytes_Hexapod()
                : this.setPaBytes_ZingV1V2()
            await new Promise((resolve) => setTimeout(resolve, 200))
        }

        this.setState({ readbytes: false })
        if (
            sessionStorage.getItem('deviceVersion')?.startsWith('1') ||
            ['Roboki', 'Atr', 'Toki', 'Poki', 'Moki'].includes(connectedDevice)
        ) {
            this.setState({ readbytes: false })
            this.setState({ isPcActive: false })
        }
        const timeout = setTimeout(() => {
            this.props.history.push('/logicTwo')
            this.setState({ slideDirection: false })
            sessionStorage.setItem('slideDirection', 'false')
            clearTimeout(timeout)
            //window.location.reload()
        }, 500)
    }

    slideDirection = () => {
        this.setState({ slideDirection: true })
        sessionStorage.setItem('slideDirection', 'true')
    }

    nextVisbility = (value) => {
        this.setState({ visible: value })
    }

    componentWillUnmount() {
        this.isComponentMounted = false

        document.removeEventListener('mousedown', this.handleClickOutside)
        document.removeEventListener('click', this.handleActiveWireCancel)
        if (this.typewriterInterval) clearInterval(this.typewriterInterval)
        if (this.tutorialMessageTimer) clearTimeout(this.tutorialMessageTimer)
        this.props.worker.removeEventListener('message', this.messageHandler)

        atatus.endTransaction('Assembly Screen')
        this.screenshotInitiate()
    }
    screenshotInitiate = () => {
        try {
            var URL, BLOB
            ;(function (exports) {
                function urlsToAbsolute(nodeList) {
                    if (!nodeList.length) {
                        return []
                    }
                    var attrName = 'href'
                    if (
                        nodeList[0].__proto__ === HTMLImageElement.prototype ||
                        nodeList[0].__proto__ === HTMLScriptElement.prototype
                    ) {
                        attrName = 'src'
                    }
                    nodeList = [].map.call(nodeList, function (el, i) {
                        var attr = el.getAttribute(attrName)
                        if (!attr) {
                            return
                        }
                        var absURL = /^(https?|data):/i.test(attr)
                        if (absURL) {
                            return el
                        } else {
                            return el
                        }
                    })
                    return nodeList
                }

                function screenshotPage() {
                    if (JSON.parse(sessionStorage.getItem('Index'))) {
                        urlsToAbsolute(document.images)
                        urlsToAbsolute(
                            document.querySelectorAll("link[rel='stylesheet']")
                        )
                        var screenshot = document
                            .getElementById('assemblyscreenid')
                            .cloneNode(true)
                        try {
                            screenshot.getElementsByClassName(
                                'assemblySidebar'
                            )[0].innerHTML = ''
                        } catch (e) {}
                        $(screenshot)
                            .find('.assemblySidebar')
                            .css('background-color', 'transparent')
                        $(screenshot)
                            .find('.assemblySidebar')
                            .css('border', 'none')
                        $(screenshot)
                            .find('.assemblySidebar')
                            .css('box-shadow', 'none')

                        $(screenshot).find('.nextButton').css('display', 'none')
                        $(screenshot)
                            .find('.navbarContainer_assem')
                            .css('display', 'none')
                        $(screenshot)
                            .find('.navbarContainer_assembly')
                            .css('display', 'none')

                        //screenshot.getElementsByClassName("assemblyScreen")[0].style.backgroundImage='';
                        $(screenshot)
                            .find('.assemblyScreen')
                            .css('background-color', 'black')
                        $(screenshot)
                            .find('.assemblyScreen')
                            .css('background-image', 'none')

                        // var b = document.createElement('base');
                        // b.href = document.location.protocol + '//' + location.host;
                        var head = screenshot.querySelector('head')
                        // head.insertBefore(b, head.firstChild);
                        screenshot.style.pointerEvents = 'none'
                        screenshot.style.overflow = 'hidden'
                        screenshot.style.webkitUserSelect = 'none'
                        screenshot.style.mozUserSelect = 'none'
                        screenshot.style.msUserSelect = 'none'
                        screenshot.style.oUserSelect = 'none'
                        screenshot.style.userSelect = 'none'
                        screenshot.dataset.scrollX = window.scrollX
                        screenshot.dataset.scrollY = window.scrollY
                        var script = document.createElement('script')
                        script.textContent =
                            '(' + addOnPageLoad_.toString() + ')();'
                        // screenshot.querySelector('body').appendChild(script);

                        var blob = new Blob([screenshot.outerHTML], {
                            type: 'text/html',
                        })
                        //screenshot.getElementsByClassName("pure-u-1-5")[0].style.display='none';
                        URL = screenshot.outerHTML
                        return blob
                    }
                }
                function addOnPageLoad_() {
                    window.addEventListener('DOMContentLoaded', function (e) {
                        var scrollX =
                            document.documentElement.dataset.scrollX || 0
                        var scrollY =
                            document.documentElement.dataset.scrollY || 0
                        window.scrollTo(scrollX, scrollY)
                    })
                }

                ;(function () {
                    window.URL = window.URL || window.webkitURL
                    BLOB = screenshotPage()
                    // window.open(window.URL.createObjectURL(screenshotPage()));
                })()

                exports.screenshotPage = screenshotPage
                // exports.generate = generate;
            })(window)
            // generate();
            var div = document.createElement('div')
            // you need to create an empty div element with some id and use that id here.
            var div = document.getElementById('assemblyShot')
            div.innerHTML = URL
            sessionStorage.setItem('assempblyImageHTML', URL)
            html2canvas(div, {
                onrendered: function (canvas) {
                    div.innerHTML = ''
                    var img = canvas.toDataURL('image/png')

                    sessionStorage.setItem('assempblyImageURI', img)
                },
            })

            html2canvas(div).then(function (canvas) {
                div.innerHTML = ''
                var img = canvas.toDataURL('image/png')
                sessionStorage.setItem('assempblyImageURI', img)
            })
        } catch (e) {}
    }

    handleAssemblyCheckbox = (e) => {
        let isCheckedValue = e.target.value

        let isChecked = e.target.checked

        // if (isCheckedValue == "FOUR_in_ONE_Sensor" && isChecked == true) {
        //
        //   this.props.assemblyTwo.PortConnections[isCheckedValue] = {
        //     type: "4_in_1_sensor",
        //     index: 0,
        //   };
        // } else if (isCheckedValue == "FOUR_in_ONE_Sensor" && isChecked == false) {
        //
        //   this.props.assemblyTwo.PortConnections[isCheckedValue] = null;
        // }

        activeCheckBox[isCheckedValue] = isChecked

        sessionStorage.setItem(
            'assemblyCheckbox',
            JSON.stringify(activeCheckBox)
        )
    }

    handleFourInOneSensor = (e) => {
        if (this.state.isClickFourInOneSensor) {
            this.setState({
                isClickFourInOneSensor: false,
            })
        } else {
            this.setState({
                isClickFourInOneSensor: true,
            })
        }
    }
    handleTempratureSensor = (e) => {
        if (this.state.isClickTempratureSensor) {
            this.setState({
                isClickTempratureSensor: false,
            })
        } else {
            this.setState({
                isClickTempratureSensor: true,
            })
        }
    }

    MSBLSBToDecimal = (MSBInBinary, LSBInBinary) => {
        return parseInt(
            parseInt(MSBInBinary).toString(2).padStart(8, 0) +
                parseInt(LSBInBinary).toString(2).padStart(8, 0),
            2
        )
    }
    handleReadBytes = async () => {
        await this.setState({ readbytes: false })
    }

    setToDefault = () => {
        this.setState({
            rangeA1: '',
            rangeA2: '',
            rangeB1: '',
            rangeB2: '',
            rangeC1: '',
            rangeC2: '',
            rangeD1: '',
            rangeD2: '',
            rangeE1: '',
            rangeE2: '',
            rangeF1: '',
            rangeF2: '',
            rangeG1: '',
            rangeG2: '',
            rangeservo_motor1: '',
            rangeservo_motor2: '',
            mic: '',
            temprature: '',
            zero: '',
            one: '',
            two: '',
            temp: '',
            light: '',
            distance: '',
            gesture: '',
            red: '',
            green: '',
            blue: '',
            accelerometer_X: '',
            accelerometer_Y: '',
            accelerometer_Z: '',
            gyro_X: '',
            gyro_Y: '',
            gyro_Z: '',
            battery: '',
            switch1: '',
            switch2: '',
            ir: '',
        })
    }

    recievedBytes_Pcv01 = async (data, blank) => {
        if (data === undefined) return
        if (blank) {
            this.setState({
                zero: '',
                one: '',
                two: '',
                rangeA1: '',
                rangeA2: '',
                rangeB1: '',
                rangeB2: '',
                rangeC1: '',
                rangeC2: '',
                red: '',
                green: '',
                blue: '',
                light: '',
                distance: '',
                gesture: '',
                mic: '',
                temprature: '',
                rangeF1: '',
                rangeF2: '',
            })
            return
        }
        console.log(data, 'gsk read')
        data = data.filter((e) => e != 80 && e != 65)
        this.setState({
            zero: this.MSBLSBToDecimal(data[1], data[0]),
            one: this.MSBLSBToDecimal(data[5], data[4]),
            two: this.MSBLSBToDecimal(data[9], data[8]),
            rangeA1: this.MSBLSBToDecimal(data[1], data[0]),
            rangeA2: this.MSBLSBToDecimal(data[3], data[2]),
            rangeB1: this.MSBLSBToDecimal(data[5], data[4]),
            rangeB2: this.MSBLSBToDecimal(data[7], data[6]),
            rangeC1: this.MSBLSBToDecimal(data[9], data[8]),
            rangeC2: this.MSBLSBToDecimal(data[11], data[10]),
            rangeF1: data[12],
            rangeF2: data[13],
            red: data[14],
            green: data[15],
            blue: data[16],
            light: this.MSBLSBToDecimal(data[15], data[14]),
            distance: data[15],
            gesture: data[16],
            mic: this.MSBLSBToDecimal(data[18], data[17]),
            temprature: this.MSBLSBToDecimal(data[20], data[19]),
        })
    }

    recievedBytes = (bytesRecieved) => {
        let deviceVersion = sessionStorage.getItem('deviceVersion')
        let connectedDevice = sessionStorage.getItem('connectedDevice')
        console.log(bytesRecieved, 'recievedData')
        if (connectedDevice == 'Ace') {
            if (deviceVersion[0] == 0) {
            } else {
                if (!this.state.isPcActive) return
                this.setState({
                    rangeA1: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        2
                    ),
                    rangeA2: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        3
                    ),
                    rangeB1: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        4
                    ),
                    rangeB2: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        5
                    ),
                    rangeC1: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        6
                    ),
                    rangeC2: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        7
                    ),
                    rangeD1: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        8
                    ),
                    rangeD2: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        9
                    ),
                    rangeE1: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        10
                    ),
                    rangeE2: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        11
                    ),
                    rangeF1: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        12
                    ),
                    rangeF2: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        13
                    ),
                    mic: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        14
                    ),
                    temprature: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        15
                    ),
                    zero: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        16
                    ),
                    one: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        17
                    ),
                    temp: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        18
                    ),
                    two: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        19
                    ),
                    light: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        '20L'
                    ),
                    distance: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        '20D'
                    ),
                    gesture: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        '20G'
                    ),
                    red: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        '20C'
                    )[0],
                    green: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        '20C'
                    )[1],
                    blue: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        '20C'
                    )[2],
                    accelerometer_X:
                        Number(
                            playComputerPABytesToSensorData(
                                bytesRecieved.slice(2),
                                '21X'
                            )
                        ) - 32768,
                    accelerometer_Y:
                        Number(
                            playComputerPABytesToSensorData(
                                bytesRecieved.slice(2),
                                '21Y'
                            )
                        ) - 32768,
                    accelerometer_Z:
                        Number(
                            playComputerPABytesToSensorData(
                                bytesRecieved.slice(2),
                                '21Z'
                            )
                        ) - 32768,
                    gyro_X:
                        Number(
                            playComputerPABytesToSensorData(
                                bytesRecieved.slice(2),
                                '21GX'
                            )
                        ) - 2500,
                    gyro_Y:
                        Number(
                            playComputerPABytesToSensorData(
                                bytesRecieved.slice(2),
                                '21GY'
                            )
                        ) - 2500,
                    gyro_Z:
                        Number(
                            playComputerPABytesToSensorData(
                                bytesRecieved.slice(2),
                                '21GZ'
                            )
                        ) - 2500,
                    battery: playComputerPABytesToSensorData(
                        bytesRecieved.slice(2),
                        22
                    ),
                })
            }
        } else if (connectedDevice == 'Hexapod') {
            if (!this.state.isReading) return
            this.setState({
                rangeA1: hexapodPABytesToSensorData(bytesRecieved, 31),
                rangeA2: hexapodPABytesToSensorData(bytesRecieved, 32),
                rangeB1: hexapodPABytesToSensorData(bytesRecieved, 33),
                rangeB2: hexapodPABytesToSensorData(bytesRecieved, 34),
                rangeC1: hexapodPABytesToSensorData(bytesRecieved, 35),
                rangeC2: hexapodPABytesToSensorData(bytesRecieved, 36),
                huAccelerometerX: Number(
                    hexapodPABytesToSensorData(bytesRecieved, '25')
                ),
                huAccelerometerY: Number(
                    hexapodPABytesToSensorData(bytesRecieved, '26')
                ),
                huAccelerometerZ: Number(
                    hexapodPABytesToSensorData(bytesRecieved, '27')
                ),
                huGyroX: Number(
                    hexapodPABytesToSensorData(bytesRecieved, '28')
                ),
                huGyroY: Number(
                    hexapodPABytesToSensorData(bytesRecieved, '29')
                ),
                huGyroZ: Number(
                    hexapodPABytesToSensorData(bytesRecieved, '30')
                ),
                huBattery: hexapodPABytesToSensorData(bytesRecieved, 23),
                huUltrasonic: hexapodPABytesToSensorData(bytesRecieved, 24),
            })
        } else if (connectedDevice == 'Humanoid') {
            if (!this.state.isReading) return
            if (deviceVersion[0] == 2) {
                this.setState({
                    rangeA1: humanoidPABytesToSensorData(bytesRecieved, 31),
                    rangeA2: humanoidPABytesToSensorData(bytesRecieved, 32),
                    rangeB1: humanoidPABytesToSensorData(bytesRecieved, 33),
                    rangeB2: humanoidPABytesToSensorData(bytesRecieved, 34),
                    rangeC1: humanoidPABytesToSensorData(bytesRecieved, 35),
                    rangeC2: humanoidPABytesToSensorData(bytesRecieved, 36),
                    huAccelerometerX: Number(
                        humanoidPABytesToSensorData(bytesRecieved, '23')
                    ),
                    huAccelerometerY: Number(
                        humanoidPABytesToSensorData(bytesRecieved, '24')
                    ),
                    huAccelerometerZ: Number(
                        humanoidPABytesToSensorData(bytesRecieved, '25')
                    ),
                    huGyroX: Number(
                        humanoidPABytesToSensorData(bytesRecieved, '26')
                    ),
                    huGyroY: Number(
                        humanoidPABytesToSensorData(bytesRecieved, '27')
                    ),
                    huGyroZ: Number(
                        humanoidPABytesToSensorData(bytesRecieved, '28')
                    ),
                    huBattery: humanoidPABytesToSensorData(bytesRecieved, 21),
                    huUltrasonic: humanoidPABytesToSensorData(
                        bytesRecieved,
                        22
                    ),
                })
            } else {
                this.setState({
                    huBattery: humanoidPABytesToSensorData(bytesRecieved, 21),
                    huAccelerometerX: humanoidPABytesToSensorData(
                        bytesRecieved,
                        23
                    ),
                    huAccelerometerY: humanoidPABytesToSensorData(
                        bytesRecieved,
                        24
                    ),
                    huAccelerometerZ: humanoidPABytesToSensorData(
                        bytesRecieved,
                        25
                    ),
                    huGyroX: humanoidPABytesToSensorData(bytesRecieved, 26),
                    huGyroY: humanoidPABytesToSensorData(bytesRecieved, 27),
                    huGyroZ: humanoidPABytesToSensorData(bytesRecieved, 28),
                    rangeA1: humanoidPABytesToSensorData(bytesRecieved, 31),
                    rangeA2: humanoidPABytesToSensorData(bytesRecieved, 32),
                    rangeB1: humanoidPABytesToSensorData(bytesRecieved, 33),
                    rangeB2: humanoidPABytesToSensorData(bytesRecieved, 34),
                    rangeC1: humanoidPABytesToSensorData(bytesRecieved, 35),
                    rangeC2: humanoidPABytesToSensorData(bytesRecieved, 36),
                    rangeD1: humanoidPABytesToSensorData(bytesRecieved, 37),
                    rangeD2: humanoidPABytesToSensorData(bytesRecieved, 38),

                    huUltrasonic: humanoidPABytesToSensorData(
                        bytesRecieved,
                        22
                    ),
                })
            }
        } else if (connectedDevice == 'Klaw') {
            this.setState({
                rangeA1: klawPABytesToSensorData(bytesRecieved, 31),
                rangeA2: klawPABytesToSensorData(bytesRecieved, 32),
                rangeB1: klawPABytesToSensorData(bytesRecieved, 33),
                rangeB2: klawPABytesToSensorData(bytesRecieved, 34),
                pot1: klawPABytesToSensorData(bytesRecieved, 0),
                pot2: klawPABytesToSensorData(bytesRecieved, 1),
                pot3: klawPABytesToSensorData(bytesRecieved, 2),
                pot4: klawPABytesToSensorData(bytesRecieved, 3),
                pot5: klawPABytesToSensorData(bytesRecieved, 4),
                pot6: klawPABytesToSensorData(bytesRecieved, 5),
                switch1: klawPABytesToSensorData(bytesRecieved, 12),
                switch2: klawPABytesToSensorData(bytesRecieved, 13),
            })
        } else if (connectedDevice == 'Atr') {
            if (!this.state.isPcActive) return
            this.setState({
                rangeA1: robokiPABytesToSensorData(bytesRecieved.slice(2), 2),
                rangeA2: robokiPABytesToSensorData(bytesRecieved.slice(2), 3),
                rangeB1: robokiPABytesToSensorData(bytesRecieved.slice(2), 6),
                rangeB2: robokiPABytesToSensorData(bytesRecieved.slice(2), 7),
                rangeC1: robokiPABytesToSensorData(bytesRecieved.slice(2), 23),
                rangeC2: robokiPABytesToSensorData(bytesRecieved.slice(2), 24),
            })
        } else if (connectedDevice == 'Toki') {
            if (!this.state.isPcActive) return
            this.setState({
                rangeA1: robokiPABytesToSensorData(bytesRecieved.slice(2), 2),
                rangeA2: robokiPABytesToSensorData(bytesRecieved.slice(2), 3),
                rangeservo_motor1: robokiPABytesToSensorData(
                    bytesRecieved.slice(2),
                    6
                ),
                rangeservo_motor2: robokiPABytesToSensorData(
                    bytesRecieved.slice(2),
                    7
                ),
                ir: robokiPABytesToSensorData(bytesRecieved.slice(2), 23),
            })
        } else if (connectedDevice == 'Poki') {
            if (!this.state.isPcActive) return

            const paDataObj = pokiPABytesToSensorData({
                receivedPABytes: bytesRecieved.slice(2),
                ...this.connectStatusRef.current,
            })

            this.setState(paDataObj)
        } else if (connectedDevice == 'Moki') {
            if (!this.state.isPcActive) return
            this.setState({
                rangeA1: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    2
                ),
                rangeA2: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    3
                ),
                rangeB1: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    4
                ),
                rangeB2: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    5
                ),
                rangeC1: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    6
                ),
                rangeC2: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    7
                ),
                rangeD1: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    8
                ),
                rangeD2: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    9
                ),
                rangeE1: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    10
                ),
                rangeE2: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    11
                ),
                rangeF1: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    12
                ),
                rangeF2: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    13
                ),
                rangeG1: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    14
                ),
                rangeG2: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    15
                ),
                ir: playComputerPABytesToSensorData(bytesRecieved.slice(2), 16),
                switch1: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    17
                ),
                switch2: playComputerPABytesToSensorData(
                    bytesRecieved.slice(2),
                    18
                ),
            })
        } else {
            if (!this.state.isPcActive) return
            this.setState({
                rangeA1: robokiPABytesToSensorData(bytesRecieved.slice(2), 2),
                rangeA2: robokiPABytesToSensorData(bytesRecieved.slice(2), 3),
                rangeB1: robokiPABytesToSensorData(bytesRecieved.slice(2), 6),
                rangeB2: robokiPABytesToSensorData(bytesRecieved.slice(2), 7),
                switch1: robokiPABytesToSensorData(bytesRecieved.slice(2), 23),
                switch2: robokiPABytesToSensorData(bytesRecieved.slice(2), 24),
            })
        }

        console.log('my updated state', this.state)
    }

    // --- Shell: push header + footer props to SubprogramRunner's persistent shell ---
    _syncShellProps = () => {
        const ctx = this.context
        if (!ctx || !ctx.setHeaderProps) return

        const stepsData = this.state.assemblySteps
        const activeSlideIndex = this.state.stepsSlideIndex
        const totalSlides = this.getStepsSlideCount(stepsData)
        const isFinalSlide =
            stepsData && activeSlideIndex === stepsData.steps.length

        const slideTitle = isFinalSlide
            ? stepsData?.finalStepTitle || 'All components assembled!'
            : stepsData?.steps?.[activeSlideIndex]?.title || ''

        const stepTitles = stepsData?.steps
            ? [
                  ...stepsData.steps.map((s) => s.title || ''),
                  stepsData.finalStepTitle || 'Assembly Complete!',
              ]
            : ['Assembly Complete!']

        ctx.setHeaderProps({
            title: stepsData?.title || '',
            showJumpTo: false,
            titlePosition: 'left',
            help_btnPosition: 'right',
            isGoBack: true,
            goBack: this.goBack,
            showSave: true,
            showAssemblyHelp: true,
            showBluetoothBtn: true,
            currentStep: activeSlideIndex + 1,
            totalSteps: totalSlides,
            stepTitles,
            onStepClick: (stepNum) => {
                const slideIndex = stepNum - 1
                this.buildWorkspaceForStep(slideIndex, { updateUI: true })
                if (this.state.aiVoiceover) this.playAudioForStep(slideIndex)
            },
        })

        // When the admin locks the Next button (nextAllowed === false), users
        // must complete each connection (by dragging) to advance instead of
        // skipping ahead. We keep the final-slide "Continue" usable so users
        // who finished the assembly can still proceed to the next screen.
        const nextDisabled =
            stepsData?.nextAllowed === false && !isFinalSlide

        ctx.setFooterProps({
            stepCounter: isFinalSlide
                ? 'Done'
                : `Step ${activeSlideIndex + 1} of ${Math.max(totalSlides - 1, 1)}`,
            stepTitle: slideTitle,
            nextLabel:
                activeSlideIndex === totalSlides - 1 ? 'Continue' : 'Next',
            onPrev: this.handleStepsPrev,
            onNext: this.handleStepsNext,
            nextDisabled,
        })

        if (ctx.setToolbarProps) {
            ctx.setToolbarProps({
                aiVoiceover: this.state.aiVoiceover,
                onAiToggle: () => {
                    this.handleAiVoiceoverToggle()
                    this.setState({
                        subtitleVisible: !this.state.aiVoiceover,
                        showSubtitleDisplay: !this.state.aiVoiceover,
                    })
                },
                onFullscreen: this.handleFullscreen,
                onReset: this.resetTutorial,
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        this.saveToLocalStorage()

        // Expose the current tutorial step's required port to IsOverPort. Grouped
        // sockets (e.g. Poki E1/E2 and F1/F2) share one coordinate, so the drop
        // resolver can't tell them apart by distance and always picks the first
        // alias. Publishing the step's target lets it break that tie toward the
        // alias the step actually wants. Cleared on the final/non-tutorial slide.
        if (prevState.highlightPort !== this.state.highlightPort) {
            if (this.state.highlightPort)
                sessionStorage.setItem(
                    'assemblyRequiredPort',
                    this.state.highlightPort
                )
            else sessionStorage.removeItem('assemblyRequiredPort')
        }

        const currentConnections = this.props.assemblyTwo.PortConnections
        const { assemblySteps, stepsSlideIndex } = this.state

        // Ensure we have steps and are not on the final "Done" slide
        if (
            assemblySteps &&
            assemblySteps.steps &&
            stepsSlideIndex < assemblySteps.steps.length
        ) {
            const currentStep = assemblySteps.steps[stepsSlideIndex]
            const requiredPort = currentStep.port
            const requiredComponent = currentStep.component

            // 1. Check if the port for the CURRENT step is connected correctly NOW
            const isConnectedNow =
                currentConnections[requiredPort] &&
                currentConnections[requiredPort].type === requiredComponent

            // 2. Check if it was connected BEFORE (using our manual shadow copy)
            // We use optional chaining (?.) just in case the port didn't exist in the shadow copy
            const wasConnectedBefore =
                this.lastPortConnections?.[requiredPort] &&
                this.lastPortConnections?.[requiredPort]?.type ===
                    requiredComponent

            // 3. If it is connected NOW, but wasn't BEFORE, the user just dragged it!
            if (isConnectedNow && !wasConnectedBefore) {
                // Determine if the user is just fixing a deviation or making progress
                // We add a small delay for visual feedback (the user sees the piece snap in)
                setTimeout(() => {
                    this.handleStepsNext()
                }, 100)
            }
        }

        // --- UPDATE SHADOW STATE ---
        // Update our local copy to match the current props for the next cycle.
        // JSON.stringify/parse creates a deep copy, breaking the reference to the mutated Redux state.
        this.lastPortConnections = JSON.parse(
            JSON.stringify(currentConnections)
        )

        // --- DEVIATION CHECK ---
        // We can't rely on prevProps !== this.props, so we check deviation whenever
        // our manual diff logic detects a change, OR we just check it every update (it's cheap).
        // To be safe, let's checking it if the stringified versions differ.
        const prevString = JSON.stringify(this.lastPortConnections)
        const currString = JSON.stringify(currentConnections)

        const storageKey = `assembly_step_${this.getCurrentProjectId()}_${this.getCurrentScreenId() || 'default'}`

        if (
            prevString !== currString ||
            prevState.stepsSlideIndex !== this.state.stepsSlideIndex
        ) {
            // Save tutorial step to sessionStorage when it changes
            if (prevState.stepsSlideIndex !== this.state.stepsSlideIndex) {
                sessionStorage.setItem(
                    storageKey,
                    this.state.stepsSlideIndex.toString()
                )
            }
            this.checkTutorialDeviation()
        }

        // --- AUDIO & TYPEWRITER LOGIC ---
        const stepChanged =
            prevState.stepsSlideIndex !== this.state.stepsSlideIndex
        const aiToggled = prevState.aiVoiceover !== this.state.aiVoiceover

        if (stepChanged || aiToggled) {
            const text = this.getCurrentInstruction()
            if (aiToggled && this.state.aiVoiceover) {
                this.setState({ showSubtitleDisplay: true })
            }
            this.runTypewriterEffect(text)
        }

        // Sync header/footer/toolbar to the persistent shell whenever step or data changes
        if (
            stepChanged ||
            aiToggled ||
            prevState.assemblySteps !== this.state.assemblySteps
        ) {
            this._syncShellProps()
        }
    }

    handleReadByte = async () => {
        if (!this.props.webSerial.isConnected) {
            await this.setState({ readbytes: false })
        }
        await this.setState({ readbytes: !this.state.readbytes })
        let flag = true
        while (true) {
            if (!this.state.readbytes && this.props.webSerial.isConnected) {
                setTimeout(() => {
                    this.props.worker.postMessage({
                        type: 'write',
                        value: 'M8',
                    })
                    this.setToDefault()
                }, 500)
                return
            }
            if (
                !this.state.readbytes ||
                goBack ||
                !this.props.webSerial.isConnected
            ) {
                setTimeout(() => this.recievedBytes_Pcv01([], true), 350)

                return
            }

            if (flag) {
                flag = false
                await new Promise((resolve) => setTimeout(resolve, 200))
            } else {
                this.props.worker.postMessage({
                    type: 'writeArray',
                    value: this.setPABytes_PCv0(),
                })
                await new Promise((resolve) => setTimeout(resolve, 100))
            }
        }
    }

    handleReadByte_v1 = async () => {
        let connectedDevice = sessionStorage.getItem('connectedDevice')
        let deviceVersion = sessionStorage.getItem('deviceVersion')

        let isAi_1Connected = this.props?.assemblyTwo?.PortConnections?.A?.type

        if (
            !isAi1NotPresent({
                connectedDevice,
                deviceVersion,
            }) &&
            isAi_1Connected === 'pcAiTool' &&
            !isAi1ShowCondition({ connectedDevice, deviceVersion })
        ) {
            this.setState({ isShowLowerVersionPopup: true })
        }

        while (true) {
            if (
                (!this.state.isPcActive && !this.state.isReading) ||
                !this.props.webSerial.isConnected
            ) {
                try {
                    this.setState({ isReading: false })
                    this.props.worker.postMessage({
                        type: 'write',
                        value: 'M8',
                    })
                    setTimeout(() => {
                        this.setToDefault()
                    }, 100)
                } catch (e) {}
                return
            } else {
                let sendPA_Byte
                if (['Humanoid', 'Hexapod'].includes(connectedDevice)) {
                    if (
                        ['2', '3'].includes(
                            sessionStorage.getItem('deviceVersion')?.[0]
                        )
                        // sessionStorage.getItem('deviceVersion')?.includes('2')
                    ) {
                        sendPA_Byte = this.setPABytes_V2()
                        this.props.worker.postMessage({
                            type: 'write',
                            value: sendPA_Byte,
                        })
                    } else {
                        sendPA_Byte =
                            connectedDevice == 'Hexapod'
                                ? this.setPaBytes_Hexapod()
                                : this.setPaBytes_ZingV1V2()
                        this.props.worker.postMessage({
                            type: 'writeArray',
                            value: sendPA_Byte,
                        })
                    }
                } else {
                    if (
                        connectedDevice == 'Roboki' ||
                        connectedDevice == 'Atr'
                    ) {
                        sendPA_Byte = this.setPABytes_Roboki()
                    } else if (connectedDevice == 'Klaw') {
                        sendPA_Byte = this.setPABytes_Klaw()
                    } else {
                        sendPA_Byte = this.setPABytes_V1()
                    }

                    this.props.worker.postMessage({
                        type: 'write',
                        value: sendPA_Byte,
                    })
                }

                await new Promise((resolve) => setTimeout(resolve, 100))
            }
        }
    }

    // Safe accessor for the 'concept' sessionStorage blob. Returns {} when the
    // key is missing (e.g. opening the assembly preview directly, before the
    // concept-selection flow has run) so render() never crashes on a null deref.
    getConcept = () => {
        try {
            return JSON.parse(sessionStorage.getItem('concept')) || {}
        } catch (e) {
            return {}
        }
    }

    renderImg = (e) => {
        const fourInOneSensorMap =
            this.getConcept()?.internalaccessories?.Four_in_one_sensor || {}

        let fourInOneSensorName = null
        Object.keys(fourInOneSensorMap).some((val) => {
            if (fourInOneSensorMap[val] == true) {
                fourInOneSensorName = val
                return true
            } else {
                return false
            }
        })

        switch (fourInOneSensorName) {
            case 'isGestureSensor': {
                return renderPrgImage('gesturesensorActive')
            }
            case 'isDistanceSensors': {
                return renderPrgImage('distancesensorsActive')
            }
            case 'isLightSensor': {
                return renderPrgImage('lightsensorActive')
            }
        }
    }

    handleInternalAccessories = () => {
        let imagelist = []
        let statelist = []

        const ia = this.getConcept()?.internalaccessories || {}

        if (ia.isIr) {
            imagelist.push('irActive')
            statelist.push('ir')
        }
        if (ia.isBattery) {
            imagelist.push('batteryActive')
            statelist.push('battery')
        }
        if (ia.isTemperature) {
            imagelist.push('tempActive')
            statelist.push('temprature')
        }

        if (ia.isAccelerometer) {
            imagelist.push('accelerometerActive')
            statelist.push('accelerometer')
        }

        if (ia.isFour_in_one_sensor) {
            let Four_in_one_sensor = ia.Four_in_one_sensor || {}
            Object.keys(Four_in_one_sensor).map((val, inx) => {
                if (Four_in_one_sensor[val] === true) {
                    switch (val) {
                        case 'isGestureSensor': {
                            imagelist.push('gesturesensorActive')
                            statelist.push('gesture')
                            return
                        }
                        case 'isDistanceSensors': {
                            imagelist.push('distancesensorsActive')
                            statelist.push('distance')
                            return
                        }
                        case 'isLightSensor': {
                            imagelist.push('lightsensorActive')
                            statelist.push('light')
                            return
                        }
                        case 'isColorSensor': {
                            imagelist.push('colorsensorActive')
                            return
                        }
                    }
                }
            })
        }

        return (
            <div className="propertyPanel">
                {imagelist.length >= 1 ? (
                    <>
                        {imagelist.length === 1 ? (
                            <>
                                {imagelist[0] !== 'colorsensorActive' &&
                                imagelist[0] !== 'accelerometerActive' ? (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            right: '7%',
                                            transform: 'translateY(-50%)',
                                            borderRadius: '46px',
                                            background: '#f4f4f4',
                                        }}
                                    >
                                        <div
                                            style={{
                                                fontSize: '12px',
                                                color: '#707070',
                                                margin: '10px',
                                                textAlign: 'center',
                                            }}
                                        >
                                            <img
                                                src={renderPrgImage(
                                                    imagelist[0]
                                                )}
                                                style={{
                                                    height: '45px',
                                                    width: '45px',
                                                }}
                                            />
                                            <p
                                                style={{
                                                    marginTop: '15px',
                                                }}
                                            >
                                                {this.state[statelist[0]]}{' '}
                                            </p>
                                        </div>
                                    </div>
                                ) : (
                                    <div
                                        className="propertyPanel-Details-colorSensor-Temp"
                                        style={{ height: '165px' }}
                                    >
                                        <div className="colorSensor-container">
                                            <div>
                                                <img
                                                    src={renderPrgImage(
                                                        imagelist[0]
                                                    )}
                                                    style={{
                                                        height: '45px',
                                                        width: '45px',
                                                        marginTop: '5px',
                                                    }}
                                                />
                                                <p
                                                    style={{
                                                        color: '#707070',
                                                        fontSize: '12px',
                                                        marginTop: '5px',
                                                        transform:
                                                            'translateX(20%)',
                                                    }}
                                                ></p>
                                            </div>
                                            {imagelist[0] ===
                                            'colorsensorActive' ? (
                                                <div>
                                                    <p
                                                        style={{
                                                            color: '#F16178',
                                                        }}
                                                    >
                                                        R : {this.state.red}
                                                    </p>
                                                    <p
                                                        style={{
                                                            color: '#3BB273',
                                                        }}
                                                    >
                                                        G : {this.state.green}
                                                    </p>
                                                    <p
                                                        style={{
                                                            color: '#30A8CE',
                                                        }}
                                                    >
                                                        B : {this.state.blue}
                                                    </p>
                                                </div>
                                            ) : (
                                                <>
                                                    <div>
                                                        <p>
                                                            {' '}
                                                            X :{' '}
                                                            {
                                                                this.state
                                                                    .accelerometer_X
                                                            }
                                                        </p>
                                                        <p>
                                                            {' '}
                                                            Y :{' '}
                                                            {
                                                                this.state
                                                                    .accelerometer_Y
                                                            }
                                                        </p>
                                                        <p>
                                                            {' '}
                                                            Z :{' '}
                                                            {
                                                                this.state
                                                                    .accelerometer_Z
                                                            }
                                                        </p>
                                                        <p>
                                                            {' '}
                                                            X :{' '}
                                                            {this.state.gyro_X}
                                                        </p>
                                                        <p>
                                                            {' '}
                                                            Y :{' '}
                                                            {this.state.gyro_Y}
                                                        </p>
                                                        <p>
                                                            {' '}
                                                            Z :{' '}
                                                            {this.state.gyro_Z}
                                                        </p>
                                                    </div>
                                                    {/* <div>
                                                   
                                                    </div> */}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </>
                        ) : (
                            <div
                                className="propertyPanel-Details-colorSensor"
                                style={{ height: 'auto' }}
                            >
                                {imagelist.map((value, index) => {
                                    return (
                                        <div>
                                            {value !== 'colorsensorActive' &&
                                            value !== 'accelerometerActive' ? (
                                                <div
                                                    style={{
                                                        fontSize: '12px',
                                                        color: '#707070',
                                                        margin: '10px',
                                                        display: 'flex',
                                                    }}
                                                >
                                                    <img
                                                        src={renderPrgImage(
                                                            value
                                                        )}
                                                        style={{
                                                            height: '45px',
                                                            width: '45px',
                                                        }}
                                                    />
                                                    <p
                                                        style={{
                                                            marginTop: '12px',
                                                            textAlign: 'center',
                                                            paddingLeft:
                                                                '2.5vh',
                                                        }}
                                                    >
                                                        {
                                                            this.state[
                                                                statelist[index]
                                                            ]
                                                        }
                                                    </p>
                                                </div>
                                            ) : (
                                                <div>
                                                    {value ===
                                                    'colorsensorActive' ? (
                                                        <>
                                                            <div
                                                                className="colorSensor-container"
                                                                style={{
                                                                    margin: ' 8% 0% 8% 8%',
                                                                }}
                                                            >
                                                                <div>
                                                                    <img
                                                                        src={renderPrgImage(
                                                                            value
                                                                        )}
                                                                        style={{
                                                                            height: '45px',
                                                                            width: '45px',
                                                                            marginTop:
                                                                                '5px',
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div>
                                                                    <p
                                                                        style={{
                                                                            color: '#F16178',
                                                                        }}
                                                                    >
                                                                        R :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .red
                                                                        }
                                                                    </p>
                                                                    <p
                                                                        style={{
                                                                            color: '#3BB273',
                                                                        }}
                                                                    >
                                                                        G :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .green
                                                                        }
                                                                    </p>
                                                                    <p
                                                                        style={{
                                                                            color: '#30A8CE',
                                                                        }}
                                                                    >
                                                                        B :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .blue
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div
                                                                className="colorSensor-container"
                                                                style={{
                                                                    margin: ' 8% 10% 60% 8%',
                                                                }}
                                                            >
                                                                <div>
                                                                    <img
                                                                        src={renderPrgImage(
                                                                            value
                                                                        )}
                                                                        style={{
                                                                            height: '45px',
                                                                            width: '45px',
                                                                            marginTop:
                                                                                '5px',
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        height: '148px',
                                                                    }}
                                                                >
                                                                    <p>
                                                                        X :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .accelerometer_X
                                                                        }
                                                                    </p>
                                                                    <p>
                                                                        Y :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .accelerometer_Y
                                                                        }
                                                                    </p>
                                                                    <p>
                                                                        Z :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .accelerometer_Z
                                                                        }
                                                                    </p>

                                                                    <p>
                                                                        {' '}
                                                                        X :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .gyro_X
                                                                        }
                                                                    </p>
                                                                    <p>
                                                                        {' '}
                                                                        Y :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .gyro_Y
                                                                        }
                                                                    </p>
                                                                    <p>
                                                                        {' '}
                                                                        Z :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .gyro_Z
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    )
                                })}
                            </div>
                        )}
                    </>
                ) : null}
            </div>
        )
    }

    buttonClicked = async () => {
        let isAi_lidarSelect =
            this.props?.assemblyTwo?.assemblyPageAi?.aiItems?.ai_lidar
        let isAi_1Connected = this.props?.assemblyTwo?.PortConnections?.A?.type

        //if AI-1 connect to the A poart if user doesnot select the lidar, paread does not work
        // if (isAi_1Connected === 'pcAiTool' && !isAi_lidarSelect) {
        //     return
        // }
        if (this.props.assemblyTwo.assemblyPageAi.isShowAiSelectContainer) {
            let assemblyPageAi = { ...this.props.assemblyTwo.assemblyPageAi }
            assemblyPageAi.isShowAiSelectContainer = false
            this.props.setAssemblyPageAi(assemblyPageAi)
        }
        if (
            ['Humanoid', 'Hexapod', 'Klaw'].includes(
                sessionStorage.getItem('connectedDevice')
            )
        ) {
            await this.setState({ isReading: true })
            this.setState({ isPopup: true })
            this.handleReadByte_v1()
        } else {
            await this.setState({ isPcActive: true })
            this.setState({ isPopup: true })
            this.handleReadByte_v1()
        }
    }
    onBack = async () => {
        goBack = true
    }
    stopPaOnBack = () => {
        if (this.state.isPcActive) {
            this.setState({ readbytes: false })
            this.setState({ isPcActive: false })
        }
        if (this.state.isReading) {
            this.setState({ isReading: false })
            sessionStorage.setItem('isReadingZingPA', false)
            // this.continuesPAstop()
        }
    }

    //show popup message handel on click ai model select
    showAiModelPopUp = ({ elementKey, text, time = 1500 }) => {
        let aiItems = this.props.assemblyTwo?.assemblyPageAi?.aiItems
        let popMessage = ''

        if (this.aiModelPopTimeOut) {
            clearTimeout(this.aiModelPopTimeOut)
        }

        if (text) {
            popMessage = elementKey
        } else {
            let element = elementKey.split('_')
            element[0] = 'AI'
            element = element.join(' ')
            if (aiItems[elementKey]) {
                popMessage = `${element} deselected`
            } else {
                popMessage = `${element} selected`
            }
        }
        this.setState({
            aiModelPopUpState: {
                message: popMessage,
                showPopup: true,
            },
        })

        this.aiModelPopTimeOut = setTimeout(() => {
            popMessage = ''
            this.setState({
                aiModelPopUpState: {
                    message: '',
                    showPopup: false,
                },
            })
        }, time)
    }

    getDeviceName = () => {
        const connectedDevice = sessionStorage.getItem('connectedDevice')
        let deviceName = 'PeeCee'
        switch (connectedDevice) {
            case 'Ace':
                deviceName = 'PeeCee'
                break
            case 'Humanoid':
                deviceName = 'Zing'
                break
            case 'Hexapod':
                deviceName = 'Crawl-e'
                break
            case 'Klaw':
                deviceName = 'Klaw-b'
                break
            default:
                deviceName = connectedDevice
        }
        return deviceName
    }

    // isShowAimodelLowerVersion = () => {
    //     let selectedComp =
    //         JSON.parse(sessionStorage.getItem('SelectedComp')) || []
    //     let d = selectedComp.some((ele) => {
    //         return ele.type === 'pcAiTool'
    //     })

    //     if (d) {
    //         let connectedDevice = sessionStorage.getItem('connectedDevice')
    //         let deviceVersion = sessionStorage.getItem('deviceVersion')

    //         if (
    //             this.props.webSerial.isConnected &&
    //             !isAi1ShowCondition({ connectedDevice, deviceVersion })
    //         ) {
    //             return true
    //         }
    //     }
    //     return false
    // }
    handelCloseAiModel = () => {
        if (this.state.isShowLowerVersionPopup) {
            this.setState({ isShowLowerVersionPopup: false })
            return
        }
        this.props.setAssemblyPageAi({
            ...this.props.assemblyTwo.assemblyPageAi,
            isShowLowerVersionPopup: false,
        })
    }

    handleClickOutside = (event) => {
        if (
            this.subtitleRef.current &&
            !this.subtitleRef.current.contains(event.target) &&
            this.state.showSubtitleDisplay
        ) {
            this.setState({ showSubtitleDisplay: false })
            this.setState({ aiSpeaking: true })
        }
    }

    handleActiveWireCancel = () => {
        // Click on empty canvas while routing a wire → cancel it. The pin stays
        // disconnected (target-pin / button clicks stopPropagation so they don't
        // reach here).
        if (!this.state.activeRgbWire) return

        // Poki: once a pin is dropped on a port, its hint behaves like a placed
        // wire and must persist on outside clicks (removed only via its pin
        // button). But while the wire is still being routed (not yet connected),
        // an outside click cancels it just like every other device.
        if (sessionStorage.getItem('connectedDevice') === 'Poki') {
            const { activeRgbWire, activeRgbComponent } = this.state
            const pc = activeRgbComponent
                ? this.getPinConnections(
                      activeRgbComponent.type,
                      activeRgbComponent.index
                  )
                : {}
            if (pc && pc[activeRgbWire]) return // connected → keep the placed hint
        }

        this.setState({ activeRgbWire: null, activeRgbComponent: null })
    }

    runTypewriterEffect = (text) => {
        // Clear any existing interval
        if (this.typewriterInterval) clearInterval(this.typewriterInterval)

        if (!text || !this.state.aiVoiceover) {
            this.setState({ typewriterText: text || '', aiSpeaking: false })
            return
        }

        this.setState({ typewriterText: '', aiSpeaking: true })

        let i = 0
        this.typewriterInterval = setInterval(() => {
            i++
            // Update state regardless of visibility (Background typing)
            this.setState({ typewriterText: text.slice(0, i) })

            if (i >= text.length) {
                clearInterval(this.typewriterInterval)
                // this.setState({ aiSpeaking: false })
            }
        }, 30)
    }

    getCurrentInstruction = () => {
        const { assemblySteps, stepsSlideIndex } = this.state
        if (!assemblySteps || !assemblySteps.steps) return ''

        const isFinalSlide = stepsSlideIndex === assemblySteps.steps.length

        if (isFinalSlide) {
            return (
                assemblySteps.finalStepInstruction ||
                'Congratulations on completing your electronic connections! Click Continue to proceed.'
            )
        }

        const activeStep = assemblySteps.steps[stepsSlideIndex]
        if (!activeStep) return ''

        return activeStep.instruction || ''
    }

    render() {
        // Hold the board until the target step's workspace is built. On a fresh
        // navigation into this screen, Redux still holds the PREVIOUS visit's
        // assembly, which would flash for ~1s until the async step load rebuilds
        // it. Gate only in Make/tutorial mode; standalone renders immediately.
        if (
            (this.context?.isMake || this.props.data) &&
            !this.state.stepsReady
        ) {
            return (
                <div
                    style={{
                        width: '100%',
                        height: '100%',
                        backgroundColor: '#FCFCFC',
                    }}
                />
            )
        }

        goBack = false
        const languageName = this.props.device.language
        // let vv = JSON.parse(localStorage.getItem("SavedData"));
        // console.log(vv[4].assembly, "DATA OF PORTS");
        var selectionType = localStorage.getItem('programMode')

        if (selectionType == 'program') {
            this.state.visible = 'visible'
        }
        // this.isShowAimodelLowerVersion()
        const propertyPanelStyle = {
            // backgroundImage: `url("${propertypanel}")`,
            // backgroundRepeat: "no-repeat",
            // backgroundSize: "100% 100%",
            // backgroundPosition: "center",
        }

        // Inside render()
        const stepsData = this.state.assemblySteps
        const totalSlides = this.getStepsSlideCount(stepsData)
        const activeSlideIndex = this.state.stepsSlideIndex

        // Check if we are on that extra +1 slide
        const isFinalSlide =
            stepsData && activeSlideIndex === stepsData.steps.length

        const slideTitle = isFinalSlide
            ? stepsData?.finalStepTitle || 'All components assembled!'
            : stepsData?.steps?.[activeSlideIndex]?.title || ''

        const slideInstruction = isFinalSlide
            ? stepsData?.finalStepInstruction ||
              'Congratulations on completing your electronic connections! Click Continue to proceed.'
            : stepsData?.steps?.[activeSlideIndex]?.instruction || ''

        const concept = this.getConcept()
        const fourInOneSensorMap =
            concept?.internalaccessories?.Four_in_one_sensor || {}

        let fourInOneSensorName = null
        const isFourInOneSensor = Object.keys(fourInOneSensorMap).some((val) => {
            if (fourInOneSensorMap[val] == true) {
                fourInOneSensorName = val
                return true
            } else {
                return false
            }
        })

        const isTempratureSensor = concept?.internalaccessories?.isTemperature

        const version = sessionStorage.getItem('deviceVersion')
        const connectedDevice = sessionStorage.getItem('connectedDevice')
        const { slideDirection } = this.state

        const { isHelp } = this.state

        // Detect mode from URL
        const urlParams = new URLSearchParams(window.location.search)
        const isPreviewMode = urlParams.get('preview') === 'true'

        return (
            <div
                className="assembly-app-container"
                style={{ overflowY: 'hidden' }}
                ref={this.appContainerRef}
            >
                {/* Floating Exit Button for preview mode */}
                {isPreviewMode && (
                    <button
                        onClick={() => this.props.history.goBack()}
                        style={{
                            position: 'fixed',
                            top: '12vh',
                            right: '30px',
                            zIndex: 9999,
                            background: '#ef4444',
                            color: 'white',
                            border: 'none',
                            padding: '12px 24px',
                            borderRadius: '50px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            boxShadow: '0 4px 15px rgba(239, 68, 68, 0.4)',
                            fontSize: '14px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                        }}
                    >
                        <MdOutlineArrowBack size={18} /> Exit Preview
                    </button>
                )}

                {/* <ProgramHeaderTwo
                    data={{
                        options: ['Mechanical', 'Electronic', 'Coding', 'Simulate'],
                        selected: 1,
                        isCustomHeader: true,
                    }}
                    showSave={true}
                    showHelp={true}
                    handleHelp={this.helpBtn}
                    onTabClick={this.handleHeaderTabClick}
                /> */}
                {!this.context?.setHeaderProps && (
                    <div
                        className="Select_Headers"
                        style={{
                            position: 'relative',
                            zIndex: 999999,
                            isolation: 'isolate',
                        }}
                    >
                        {this.context || isPreviewMode ? (
                            <MakeHeader
                                showTimeline={true}
                                title={this.state.assemblySteps?.title || ''}
                                showJumpTo={false}
                                titlePosition="left"
                                help_btnPosition="right"
                                isGoBack={true}
                                showSave={true}
                                showAssemblyHelp={true}
                                showBluetoothBtn={true}
                                currentStep={this.state.stepsSlideIndex + 1}
                                // UPDATED: Tell the timeline there is an extra final step
                                totalSteps={
                                    (this.state.assemblySteps?.steps?.length ||
                                        0) + 1
                                }
                                // UPDATED: Push the final title to the end of the step titles array
                                stepTitles={
                                    this.state.assemblySteps?.steps
                                        ? [
                                              ...this.state.assemblySteps.steps.map(
                                                  (s) => s.title || ''
                                              ),
                                              this.state.assemblySteps
                                                  .finalStepTitle ||
                                                  'Assembly Complete!',
                                          ]
                                        : ['Assembly Complete!']
                                }
                                onStepClick={(stepNum) => {
                                    // stepNum is 1-based from ProgramTimelineNav
                                    const slideIndex = stepNum - 1

                                    // Rebuild board state AND update UI in one pass
                                    this.buildWorkspaceForStep(slideIndex, {
                                        updateUI: true,
                                    })

                                    if (this.state.aiVoiceover) {
                                        this.playAudioForStep(slideIndex)
                                    }
                                }}
                            />
                        ) : (
                            <MakeHeader
                                title={this.state.assemblySteps?.title || ''}
                                showJumpTo={!isPreviewMode}
                                data={{
                                    options: [
                                        'Mechanical',
                                        'Electronic',
                                        'Coding',
                                        'Simulate',
                                    ],
                                    selected: 1,
                                    isCustomHeader: true,
                                }}
                                onJumpClick={this.handleHeaderTabClick}
                                titlePosition="left"
                                help_btnPosition="right"
                                isGoBack={true}
                                goBack={this.goBack}
                                // showAccountSetting={true}
                                showSave={!isPreviewMode}
                                showAssemblyHelp={true}
                                showBluetoothBtn={true}
                            />
                        )}
                    </div>
                )}

                <div
                    className="assembly-main-area"
                    style={{
                        position: 'relative',
                        zIndex: 10,
                        isolation: 'isolate',
                    }}
                >
                    {/* AI Speaking Pill / Subtitle Box — morphs between shapes */}
                    <div
                        ref={this.subtitleRef}
                        style={{
                            position: 'absolute',
                            top: '10px',
                            left: '50%',
                            transform: !this.state.subtitleVisible
                                ? 'translateX(-50%) translateY(-120vh)'
                                : 'translateX(-50%)',
                            maxWidth: !this.state.showSubtitleDisplay
                                ? '280px'
                                : '600px',
                            maxHeight: !this.state.showSubtitleDisplay
                                ? '44px'
                                : '150px',
                            borderRadius: !this.state.showSubtitleDisplay
                                ? '20px'
                                : '20px',
                            padding: !this.state.showSubtitleDisplay
                                ? '0 18px'
                                : '12px 24px',
                            background: !this.state.showSubtitleDisplay
                                ? 'rgba(60, 60, 120, 0.13)'
                                : 'rgba(255, 255, 255, 0.3)',
                            backdropFilter: 'blur(10px)',
                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                            border: '1px solid rgba(0, 0, 0, 0.08)',
                            display: 'grid',
                            gridTemplateRows: !this.state.showSubtitleDisplay
                                ? '44px'
                                : 'auto',
                            alignItems: 'center',
                            justifyItems: 'center',
                            overflow: 'hidden',
                            zIndex: 101,
                            cursor: !this.state.showSubtitleDisplay
                                ? 'pointer'
                                : 'default',
                            opacity: !this.state.subtitleVisible ? 0 : 1,
                            pointerEvents: !this.state.subtitleVisible
                                ? 'none'
                                : 'auto',
                            transition: [
                                'transform 1s cubic-bezier(0.4, 0, 0.2, 1)',
                                'max-width 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                                'max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                                'border-radius 0.45s ease',
                                'padding 0.4s ease',
                                'background 0.45s ease',
                                'opacity 0.6s ease',
                            ].join(', '),
                        }}
                        onClick={
                            !this.state.showSubtitleDisplay
                                ? () =>
                                      this.setState({
                                          showSubtitleDisplay: true,
                                      })
                                : undefined
                        }
                    >
                        {/* Pill content — visible when collapsed */}
                        <div
                            style={{
                                gridArea: '1/1',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px',
                                fontWeight: 600,
                                fontSize: '1rem',
                                color: '#2f2e65',
                                fontFamily: 'Halcyon_SemiBold, sans-serif',
                                whiteSpace: 'nowrap',
                                opacity: !this.state.showSubtitleDisplay
                                    ? 1
                                    : 0,
                                transition: 'opacity 0.2s ease',
                                transitionDelay: !this.state.showSubtitleDisplay
                                    ? '0.25s'
                                    : '0s',
                                pointerEvents: 'none',
                            }}
                        >
                            <BsStars size={20} style={{ color: '#2f2e65' }} />
                            {this.state.aiVoiceover
                                ? 'AI is speaking...'
                                : 'Click to expand'}
                        </div>
                        {/* Subtitle text — visible when expanded */}
                        <div
                            style={{
                                gridArea: '1/1',
                                fontSize: '1.1rem',
                                color: '#333',
                                wordBreak: 'break-word',
                                whiteSpace: 'pre-wrap',
                                fontFamily: 'Halcyon Regular, sans-serif',
                                lineHeight: '1.5',
                                textAlign: 'center',
                                opacity: !this.state.showSubtitleDisplay
                                    ? 0
                                    : 1,
                                transition: 'opacity 0.2s ease',
                                transitionDelay: !this.state.showSubtitleDisplay
                                    ? '0s'
                                    : '0.25s',
                                pointerEvents: 'none',
                                width: '100%',
                            }}
                        >
                            {this.state.aiVoiceover
                                ? this.state.typewriterText
                                : this.getCurrentInstruction()}
                        </div>
                    </div>

                    {/* Inline tutorial notice — floats just above the footer.
                        Auto-hides, and is dismissible. Used for: (1) clicking a
                        sidebar component that isn't part of the current step, and
                        (2) interacting with a locked, already-completed component. */}
                    {this.state.tutorialMessage &&
                        (() => {
                            const isLocked =
                                this.state.tutorialMessage.tone === 'locked'
                            const theme = isLocked
                                ? {
                                      bg: 'rgba(238, 242, 255, 0.97)',
                                      border: 'rgba(99, 102, 241, 0.55)',
                                      accent: '#4338ca',
                                      text: '#3730a3',
                                  }
                                : {
                                      bg: 'rgba(255, 251, 235, 0.97)',
                                      border: 'rgba(245, 158, 11, 0.55)',
                                      accent: '#b45309',
                                      text: '#92400e',
                                  }
                            return (
                                <div
                                    role="status"
                                    aria-live="polite"
                                    style={{
                                        position: 'fixed',
                                        bottom: '96px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        zIndex: 100000,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px',
                                        maxWidth: '560px',
                                        padding: '12px 14px 12px 16px',
                                        borderRadius: '14px',
                                        background: theme.bg,
                                        border: `1px solid ${theme.border}`,
                                        borderLeft: `4px solid ${theme.accent}`,
                                        backdropFilter: 'blur(10px)',
                                        WebkitBackdropFilter: 'blur(10px)',
                                        boxShadow:
                                            '0 10px 30px rgba(0, 0, 0, 0.16)',
                                        animation:
                                            'assemblyNoticeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1)',
                                    }}
                                >
                                    <style>
                                        {`@keyframes assemblyNoticeIn {
                                            from { opacity: 0; transform: translateX(-50%) translateY(12px); }
                                            to   { opacity: 1; transform: translateX(-50%) translateY(0); }
                                        }`}
                                    </style>
                                    <span
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: theme.accent,
                                            flexShrink: 0,
                                        }}
                                    >
                                        {isLocked ? (
                                            <MdLock size={22} />
                                        ) : (
                                            <MdInfoOutline size={22} />
                                        )}
                                    </span>
                                    <span
                                        style={{
                                            fontSize: '0.95rem',
                                            lineHeight: 1.4,
                                            color: theme.text,
                                            fontFamily:
                                                'Halcyon_SemiBold, sans-serif',
                                        }}
                                    >
                                        {this.state.tutorialMessage.text}
                                    </span>
                                    <button
                                        onClick={this.dismissTutorialMessage}
                                        aria-label="Dismiss"
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            border: 'none',
                                            background: 'transparent',
                                            color: theme.accent,
                                            cursor: 'pointer',
                                            padding: '2px',
                                            marginLeft: '2px',
                                            flexShrink: 0,
                                            opacity: 0.75,
                                        }}
                                    >
                                        <MdClose size={18} />
                                    </button>
                                </div>
                            )
                        })()}

                    <div
                        style={{
                            height: '10%',
                            width: '100%',
                            position: 'absolute',
                            userSelect: 'none',
                            marginTop: '60px',
                        }}
                    >
                        <DialogModal
                            show={
                                this.props.assemblyTwo?.assemblyPageAi
                                    ?.isShowLowerVersionPopup ||
                                this.state.isShowLowerVersionPopup
                            }
                            text={
                                <p>
                                    {`AI-1 accessory is not compatible with the current firmware version. Please update the ${this.getDeviceName()} using the firmware updation tool `}
                                    <a
                                        href="https://firmware.plode.org"
                                        target="_blank"
                                    >
                                        Here.
                                    </a>
                                </p>
                            }
                            // optionsToSelect={[
                            //     {
                            //         text: 'BACK',
                            //         do: () => {
                            //             this.props.history.push('/kitSelection')
                            //         },
                            //     },
                            // ]}
                            showCloseBtn={true}
                            handleDialogModalClose={() =>
                                this.handelCloseAiModel()
                            }
                        />
                        <DialogModal
                            show={
                                this.props.assemblyTwo?.assemblyPageAi
                                    ?.isShowDeviceNotConnectPopUp
                            }
                            text={`Please ensure the ${this.getDeviceName()} and AI-1 are connected before proceeding.`}
                            showCloseBtn={true}
                            handleDialogModalClose={() =>
                                this.props.setAssemblyPageAi({
                                    ...this.props.assemblyTwo.assemblyPageAi,
                                    isShowDeviceNotConnectPopUp: false,
                                })
                            }
                        />
                        <div
                            className="navbarContainer"
                            style={{ zIndex: '1000' }}
                        >
                            <div
                                className="navbar-Action"
                                style={{ alignItems: 'center' }}
                            >
                                {this.state.isHelp && (
                                    <div
                                        className="Ss_slide"
                                        style={{
                                            width: '106vw',
                                            top: '39vh',
                                            left: '-55%',
                                            height: '105vh',
                                        }}
                                    >
                                        <AssemblyPrgm />
                                        <img
                                            className="helpClo"
                                            src={renderPrgImage('closBtn')}
                                            onClick={this.helpBtn}
                                        ></img>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div
                        className={`${
                            slideDirection === 'true'
                                ? 'slide-right'
                                : 'slide-left'
                        }`}
                        style={{ height: '100vh', width: '100vw' }}
                    >
                        {' '}
                        <div
                            id="assemblyscreenid"
                            className="pure-g assemblyScreen"
                            style={{
                                width: '100%',
                                height: '100%',
                                overflow: 'hidden',
                            }}
                        >
                            {/* Hidden audio element */}
                            <audio
                                ref={this.audioRef}
                                style={{ display: 'none' }}
                            />
                            <div
                                className="pure-u-1-5 user-select"
                                style={{ marginTop: '0%' }}
                            >
                                <Sidebar
                                    saveToLocalStorage={this.saveToLocalStorage}
                                    removeFromWorkspace={
                                        this.removeFromWorkspace
                                    }
                                    highlightComponentType={
                                        this.state.highlightComponentType
                                    }
                                    onBlockedComponentClick={
                                        this.notifyBlockedSidebarComponent
                                    }
                                    shield={this.state.shield}
                                    setShield={this.setShield}
                                    armShield={this.state.armShield}
                                    setArmShield={this.setArmShield}
                                    peeCeeATR={this.state.peeCeeATR}
                                    setPeeCeeATR={this.setPeeCeeATR}
                                    reader={reader}
                                    port={this.props.webSerial.port}
                                    onBack={this.onBack}
                                    humanoidRead={
                                        connectedDevice == 'Hexapod'
                                            ? this.setPaBytes_Hexapod
                                            : connectedDevice == 'Klaw'
                                              ? this.klawPAread
                                              : this.setPaBytes_ZingV1V2
                                    }
                                    stopPA={this.stopPaOnBack}
                                    check={this.check}
                                    onMouse={this.handleMouseDown}
                                    slideDirection={this.slideDirection}
                                />
                            </div>
                            <div id="screenshotid" className="pure-u-4-5">
                                <div
                                    id="assemblyConnections"
                                    style={{
                                        position: 'absolute',
                                        width: '80%',
                                        height: '100%',
                                        zIndex: 1,
                                    }}
                                    onWheel={this.wheel}
                                >
                                    {/* IMG of ACE and  Sensor Img */}
                                    {version?.startsWith('1') &&
                                    ['Ace'].includes(connectedDevice) ? (
                                        <WorkSpace
                                            workspace={
                                                this.props.assemblyTwo.workspace
                                            }
                                            isReading={this.state.isReading}
                                            isPcActive={this.state.isPcActive}
                                            update={
                                                this.props.assemblyComponent
                                            }
                                            appState={this.props}
                                            height={this.props.height}
                                            width={this.props.width * 0.8}
                                            prop={this.props.assemblyTwo}
                                            webSerial={this.props.webSerial}
                                            updatePort={
                                                this.props.PortConnections
                                            }
                                            setAssemblyPageAi={
                                                this.props.setAssemblyPageAi
                                            }
                                            componentsData={
                                                this.props.assemblyTwo
                                                    .components
                                            }
                                            removeFromWorkspace={
                                                this.removeFromWorkspace
                                            }
                                            stopPA={this.stopPaOnBack}
                                            nextVisbility={this.nextVisbility}
                                            responceTp0={this.state.responceTp0}
                                            responceTp1={this.state.responceTp1}
                                            responceTp2={this.state.responceTp2}
                                            touch_pad={this.state.touch_pad}
                                            touch_pad2={this.state.touch_pad2}
                                            rangeA1={this.state.rangeA1}
                                            rangeA2={this.state.rangeA2}
                                            rangeB1={this.state.rangeB1}
                                            rangeB2={this.state.rangeB2}
                                            rangeC1={this.state.rangeC1}
                                            rangeC2={this.state.rangeC2}
                                            rangeD1={this.state.rangeD1}
                                            rangeD2={this.state.rangeD2}
                                            rangeE1={this.state.rangeE1}
                                            rangeE2={this.state.rangeE2}
                                            rangeF1={this.state.rangeF1}
                                            rangeF2={this.state.rangeF2}
                                            rangeG1={this.state.rangeG1}
                                            rangeG2={this.state.rangeG2}
                                            rangeservo_motor1={
                                                this.state.rangeservo_motor1
                                            }
                                            rangeservo_motor2={
                                                this.state.rangeservo_motor2
                                            }
                                            tactswitch={this.state.tactswitch}
                                            mic={this.state.mic}
                                            temp={this.state.temp}
                                            gas={this.state.gas}
                                            zero={this.state.zero}
                                            one={this.state.one}
                                            two={this.state.two}
                                            switch1={this.state.switch1}
                                            switch2={this.state.switch2}
                                            ir={this.state.ir}
                                            shield={this.state.shield}
                                            setShield={this.setShield}
                                            setPeeCeeATR={this.setPeeCeeATR}
                                        />
                                    ) : (
                                        <WorkSpace
                                            workspace={
                                                this.props.assemblyTwo.workspace
                                            }
                                            isPcActive={this.state.isPcActive}
                                            isReading={this.state.isReading}
                                            update={
                                                this.props.assemblyComponent
                                            }
                                            appState={this.props}
                                            height={this.props.height}
                                            width={this.props.width * 0.8}
                                            prop={this.props.assemblyTwo}
                                            webSerial={this.props.webSerial}
                                            updatePort={
                                                this.props.PortConnections
                                            }
                                            setAssemblyPageAi={
                                                this.props.setAssemblyPageAi
                                            }
                                            componentsData={
                                                this.props.assemblyTwo
                                                    .components
                                            }
                                            removeFromWorkspace={
                                                this.removeFromWorkspace
                                            }
                                            stopPA={this.stopPaOnBack}
                                            handleReadBytes={
                                                this.handleReadBytes
                                            }
                                            nextVisbility={this.nextVisbility}
                                            responceTp0={this.state.responceTp0}
                                            responceTp1={this.state.responceTp1}
                                            responceTp2={this.state.responceTp2}
                                            touch_pad={this.state.touch_pad}
                                            touch_pad2={this.state.touch_pad2}
                                            rangeA1={this.state.rangeA1}
                                            rangeA2={this.state.rangeA2}
                                            rangeB1={this.state.rangeB1}
                                            rangeB2={this.state.rangeB2}
                                            rangeC1={this.state.rangeC1}
                                            rangeC2={this.state.rangeC2}
                                            rangeD1={this.state.rangeD1}
                                            rangeD2={this.state.rangeD2}
                                            rangeE1={this.state.rangeE1}
                                            rangeE2={this.state.rangeE2}
                                            rangeF1={this.state.rangeF1}
                                            rangeF2={this.state.rangeF2}
                                            rangeG1={this.state.rangeG1}
                                            rangeG2={this.state.rangeG2}
                                            rangeservo_motor1={
                                                this.state.rangeservo_motor1
                                            }
                                            rangeservo_motor2={
                                                this.state.rangeservo_motor2
                                            }
                                            tactswitch={this.state.tactswitch}
                                            mic={this.state.mic}
                                            temp={this.state.temp}
                                            gas={this.state.gas}
                                            zero={this.state.zero}
                                            one={this.state.one}
                                            two={this.state.two}
                                            switch1={this.state.switch1}
                                            switch2={this.state.switch2}
                                            ir={this.state.ir}
                                            shield={this.state.shield}
                                            setShield={this.setShield}
                                            armShield={this.state.armShield}
                                            setArmShield={this.setArmShield}
                                            peeCeeATR={this.state.peeCeeATR}
                                            setPeeCeeATR={this.setPeeCeeATR}
                                        />
                                    )}
                                    {/* <AssemblyStepsSlideshow
                                        slideIndex={activeSlideIndex}
                                        totalSlides={totalSlides}
                                        title={slideTitle}
                                        instruction={slideInstruction}
                                        onPrev={this.handleStepsPrev}
                                        onNext={this.handleStepsNext}
                                    /> */}
                                </div>
                            </div>

                            {/* WIRE ,WHITE DOTS POINT_ON ACE, SHOWS IMG at Draging Time   */}
                            <CustomDragLayer
                                style={{
                                    float: 'right',
                                    width: '75%',
                                    height: '100%',
                                    position: 'relative',
                                }}
                                height={this.props.height}
                                width={this.props.width}
                                workspace={this.props.assemblyTwo.workspace}
                                PortConnections={
                                    this.props.assemblyTwo.PortConnections
                                }
                                shield={this.state.shield}
                                setShield={this.setShield}
                                armShield={this.state.armShield}
                                setArmShield={this.setArmShield}
                                peeCeeATR={this.state.peeCeeATR}
                                setPeeCeeATR={this.setPeeCeeATR}
                                highlightPort={this.state.highlightPort}
                                isForced={this.state.isForced}
                                isFinalSlide={isFinalSlide}
                                appState={this}
                            />

                            {/* ---------- AI Select div -----------*/}
                            {this.props.assemblyTwo?.assemblyPageAi
                                ?.isShowAiSelectContainer && (
                                <div>
                                    <AiModeSelect
                                        showAiModelPopUp={this.showAiModelPopUp}
                                    />
                                </div>
                            )}

                            {!this.context?.setHeaderProps && (
                                <div className="toolbar-sidebar">
                                    <button
                                        className={`toolbar-button ${this.state.aiVoiceover ? 'active' : ''}`}
                                        title="AI Voiceover"
                                        onClick={() => {
                                            this.handleAiVoiceoverToggle()
                                            this.setState({
                                                subtitleVisible:
                                                    !this.state.aiVoiceover,
                                                showSubtitleDisplay:
                                                    !this.state.aiVoiceover,
                                            })
                                        }}
                                    >
                                        <BsStars />
                                    </button>
                                    <button
                                        className="toolbar-button"
                                        title="Fullscreen"
                                        onClick={this.handleFullscreen}
                                    >
                                        <MdFullscreen />
                                    </button>
                                    <button
                                        className="toolbar-button"
                                        title="Reset"
                                        onClick={this.resetTutorial}
                                    >
                                        <RxReset />
                                    </button>
                                </div>
                            )}

                            {[
                                'Ace',
                                'Roboki',
                                'Atr',
                                'Toki',
                                'Poki',
                                'Moki',
                            ].includes(connectedDevice) ? (
                                <>
                                    {(version?.startsWith('1') &&
                                        ['Ace'].includes(connectedDevice)) ||
                                    [
                                        'Roboki',
                                        'Atr',
                                        'Toki',
                                        'Moki',
                                        'Poki',
                                    ].includes(connectedDevice) ? (
                                        <>
                                            {this.state.isPcActive &&
                                            this.props.webSerial.isConnected ? (
                                                <div className="Read_button">
                                                    {this.handleInternalAccessories()}
                                                </div>
                                            ) : (
                                                <>
                                                    {this.state.isPcActive &&
                                                    !this.props.webSerial
                                                        .isConnected ? (
                                                        <>
                                                            {this.setState({
                                                                isPcActive: false,
                                                            })}
                                                        </>
                                                    ) : (
                                                        <div className="Read_button"></div>
                                                    )}
                                                </>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            {this.state.readbytes &&
                                            !isFourInOneSensor &&
                                            !isTempratureSensor ? (
                                                <div className="Read_button"></div>
                                            ) : !isFourInOneSensor &&
                                              !isTempratureSensor ? (
                                                <div className="Read_button"></div>
                                            ) : (
                                                <></>
                                            )}

                                            {/* /////////////////   isFourInOneSensor   //////////////// */}

                                            {isFourInOneSensor ? (
                                                this.state
                                                    .isClickFourInOneSensor ==
                                                false ? (
                                                    <div></div>
                                                ) : (
                                                    <div className="propertyPanel">
                                                        {JSON.parse(
                                                            sessionStorage.getItem(
                                                                'concept'
                                                            )
                                                        ).internalaccessories
                                                            .Four_in_one_sensor
                                                            .isColorSensor ? (
                                                            <div>
                                                                {JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'concept'
                                                                    )
                                                                )
                                                                    .internalaccessories
                                                                    .isTemperature ? (
                                                                    <div
                                                                        className="propertyPanel-Details-colorSensor"
                                                                        style={
                                                                            propertyPanelStyle
                                                                        }
                                                                    >
                                                                        <div className="colorSensor-container">
                                                                            <div>
                                                                                <img
                                                                                    src={renderPrgImage(
                                                                                        'colorsensorActive'
                                                                                    )}
                                                                                    style={{
                                                                                        height: '45px',
                                                                                        width: '45px',
                                                                                        marginTop:
                                                                                            '5px',
                                                                                    }}
                                                                                />
                                                                                <p
                                                                                    style={{
                                                                                        color: '#707070',
                                                                                        fontSize:
                                                                                            '12px',
                                                                                        marginTop:
                                                                                            '5px',
                                                                                        transform:
                                                                                            'translateX(20%)',
                                                                                    }}
                                                                                ></p>
                                                                            </div>
                                                                            <div>
                                                                                <p
                                                                                    style={{
                                                                                        color: '#F16178',
                                                                                    }}
                                                                                >
                                                                                    {' '}
                                                                                    R
                                                                                    :{' '}
                                                                                    {
                                                                                        this
                                                                                            .state
                                                                                            .red
                                                                                    }
                                                                                </p>
                                                                                <p
                                                                                    style={{
                                                                                        color: '#3BB273',
                                                                                    }}
                                                                                >
                                                                                    {' '}
                                                                                    G
                                                                                    :{' '}
                                                                                    {
                                                                                        this
                                                                                            .state
                                                                                            .green
                                                                                    }
                                                                                </p>
                                                                                <p
                                                                                    style={{
                                                                                        color: '#30A8CE',
                                                                                    }}
                                                                                >
                                                                                    {' '}
                                                                                    B
                                                                                    :{' '}
                                                                                    {
                                                                                        this
                                                                                            .state
                                                                                            .blue
                                                                                    }
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="colorSensor-container2">
                                                                            <img
                                                                                src={renderPrgImage(
                                                                                    'tempActive'
                                                                                )}
                                                                                style={{
                                                                                    height: '45px',
                                                                                    width: '45px',
                                                                                }}
                                                                            />

                                                                            <p>
                                                                                {
                                                                                    this
                                                                                        .state
                                                                                        .temprature
                                                                                }
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div
                                                                        className="propertyPanel-Details-colorSensor-Temp" ///////////visa
                                                                        // style={
                                                                        //     propertyPanelStyle
                                                                        // }
                                                                    >
                                                                        <div className="colorSensor-container">
                                                                            <div>
                                                                                <img
                                                                                    src={renderPrgImage(
                                                                                        'colorsensorActive'
                                                                                    )}
                                                                                    style={{
                                                                                        height: '45px',
                                                                                        width: '45px',
                                                                                        marginTop:
                                                                                            '5px',
                                                                                    }}
                                                                                />
                                                                                <p
                                                                                    style={{
                                                                                        color: '#707070',
                                                                                        fontSize:
                                                                                            '12px',
                                                                                        marginTop:
                                                                                            '5px',
                                                                                        transform:
                                                                                            'translateX(20%)',
                                                                                    }}
                                                                                ></p>
                                                                            </div>
                                                                            <div>
                                                                                <p
                                                                                    style={{
                                                                                        color: '#F16178',
                                                                                    }}
                                                                                >
                                                                                    {' '}
                                                                                    R
                                                                                    :{' '}
                                                                                    {
                                                                                        this
                                                                                            .state
                                                                                            .red
                                                                                    }
                                                                                </p>
                                                                                <p
                                                                                    style={{
                                                                                        color: '#3BB273',
                                                                                    }}
                                                                                >
                                                                                    {' '}
                                                                                    G
                                                                                    :{' '}
                                                                                    {
                                                                                        this
                                                                                            .state
                                                                                            .green
                                                                                    }
                                                                                </p>
                                                                                <p
                                                                                    style={{
                                                                                        color: '#30A8CE',
                                                                                    }}
                                                                                >
                                                                                    {' '}
                                                                                    B
                                                                                    :{' '}
                                                                                    {
                                                                                        this
                                                                                            .state
                                                                                            .blue
                                                                                    }
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <div>
                                                                {JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'concept'
                                                                    )
                                                                )
                                                                    .internalaccessories
                                                                    .isTemperature ==
                                                                true ? (
                                                                    <div
                                                                        className="propertyPanel-Details"
                                                                        style={
                                                                            propertyPanelStyle
                                                                        }
                                                                    >
                                                                        <div className="Item">
                                                                            <img
                                                                                src={this.renderImg()}
                                                                                style={{
                                                                                    height: '45px',
                                                                                    width: '45px',
                                                                                }}
                                                                            />

                                                                            <p>
                                                                                {JSON.parse(
                                                                                    sessionStorage.getItem(
                                                                                        'concept'
                                                                                    )
                                                                                )
                                                                                    .internalaccessories
                                                                                    .Four_in_one_sensor
                                                                                    .isLightSensor ? (
                                                                                    <>
                                                                                        {
                                                                                            this
                                                                                                .state
                                                                                                .light
                                                                                        }
                                                                                    </>
                                                                                ) : JSON.parse(
                                                                                      sessionStorage.getItem(
                                                                                          'concept'
                                                                                      )
                                                                                  )
                                                                                      .internalaccessories
                                                                                      .Four_in_one_sensor
                                                                                      .isDistanceSensors ? (
                                                                                    <>
                                                                                        {
                                                                                            this
                                                                                                .state
                                                                                                .distance
                                                                                        }
                                                                                    </>
                                                                                ) : JSON.parse(
                                                                                      sessionStorage.getItem(
                                                                                          'concept'
                                                                                      )
                                                                                  )
                                                                                      .internalaccessories
                                                                                      .Four_in_one_sensor
                                                                                      .isGestureSensor ? (
                                                                                    <>
                                                                                        {this
                                                                                            .state
                                                                                            .gesture ==
                                                                                        1 ? (
                                                                                            <p>
                                                                                                Down
                                                                                            </p>
                                                                                        ) : this
                                                                                              .state
                                                                                              .gesture ==
                                                                                          2 ? (
                                                                                            <p>
                                                                                                Up
                                                                                            </p>
                                                                                        ) : this
                                                                                              .state
                                                                                              .gesture ==
                                                                                          3 ? (
                                                                                            <p>
                                                                                                Right
                                                                                            </p>
                                                                                        ) : this
                                                                                              .state
                                                                                              .gesture ==
                                                                                          4 ? (
                                                                                            <p>
                                                                                                Left
                                                                                            </p>
                                                                                        ) : (
                                                                                            <p></p>
                                                                                        )}
                                                                                    </>
                                                                                ) : (
                                                                                    <>

                                                                                    </>
                                                                                )}
                                                                            </p>
                                                                        </div>

                                                                        <div className="Item2">
                                                                            <img
                                                                                src={renderPrgImage(
                                                                                    'tempActive'
                                                                                )}
                                                                                style={{
                                                                                    height: '45px',
                                                                                    width: '45px',
                                                                                }}
                                                                            />

                                                                            <p>
                                                                                {
                                                                                    this
                                                                                        .state
                                                                                        .temprature
                                                                                }{' '}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    // gesture laxmi
                                                                    <div
                                                                        className="propertyPanel-Details-FIO"
                                                                        style={
                                                                            propertyPanelStyle
                                                                        }
                                                                    >
                                                                        <div className="Item3">
                                                                            <img
                                                                                src={this.renderImg()}
                                                                                style={{
                                                                                    height: '45px',
                                                                                    width: '45px',
                                                                                }}
                                                                            />

                                                                            <p>
                                                                                {JSON.parse(
                                                                                    sessionStorage.getItem(
                                                                                        'concept'
                                                                                    )
                                                                                )
                                                                                    .internalaccessories
                                                                                    .Four_in_one_sensor
                                                                                    .isLightSensor ? (
                                                                                    <>
                                                                                        {
                                                                                            this
                                                                                                .state
                                                                                                .light
                                                                                        }
                                                                                    </>
                                                                                ) : JSON.parse(
                                                                                      sessionStorage.getItem(
                                                                                          'concept'
                                                                                      )
                                                                                  )
                                                                                      .internalaccessories
                                                                                      .Four_in_one_sensor
                                                                                      .isDistanceSensors ? (
                                                                                    <>
                                                                                        {
                                                                                            this
                                                                                                .state
                                                                                                .distance
                                                                                        }
                                                                                    </>
                                                                                ) : JSON.parse(
                                                                                      sessionStorage.getItem(
                                                                                          'concept'
                                                                                      )
                                                                                  )
                                                                                      .internalaccessories
                                                                                      .Four_in_one_sensor
                                                                                      .isGestureSensor ? (
                                                                                    <>
                                                                                        {this
                                                                                            .state
                                                                                            .gesture ==
                                                                                        1 ? (
                                                                                            <p>
                                                                                                Down
                                                                                            </p>
                                                                                        ) : this
                                                                                              .state
                                                                                              .gesture ==
                                                                                          2 ? (
                                                                                            <p>
                                                                                                Up
                                                                                            </p>
                                                                                        ) : this
                                                                                              .state
                                                                                              .gesture ==
                                                                                          3 ? (
                                                                                            <p>
                                                                                                Right
                                                                                            </p>
                                                                                        ) : this
                                                                                              .state
                                                                                              .gesture ==
                                                                                          4 ? (
                                                                                            <p>
                                                                                                Left
                                                                                            </p>
                                                                                        ) : (
                                                                                            <p></p>
                                                                                        )}
                                                                                    </>
                                                                                ) : (
                                                                                    <>

                                                                                    </>
                                                                                )}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}

                                                        <div className="propertyPanel-closeBtn"></div>
                                                    </div>
                                                )
                                            ) : null}

                                            {/* ///////////////// isTempratureSensor    //////////////// */}

                                            {isTempratureSensor ? (
                                                <div>
                                                    {' '}
                                                    {isFourInOneSensor ? null : this
                                                          .state
                                                          .isClickTempratureSensor ==
                                                      true ? (
                                                        <div>
                                                            <div className="propertyPanel">
                                                                <div
                                                                    style={{
                                                                        position:
                                                                            'absolute',
                                                                        top: '50%',
                                                                        right: '7%',
                                                                        transform:
                                                                            'translateY(-50%)',
                                                                        height: '100px',
                                                                        width: '65px',

                                                                        borderRadius:
                                                                            '46px',
                                                                        background:
                                                                            '#f4f4f4',
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            fontSize:
                                                                                '12px',
                                                                            color: '#707070',
                                                                            margin: '10px',
                                                                            textAlign:
                                                                                'center',
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={renderPrgImage(
                                                                                'tempActive'
                                                                            )}
                                                                            style={{
                                                                                height: '45px',
                                                                                width: '45px',
                                                                            }}
                                                                        />

                                                                        <p
                                                                            style={{
                                                                                marginTop:
                                                                                    '5px',
                                                                            }}
                                                                        >
                                                                            {
                                                                                this
                                                                                    .state
                                                                                    .temprature
                                                                            }{' '}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="propertyPanel-closeBtn">
                                                                <div className="Read_button"></div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="Read_button"></div>
                                                    )}
                                                </div>
                                            ) : null}
                                        </>
                                    )}{' '}
                                </>
                            ) : (
                                <></>
                            )}

                            {connectedDevice === 'Humanoid' && (
                                <>
                                    <div className="Read_button"></div>

                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '37vh',
                                            left: '83vw',
                                            width: '160px',
                                            // height: "300px",

                                            display: 'flex',
                                            flexDirection: 'column',

                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            gap: '0.5rem',
                                        }}
                                        // className="bg-primary"
                                    >
                                        {this.state.isReading &&
                                            this.props.webSerial
                                                .isConnected && (
                                                <>
                                                    {this.state
                                                        .humanoidPortData['23']
                                                        .isPortSelected ||
                                                    this.state.humanoidPortData[
                                                        '24'
                                                    ].isPortSelected ||
                                                    this.state.humanoidPortData[
                                                        '25'
                                                    ].isPortSelected ? (
                                                        <div
                                                            className="row"
                                                            style={{
                                                                width: '150px',
                                                            }}
                                                        >
                                                            <div
                                                                className="col-6"
                                                                style={{
                                                                    margin: 'auto',
                                                                }}
                                                            >
                                                                <img
                                                                    src={renderImage(
                                                                        'activeAccelerometerX'
                                                                    )}
                                                                    style={{
                                                                        width: '40px',
                                                                        height: '40px',
                                                                    }}
                                                                    alt=""
                                                                />
                                                            </div>

                                                            <div className="col-6">
                                                                {this.state
                                                                    .humanoidPortData[
                                                                    '23'
                                                                ]
                                                                    .isPortSelected ? (
                                                                    <p
                                                                        style={{
                                                                            margin: '0',
                                                                            padding:
                                                                                '0',
                                                                            fontSize:
                                                                                '0.8rem',
                                                                        }}
                                                                    >
                                                                        X :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .huAccelerometerX
                                                                        }
                                                                    </p>
                                                                ) : null}
                                                                {this.state
                                                                    .humanoidPortData[
                                                                    '24'
                                                                ]
                                                                    .isPortSelected ? (
                                                                    <p
                                                                        style={{
                                                                            margin: '0',
                                                                            padding:
                                                                                '0',
                                                                            fontSize:
                                                                                '0.8rem',
                                                                        }}
                                                                    >
                                                                        Y :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .huAccelerometerY
                                                                        }
                                                                    </p>
                                                                ) : null}
                                                                {this.state
                                                                    .humanoidPortData[
                                                                    '25'
                                                                ]
                                                                    .isPortSelected ? (
                                                                    <p
                                                                        style={{
                                                                            margin: '0',
                                                                            padding:
                                                                                '0',
                                                                            fontSize:
                                                                                '0.8rem',
                                                                        }}
                                                                    >
                                                                        Z :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .huAccelerometerZ
                                                                        }
                                                                    </p>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                    ) : null}

                                                    {this.state
                                                        .humanoidPortData['26']
                                                        .isPortSelected ||
                                                    this.state.humanoidPortData[
                                                        '27'
                                                    ].isPortSelected ||
                                                    this.state.humanoidPortData[
                                                        '28'
                                                    ].isPortSelected ? (
                                                        <div
                                                            className="row"
                                                            style={{
                                                                width: '150px',
                                                            }}
                                                        >
                                                            <div
                                                                className="col-6"
                                                                style={{
                                                                    margin: 'auto',
                                                                }}
                                                            >
                                                                <img
                                                                    src={renderImage(
                                                                        'activeGyroX'
                                                                    )}
                                                                    style={{
                                                                        width: '40px',
                                                                        height: '40px',
                                                                    }}
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                {this.state
                                                                    .humanoidPortData[
                                                                    '26'
                                                                ]
                                                                    .isPortSelected ? (
                                                                    <p
                                                                        style={{
                                                                            margin: '0',
                                                                            padding:
                                                                                '0',
                                                                            fontSize:
                                                                                '0.8rem',
                                                                        }}
                                                                    >
                                                                        X :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .huGyroX
                                                                        }
                                                                    </p>
                                                                ) : null}
                                                                {this.state
                                                                    .humanoidPortData[
                                                                    '27'
                                                                ]
                                                                    .isPortSelected ? (
                                                                    <p
                                                                        style={{
                                                                            margin: '0',
                                                                            padding:
                                                                                '0',
                                                                            fontSize:
                                                                                '0.8rem',
                                                                        }}
                                                                    >
                                                                        Y :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .huGyroY
                                                                        }
                                                                    </p>
                                                                ) : null}

                                                                {this.state
                                                                    .humanoidPortData[
                                                                    '28'
                                                                ]
                                                                    .isPortSelected ? (
                                                                    <p
                                                                        style={{
                                                                            margin: '0',
                                                                            padding:
                                                                                '0',
                                                                            fontSize:
                                                                                '0.8rem',
                                                                        }}
                                                                    >
                                                                        Z :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .huGyroZ
                                                                        }
                                                                    </p>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                    ) : null}

                                                    {this.state
                                                        .humanoidPortData['21']
                                                        .isPortSelected ? (
                                                        <div
                                                            className="row"
                                                            style={{
                                                                width: '150px',
                                                            }}
                                                        >
                                                            <div
                                                                className="col-6"
                                                                style={{
                                                                    marginLeft:
                                                                        '',
                                                                }}
                                                            >
                                                                <img
                                                                    src={renderImage(
                                                                        'activeBattery'
                                                                    )}
                                                                    style={{
                                                                        width: '40px',
                                                                        height: '40px',
                                                                        marginRight:
                                                                            '1rem',
                                                                    }}
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <p
                                                                    style={{
                                                                        margin: '0',
                                                                        padding:
                                                                            '0',
                                                                        fontSize:
                                                                            '0.8rem',

                                                                        margin: 'auto',
                                                                        height: '100%',

                                                                        paddingTop:
                                                                            '30%',
                                                                    }}
                                                                    className="text-center"
                                                                >
                                                                    {
                                                                        this
                                                                            .state
                                                                            .huBattery
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                    ) : null}

                                                    {this.state
                                                        .humanoidPortData['22']
                                                        .isPortSelected ? (
                                                        <div
                                                            className="row"
                                                            style={{
                                                                width: '150px',
                                                            }}
                                                        >
                                                            <div
                                                                className="col-6"
                                                                style={{
                                                                    marginLeft:
                                                                        '',
                                                                }}
                                                            >
                                                                <img
                                                                    src={renderImage(
                                                                        'activeUltrasonic'
                                                                    )}
                                                                    style={{
                                                                        width: '40px',
                                                                        height: '40px',
                                                                        marginRight:
                                                                            '1rem',
                                                                    }}
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <p
                                                                    style={{
                                                                        margin: '0',
                                                                        padding:
                                                                            '0',
                                                                        fontSize:
                                                                            '0.8rem',

                                                                        margin: 'auto',
                                                                        height: '100%',

                                                                        paddingTop:
                                                                            '30%',
                                                                    }}
                                                                    className="text-center"
                                                                >
                                                                    {
                                                                        this
                                                                            .state
                                                                            .huUltrasonic
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                    ) : null}

                                                    {/* --------------read servo ------------------- */}
                                                    {/* {this.state.humanoidPortData[
                                                    '4b'
                                                ].isPortSelected ? (
                                                    <div
                                                        className="row"
                                                        style={{
                                                            width: '150px',
                                                        }}
                                                    >
                                                        <div
                                                            className="col-6"
                                                            style={{
                                                                margin: 'auto',
                                                            }}
                                                        >
                                                            <img
                                                                src={renderImage(
                                                                    'activeIndividual'
                                                                )}
                                                                style={{
                                                                    width: '40px',
                                                                    height: '40px',
                                                                }}
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            {[
                                                                1, 2, 3, 4, 5,
                                                                6, 7, 8, 9, 10,
                                                                11, 12, 13, 14,
                                                                15, 16,
                                                            ].map((ind) => (
                                                                <p
                                                                    style={{
                                                                        margin: '0',
                                                                        padding:
                                                                            '0',
                                                                        fontSize:
                                                                            '0.8rem',
                                                                    }}
                                                                >
                                                                    {`S${ind}`}{' '}
                                                                    :{' '}
                                                                    {
                                                                        this
                                                                            .state[
                                                                            `huSred${ind}`
                                                                        ]
                                                                    }
                                                                </p>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ) : null} */}
                                                </>
                                            )}
                                    </div>
                                </>
                            )}

                            {connectedDevice === 'Hexapod' && (
                                <>
                                    <div className="Read_button"></div>
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '37vh',
                                            left: '83vw',
                                            width: '160px',
                                            // height: "300px",

                                            display: 'flex',
                                            flexDirection: 'column',

                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            gap: '0.5rem',
                                        }}
                                        // className="bg-primary"
                                    >
                                        {this.state.isReading &&
                                            this.props.webSerial
                                                .isConnected && (
                                                <>
                                                    {this.state
                                                        .humanoidPortData['25']
                                                        .isPortSelected ||
                                                    this.state.humanoidPortData[
                                                        '26'
                                                    ].isPortSelected ||
                                                    this.state.humanoidPortData[
                                                        '27'
                                                    ].isPortSelected ? (
                                                        <div
                                                            className="row"
                                                            style={{
                                                                width: '150px',
                                                            }}
                                                        >
                                                            <div
                                                                className="col-6"
                                                                style={{
                                                                    margin: 'auto',
                                                                }}
                                                            >
                                                                <img
                                                                    src={renderImage(
                                                                        'activeAccelerometerX'
                                                                    )}
                                                                    style={{
                                                                        width: '40px',
                                                                        height: '40px',
                                                                    }}
                                                                    alt=""
                                                                />
                                                            </div>

                                                            <div className="col-6">
                                                                {this.state
                                                                    .humanoidPortData[
                                                                    '25'
                                                                ]
                                                                    .isPortSelected ? (
                                                                    <p
                                                                        style={{
                                                                            whiteSpace:
                                                                                'nowrap',
                                                                            margin: '0',
                                                                            padding:
                                                                                '0',
                                                                            fontSize:
                                                                                '0.8rem',
                                                                        }}
                                                                    >
                                                                        X :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .huAccelerometerX
                                                                        }
                                                                    </p>
                                                                ) : null}
                                                                {this.state
                                                                    .humanoidPortData[
                                                                    '26'
                                                                ]
                                                                    .isPortSelected ? (
                                                                    <p
                                                                        style={{
                                                                            whiteSpace:
                                                                                'nowrap',
                                                                            margin: '0',
                                                                            padding:
                                                                                '0',
                                                                            fontSize:
                                                                                '0.8rem',
                                                                        }}
                                                                    >
                                                                        Y :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .huAccelerometerY
                                                                        }
                                                                    </p>
                                                                ) : null}
                                                                {this.state
                                                                    .humanoidPortData[
                                                                    '27'
                                                                ]
                                                                    .isPortSelected ? (
                                                                    <p
                                                                        style={{
                                                                            whiteSpace:
                                                                                'nowrap',
                                                                            margin: '0',
                                                                            padding:
                                                                                '0',
                                                                            fontSize:
                                                                                '0.8rem',
                                                                        }}
                                                                    >
                                                                        Z :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .huAccelerometerZ
                                                                        }
                                                                    </p>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                    ) : null}

                                                    {this.state
                                                        .humanoidPortData['28']
                                                        .isPortSelected ||
                                                    this.state.humanoidPortData[
                                                        '29'
                                                    ].isPortSelected ||
                                                    this.state.humanoidPortData[
                                                        '30'
                                                    ].isPortSelected ? (
                                                        <div
                                                            className="row"
                                                            style={{
                                                                width: '150px',
                                                            }}
                                                        >
                                                            <div
                                                                className="col-6"
                                                                style={{
                                                                    margin: 'auto',
                                                                }}
                                                            >
                                                                <img
                                                                    src={renderImage(
                                                                        'activeGyroX'
                                                                    )}
                                                                    style={{
                                                                        width: '40px',
                                                                        height: '40px',
                                                                    }}
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                {this.state
                                                                    .humanoidPortData[
                                                                    '28'
                                                                ]
                                                                    .isPortSelected ? (
                                                                    <p
                                                                        style={{
                                                                            whiteSpace:
                                                                                'nowrap',
                                                                            margin: '0',
                                                                            padding:
                                                                                '0',
                                                                            fontSize:
                                                                                '0.8rem',
                                                                        }}
                                                                    >
                                                                        X :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .huGyroX
                                                                        }
                                                                    </p>
                                                                ) : null}
                                                                {this.state
                                                                    .humanoidPortData[
                                                                    '29'
                                                                ]
                                                                    .isPortSelected ? (
                                                                    <p
                                                                        style={{
                                                                            whiteSpace:
                                                                                'nowrap',
                                                                            margin: '0',
                                                                            padding:
                                                                                '0',
                                                                            fontSize:
                                                                                '0.8rem',
                                                                        }}
                                                                    >
                                                                        Y :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .huGyroY
                                                                        }
                                                                    </p>
                                                                ) : null}

                                                                {this.state
                                                                    .humanoidPortData[
                                                                    '30'
                                                                ]
                                                                    .isPortSelected ? (
                                                                    <p
                                                                        style={{
                                                                            whiteSpace:
                                                                                'nowrap',
                                                                            margin: '0',
                                                                            padding:
                                                                                '0',
                                                                            fontSize:
                                                                                '0.8rem',
                                                                        }}
                                                                    >
                                                                        Z :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .huGyroZ
                                                                        }
                                                                    </p>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                    ) : null}

                                                    {this.state
                                                        .humanoidPortData['23']
                                                        .isPortSelected ? (
                                                        <div
                                                            className="row"
                                                            style={{
                                                                width: '150px',
                                                            }}
                                                        >
                                                            <div
                                                                className="col-6"
                                                                style={{
                                                                    marginLeft:
                                                                        '',
                                                                }}
                                                            >
                                                                <img
                                                                    src={renderImage(
                                                                        'activeBattery'
                                                                    )}
                                                                    style={{
                                                                        width: '40px',
                                                                        height: '40px',
                                                                        marginRight:
                                                                            '1rem',
                                                                    }}
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <p
                                                                    style={{
                                                                        whiteSpace:
                                                                            'nowrap',
                                                                        margin: '0',
                                                                        padding:
                                                                            '0',
                                                                        fontSize:
                                                                            '0.8rem',

                                                                        margin: 'auto',
                                                                        height: '100%',

                                                                        paddingTop:
                                                                            '30%',
                                                                        paddingRight:
                                                                            '35%',
                                                                    }}
                                                                    className="text-center"
                                                                >
                                                                    B:{'  '}
                                                                    {
                                                                        this
                                                                            .state
                                                                            .huBattery
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                    {this.state
                                                        .humanoidPortData['24']
                                                        .isPortSelected ? (
                                                        <div
                                                            className="row"
                                                            style={{
                                                                width: '150px',
                                                            }}
                                                        >
                                                            <div
                                                                className="col-6"
                                                                style={{
                                                                    marginLeft:
                                                                        '',
                                                                }}
                                                            >
                                                                <img
                                                                    src={renderImage(
                                                                        'activeUltrasonic'
                                                                    )}
                                                                    style={{
                                                                        width: '40px',
                                                                        height: '40px',
                                                                        marginRight:
                                                                            '1rem',
                                                                    }}
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <p
                                                                    style={{
                                                                        whiteSpace:
                                                                            'nowrap',
                                                                        margin: '0',
                                                                        padding:
                                                                            '0',
                                                                        fontSize:
                                                                            '0.8rem',

                                                                        margin: 'auto',
                                                                        height: '100%',

                                                                        paddingTop:
                                                                            '30%',
                                                                        paddingRight:
                                                                            '35%',
                                                                    }}
                                                                    className="text-center"
                                                                >
                                                                    U :{' '}
                                                                    {
                                                                        this
                                                                            .state
                                                                            .huUltrasonic
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                </>
                                            )}
                                    </div>
                                </>
                            )}
                            {connectedDevice === 'Klaw' && (
                                <>
                                    <div className="Read_button"></div>
                                    <div
                                        style={{
                                            position: 'absolute',
                                            // top: '37vh',
                                            top: '22vh',
                                            left: '82vw',
                                            width: '160px',
                                            height: '53vh',

                                            display: 'flex',
                                            flexDirection: 'column',

                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            gap: '0.5rem',
                                        }}
                                        // className="bg-primary"
                                    >
                                        {this.state.isReading &&
                                            this.props.webSerial
                                                .isConnected && (
                                                <>
                                                    {/*----------Swwitch 1-------------*/}
                                                    {this.state
                                                        .humanoidPortData['12']
                                                        .isPortSelected ? (
                                                        <div
                                                            className="row"
                                                            style={{
                                                                width: '200px',
                                                                alignItems:
                                                                    'center',
                                                            }}
                                                        >
                                                            <div
                                                                className="col-6"
                                                                style={{
                                                                    margin: 'auto',
                                                                }}
                                                            >
                                                                <img
                                                                    src={renderImage(
                                                                        'switch1Active'
                                                                    )}
                                                                    style={{
                                                                        width: '40px',
                                                                        height: '40px',
                                                                    }}
                                                                    alt=""
                                                                />
                                                            </div>

                                                            <div className="col-6">
                                                                <p
                                                                    style={{
                                                                        margin: '0',
                                                                        padding:
                                                                            '0',
                                                                        fontSize:
                                                                            '0.8rem',
                                                                    }}
                                                                >
                                                                    Switch1 :{' '}
                                                                    {
                                                                        this
                                                                            .state
                                                                            .switch1
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                    {/*----------Swwitch 2-------------*/}
                                                    {this.state
                                                        .humanoidPortData['13']
                                                        .isPortSelected ? (
                                                        <div
                                                            className="row"
                                                            style={{
                                                                width: '200px',
                                                                alignItems:
                                                                    'center',
                                                            }}
                                                        >
                                                            <div
                                                                className="col-6"
                                                                style={{
                                                                    margin: 'auto',
                                                                }}
                                                            >
                                                                <img
                                                                    src={renderImage(
                                                                        'switch2Active'
                                                                    )}
                                                                    style={{
                                                                        width: '40px',
                                                                        height: '40px',
                                                                    }}
                                                                    alt=""
                                                                />
                                                            </div>

                                                            <div className="col-6">
                                                                <p
                                                                    style={{
                                                                        margin: '0',
                                                                        padding:
                                                                            '0',
                                                                        fontSize:
                                                                            '0.8rem',
                                                                    }}
                                                                >
                                                                    Switch2 :{' '}
                                                                    {
                                                                        this
                                                                            .state
                                                                            .switch2
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                    {/*----------pot1-------------*/}
                                                    {this.state
                                                        .humanoidPortData['0']
                                                        .isPortSelected ? (
                                                        <div
                                                            className="row"
                                                            style={{
                                                                width: '200px',
                                                                alignItems:
                                                                    'center',
                                                            }}
                                                        >
                                                            <div
                                                                className="col-6"
                                                                style={{
                                                                    margin: 'auto',
                                                                }}
                                                            >
                                                                <img
                                                                    src={renderImage(
                                                                        'activePot1'
                                                                    )}
                                                                    style={{
                                                                        width: '40px',
                                                                        height: '40px',
                                                                    }}
                                                                    alt=""
                                                                />
                                                            </div>

                                                            <div className="col-6">
                                                                {/* joystick1 */}
                                                                {this.state
                                                                    .humanoidPortData[
                                                                    '0'
                                                                ]
                                                                    .isPortSelected ? (
                                                                    <>
                                                                        <p
                                                                            style={{
                                                                                margin: '0',
                                                                                padding:
                                                                                    '0',
                                                                                fontSize:
                                                                                    '0.8rem',
                                                                            }}
                                                                        >
                                                                            Pot1
                                                                            :{' '}
                                                                            {
                                                                                this
                                                                                    .state
                                                                                    .pot1
                                                                            }
                                                                        </p>
                                                                    </>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                    {/*----------pot2-------------*/}
                                                    {/* ////////////////////////// */}
                                                    {this.state
                                                        .humanoidPortData['1']
                                                        .isPortSelected ? (
                                                        <div
                                                            className="row"
                                                            style={{
                                                                width: '200px',
                                                                alignItems:
                                                                    'center',
                                                            }}
                                                        >
                                                            <div
                                                                className="col-6"
                                                                style={{
                                                                    margin: 'auto',
                                                                }}
                                                            >
                                                                <img
                                                                    src={renderImage(
                                                                        'activePot2'
                                                                    )}
                                                                    style={{
                                                                        width: '40px',
                                                                        height: '40px',
                                                                    }}
                                                                    alt=""
                                                                />
                                                            </div>

                                                            <div className="col-6">
                                                                {/* joystick2 */}
                                                                {this.state
                                                                    .humanoidPortData[
                                                                    '1'
                                                                ]
                                                                    .isPortSelected ? (
                                                                    <>
                                                                        <p
                                                                            style={{
                                                                                margin: '0',
                                                                                padding:
                                                                                    '0',
                                                                                fontSize:
                                                                                    '0.8rem',
                                                                            }}
                                                                        >
                                                                            Pot2
                                                                            :{' '}
                                                                            {
                                                                                this
                                                                                    .state
                                                                                    .pot2
                                                                            }
                                                                        </p>
                                                                    </>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                    ) : null}

                                                    {/*----------pot3-------------*/}
                                                    {/* ////////////////////////// */}
                                                    {this.state
                                                        .humanoidPortData['2']
                                                        .isPortSelected ? (
                                                        <div
                                                            className="row"
                                                            style={{
                                                                width: '200px',
                                                                alignItems:
                                                                    'center',
                                                            }}
                                                        >
                                                            <div
                                                                className="col-6"
                                                                style={{
                                                                    margin: 'auto',
                                                                }}
                                                            >
                                                                <img
                                                                    src={renderImage(
                                                                        'activePot3'
                                                                    )}
                                                                    style={{
                                                                        width: '40px',
                                                                        height: '40px',
                                                                    }}
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                {/* joystick3 */}
                                                                {this.state
                                                                    .humanoidPortData[
                                                                    '2'
                                                                ]
                                                                    .isPortSelected ? (
                                                                    <>
                                                                        <p
                                                                            style={{
                                                                                margin: '0',
                                                                                padding:
                                                                                    '0',
                                                                                fontSize:
                                                                                    '0.8rem',
                                                                            }}
                                                                        >
                                                                            Pot3
                                                                            :{' '}
                                                                            {
                                                                                this
                                                                                    .state
                                                                                    .pot3
                                                                            }
                                                                        </p>
                                                                    </>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                    ) : null}

                                                    {/*----------pot4-------------*/}
                                                    {this.state
                                                        .humanoidPortData['3']
                                                        .isPortSelected ? (
                                                        <div
                                                            className="row"
                                                            style={{
                                                                width: '200px',
                                                                alignItems:
                                                                    'center',
                                                            }}
                                                        >
                                                            <div
                                                                className="col-6"
                                                                style={{
                                                                    margin: 'auto',
                                                                }}
                                                            >
                                                                <img
                                                                    src={renderImage(
                                                                        'activePot4'
                                                                    )}
                                                                    style={{
                                                                        width: '40px',
                                                                        height: '40px',
                                                                    }}
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <>
                                                                    <p
                                                                        style={{
                                                                            margin: '0',
                                                                            padding:
                                                                                '0',
                                                                            fontSize:
                                                                                '0.8rem',
                                                                        }}
                                                                    >
                                                                        Pot4 :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .pot4
                                                                        }
                                                                    </p>
                                                                </>
                                                            </div>
                                                        </div>
                                                    ) : null}

                                                    {/*----------pot5-------------*/}
                                                    {this.state
                                                        .humanoidPortData['4']
                                                        .isPortSelected ? (
                                                        <div
                                                            className="row"
                                                            style={{
                                                                width: '200px',
                                                                alignItems:
                                                                    'center',
                                                            }}
                                                        >
                                                            <div
                                                                className="col-6"
                                                                style={{
                                                                    margin: 'auto',
                                                                }}
                                                            >
                                                                <img
                                                                    src={renderImage(
                                                                        'activePot5'
                                                                    )}
                                                                    style={{
                                                                        width: '40px',
                                                                        height: '40px',
                                                                    }}
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <>
                                                                    <p
                                                                        style={{
                                                                            margin: '0',
                                                                            padding:
                                                                                '0',
                                                                            fontSize:
                                                                                '0.8rem',
                                                                        }}
                                                                    >
                                                                        Pot5 :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .pot5
                                                                        }
                                                                    </p>
                                                                </>
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                    {/*----------pot6-------------*/}
                                                    {this.state
                                                        .humanoidPortData['5']
                                                        .isPortSelected ? (
                                                        <div
                                                            className="row"
                                                            style={{
                                                                width: '200px',
                                                                alignItems:
                                                                    'center',
                                                            }}
                                                        >
                                                            <div
                                                                className="col-6"
                                                                style={{
                                                                    margin: 'auto',
                                                                }}
                                                            >
                                                                <img
                                                                    src={renderImage(
                                                                        'activePot6'
                                                                    )}
                                                                    style={{
                                                                        width: '40px',
                                                                        height: '40px',
                                                                    }}
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="col-6">
                                                                <>
                                                                    <p
                                                                        style={{
                                                                            margin: '0',
                                                                            padding:
                                                                                '0',
                                                                            fontSize:
                                                                                '0.8rem',
                                                                        }}
                                                                    >
                                                                        Pot6 :{' '}
                                                                        {
                                                                            this
                                                                                .state
                                                                                .pot6
                                                                        }
                                                                    </p>
                                                                </>
                                                            </div>
                                                        </div>
                                                    ) : null}
                                                </>
                                            )}
                                    </div>
                                </>
                            )}
                            <div id="assemblyShot"></div>
                        </div>
                    </div>

                    {/* -------- button click popup message -------------- */}
                    {this.state.aiModelPopUpState.showPopup && (
                        <div className="aiModel_Selectpopup">
                            {this.state.aiModelPopUpState.message}
                        </div>
                    )}

                    {/* BOTTOM BACK,NEXT BTN and discription*/}
                    <div
                        className="SelectScreenBottom"
                        style={{
                            width: '80%',
                            marginLeft: '8%',
                            zIndex: '100',
                        }}
                    >
                        {this.state.showPopup ? (
                            <div className="snackbar">
                                "Read sensor" paramaters are supported only in
                                new Firmware. Please update the firmware -{' '}
                                <a
                                    target="_blank"
                                    href="https://firmware.plode.org/"
                                >
                                    Update Here
                                </a>
                            </div>
                        ) : (
                            <></>
                        )}
                        <div
                            className="bottom-child"
                            style={{ zIndex: '1000', position: 'relative' }}
                        >
                            {/* <div className="decription" style={{ left: '50%' }}>
                                <p style={{ display: 'none' }}>
                                    Drag and drop components to make
                                    connection{' '}
                                </p>
                            </div>
                            <button
                                type="button"
                                onClick={this.resetTutorial}
                                style={{
                                    position: 'absolute',
                                    right: '30%',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: this.state.tutorialDeviation
                                        ? 'linear-gradient(135deg, #ff6b35, #ff8c19)'
                                        : 'linear-gradient(135deg, #4ade80, #22c55e)',
                                    color: '#ffffff',
                                    border: 'none',
                                    borderRadius: '999px',
                                    padding: '10px 20px',
                                    fontSize: '0.9rem',
                                    fontWeight: 600,
                                    letterSpacing: '0.2px',
                                    cursor: 'pointer',
                                    boxShadow: this.state.tutorialDeviation
                                        ? '0 8px 18px rgba(255, 107, 53, 0.4)'
                                        : '0 8px 18px rgba(34, 197, 94, 0.3)',
                                    transition: 'all 0.3s ease',
                                }}
                            >
                                {this.state.tutorialDeviation
                                    ? '\u26a0 Reset Tutorial'
                                    : '\u2713 On Track'}
                            </button> */}
                            {/* <img
                            className="iconBtnSize imgNextBtn"
                            src={renderPrgImage('nextBtn')}
                            onMouseDown={() => {
                                this.setState({ readbytes: false })
                                this.setState({ isPcActive: false })
                            }}
                            onClick={this.check}
                            style={{ top: '50%' }}
                        /> */}
                        </div>
                    </div>
                </div>

                {!this.context?.setHeaderProps && (
                    <footer className="footer">
                        <div className="step-counter">
                            {isFinalSlide
                                ? 'Done'
                                : `Step ${activeSlideIndex + 1} of ${Math.max(totalSlides - 1, 1)}`}
                        </div>
                        <div className="step-title">{slideTitle}</div>
                        <div className="nav-buttons">
                            <button
                                className="nav-btn"
                                onClick={this.handleStepsPrev}
                                // disabled={activeSlideIndex === 0}
                            >
                                <GrPrevious />{' '}
                                <span className="footer-btn-text">
                                    Previous
                                </span>
                            </button>
                            <button
                                className="nav-btn"
                                onClick={this.handleStepsNext}
                            >
                                <span className="footer-btn-text">
                                    {activeSlideIndex === totalSlides - 1
                                        ? 'Continue'
                                        : 'Next'}
                                </span>
                                <GrNext />
                            </button>
                        </div>
                    </footer>
                )}
            </div>
        )
    }
}

// export default Assembly;

const mapStateToProps = (state) => {
    return state
}

//   return {
//     webserialPort: state.webSerial,
//   };
// };
const mapDispatchToProps = (dispatch) => {
    return {
        assemblyComponent: (data) => {
            dispatch({ type: 'ASSEMBLY_TWO_SELECTION', payload: data })
        },
        logicComponent: (data) => {
            dispatch({ type: 'LOGIC_SELECTION', payload: data })
        },
        PortConnections: (data) => {
            dispatch({ type: 'PORT_CONNECTION_TWO', payload: data })
        },
        webSerialConnect: (data) => {
            dispatch(webSerialConnect(data))
        },
        updateInternalAccessories: (data) => {
            console.log('changing Internal')
            dispatch({ type: 'INTERNAL_ACCESSORIES', payload: data })
        },
        setAssemblyPageAi: (data) => {
            dispatch({ type: 'ASSEMBLY_PAGE_AI_TWO', payload: data })
        },
        updateComponentProps: (data) => {
            dispatch({ type: 'COMPONENT_PROPS', payload: data })
        },
        updateComponentSelection: (data) => {
            dispatch({ type: 'COMPONENT_SELECTION', payload: data })
        },
    }
}

AssemblyTwo = withRouter(
    connect(mapStateToProps, mapDispatchToProps)(AssemblyTwo)
)
AssemblyTwo = withRouter(
    DragDropContext(
        sessionStorage.getItem('isTouchEnabled') == 'true'
            ? TouchBackend
            : HTML5Backend
    )(AssemblyTwo)
)
// Sidebar = DragSource('items', itemSource, collect)(Sidebar)

export default AssemblyTwo
// export default connect(mapStateToProp)(AssemblyNew);
